"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Server_UserApiKey_Client = exports.Server_SystemConfig_Client = exports.Server_BusinessGroupSubscription_Client = exports.Server_BusinessGroupQuantity_Client = exports.Server_BusinessGroupSoftSkills_Client = exports.Server_BusinessGroupRequest_Client = exports.Server_UserReferral_Client = exports.Server_Languages_Client = exports.Server_Feedback_Client = exports.Server_EventKeyMapping_Client = exports.Server_ContactUs_Client = exports.Server_BusinessGroupVoucher_Client = exports.Server_BusinessGroupUser_Client = exports.Server_BusinessGroupDepartments_Client = exports.Server_BusinessGroup_Client = exports.Server_Auth_Client = exports.Server_AppRates_Client = exports.Server_Sales_Client = exports.Server_UserSummaries_Client = exports.Server_TablePreferences_Client = exports.Server_SuggestContent_Client = exports.Server_Role_Client = exports.Server_RoleClaim_Client = exports.Server_ReportProblem_Client = exports.Server_PushNotifications_Client = exports.Server_Policies_Client = exports.Server_Points_Client = exports.Server_General_Client = exports.Server_Faqs_Client = exports.Server_Account_Client = exports.Server_Media_Client = exports.Server_PromoCodeAlias_Client = exports.Server_Vouchers_Client = exports.Server_TamatemPlus_Client = exports.Server_Tamara_Client = exports.Server_Subscriptions_Client = exports.Server_Stripe_Client = exports.Server_Moyasar_Client = exports.Server_Features_Client = exports.Server_Countries_Client = exports.Server_Campaign_Client = exports.Server_BehaviourEvent_Client = exports.Server_WebHooks_Client = exports.Server_Test_Client = exports.Server_PromoCode_Client = exports.Server_Products_Client = exports.Server_ProductGroup_Client = exports.Server_Plans_Client = exports.Server_Gifts_Client = exports.Server_Admin_Client = void 0;
exports.Server_BusinessGroupQueries_Client = exports.Server_BusinessGroupAnalytics_Client = exports.Server_Tracking_Client = exports.Server_ReportTextProblems_Client = exports.Server_Reels_Client = exports.Server_QuizTries_Client = exports.Server_Likings_Client = exports.Server_Flows_Client = exports.Server_ContentEntityStructures_Client = exports.Server_ContentEntityAudios_Client = exports.Server_Certificate_Client = exports.Server_Badges_Client = exports.Server_CollectionComponentTypes_Client = exports.Server_CollectionComponents_Client = exports.Server_ComponentTypes_Client = exports.Server_Components_Client = exports.Server_Downloads_Client = exports.Server_ContentEntityTypes_Client = exports.Server_ContentEntities_Client = exports.Server_WajeezRSSFeed_Client = exports.Server_UserContentUsageHistory_Client = exports.Server_Tests_Client = exports.Server_Sessions_Client = exports.Server_ReaderStatistics_Client = exports.Server_Rating_Client = exports.Server_Quote_Client = exports.Server_PublishersAnalysis_Client = exports.Server_Playlists_Client = exports.Server_PlaylistAllowedType_Client = exports.Server_Narrators_Client = exports.Server_LandingPage_Client = exports.Server_Interests_Client = exports.Server_Highlights_Client = exports.Server_Goals_Client = exports.Server_FullAudioTask_Client = exports.Server_Followings_Client = exports.Server_DynamicLinks_Client = exports.Server_DailyContent_Client = exports.Server_ContentSubscriptions_Client = exports.Server_ContentEntityTexts_Client = exports.Server_Collections_Client = exports.Server_Bookmarks_Client = exports.Server_Authors_Client = exports.Server_Allowings_Client = exports.Server_NotificationTemplates_Client = exports.Server_NotificationSubtype_Client = exports.Server_EmailTemplates_Client = exports.Server_Reciever_Client = exports.Server_NotificationTypes_Client = exports.Server_UtilityUser_Client = void 0;
exports.UtilityUserRole = exports.UserSummaryColumns = exports.SuggestContentColumns = exports.ReportProblemColumns = exports.PolicyType = exports.FaqColumns = exports.UserColumns = exports.EmailSubscriptionLevel = exports.LoginOption = exports.OperatingSystems = exports.PlayerMode = exports.Gender = exports.ImageFormats = exports.VoucherColumns = exports.RandomStringType = exports.PromoCodeAliasColumns = exports.ProductsColumns = exports.RedeemVoucherState = exports.SubscriptionContractCancellationState = exports.PromoCodeColumns = exports.SubscriptionCustomerProductType = exports.UpgradeType = exports.PurchaseSourceType = exports.OrderByDirection = exports.ComparisonType = exports.DataType = exports.ProductGroupColumns = exports.Platform = exports.ProductType = exports.PurchaseSource = exports.PurchaseType = exports.ReferralRewardType = exports.PlanPermission = exports.ResponseCode = exports.Server_WajeezQueries_Client = exports.Server_PaymentQueries_Client = exports.Server_IdentityQueries_Client = exports.Server_ContentQueries_Client = exports.Server_AppleReports_Client = exports.Server_DataWorkflow_Client = exports.Server_Tags_Client = exports.Server_Quizzes_Client = exports.Server_Questions_Client = exports.Server_Publishers_Client = exports.Server_FlowSelections_Client = exports.Server_ContentEntityTypeNavigations_Client = exports.Server_ContentEntityLists_Client = exports.Server_Answers_Client = exports.Server_Anghami_Client = exports.Server_Analytics_Client = void 0;
exports.FieldType = exports.ComponentsLookUpColumns = exports.ComponentUsageType = exports.ComponentFieldType = exports.LinkageType = exports.ValueToPick = exports.HandlingTypeSubType = exports.HandlingType = exports.ProgressUpdatePriority = exports.LockType = exports.ContentEntityTypeFieldType = exports.ContentEntityLookUpColumns = exports.NextItemSource = exports.SortingDirection = exports.SortingFactor = exports.SelectFactor = exports.ContentEntityUpdateReason = exports.EventType = exports.RatingOptionType = exports.PlayingMode = exports.NarratorColumns = exports.SortBy = exports.ContentItemType = exports.BookMarkType = exports.AuthorColumns = exports.EmailTemplateColumns = exports.FixedEmailTemplate = exports.SystemConfigColumns = exports.FeedbackColumns = exports.FeedbackOptionColumns = exports.EventKeyMappingsColumns = exports.ContactUsColumns = exports.BusinessGroupSubscriptionColumns = exports.BusinessGroupQuantityColumns = exports.BusinessGroupColumns = exports.AppRateColumns = exports.BusinessGroupVoucherColumns = exports.BusinessGroupUserColumns = exports.RegisterationMethod = exports.UserState = exports.BusinessGroupUserRole = exports.BusinessGroupRequestColumns = exports.RequestState = exports.FeedbackType = exports.EventProvider = exports.AppRateOptionType = exports.UtilityVouchersAnalysisColumns = exports.PaymentMethod = exports.UtilityUsersColumns = exports.UtilityUserState = void 0;
exports.ApiException = exports.XAppPlatform15 = exports.XAppPlatform14 = exports.XAppPlatform13 = exports.XAppPlatform12 = exports.XAppPlatform11 = exports.XAppPlatform10 = exports.XAppPlatform9 = exports.XAppPlatform8 = exports.XAppPlatform7 = exports.XAppPlatform6 = exports.XAppPlatform5 = exports.XAppPlatform4 = exports.XAppPlatform3 = exports.XAppPlatform2 = exports.XAppPlatform = exports.StripeSubscriptionStatus = exports.SubscriptionType = exports.SubscriptionDuration = exports.RetentionPeriod = exports.PlanType = exports.ContentType = exports.ReportTextProblemColumns = exports.ReportProblemState = exports.QuizColumns = exports.QuestionColumns = exports.PublisherColumns = exports.FlowSelectionColumns = exports.FlowColumns = exports.ContentEntityTypeColumns = exports.ContentEntityTypeNavigationColumns = exports.ContentEntityListColumns = exports.BadgeColumns = exports.AnswerColumns = exports.SkillStatusEnum = exports.SoftSkillType = exports.Period = exports.AfterCompleteQuizAction = exports.ContentEntityQuizAction = exports.FlowTabType = exports.TabResponsibility = exports.UserGrouping = exports.PaymentMethod2 = exports.SortBy2 = exports.CollectionComponentTypesLookUpColumns = exports.CollectionComponentLookUpColumns = exports.CollectionComponentUsageType = exports.ComponentTypeColumns = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var axios_1 = __importDefault(require("axios"));
var Server_Admin_Client = /** @class */ (function () {
    function Server_Admin_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 136.0) (Scope: Dashboard)
     */
    Server_Admin_Client.prototype.admin_Admin_invalidateCacheKeys_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/invalidate-cache-keys";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_invalidateCacheKeys_post_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_invalidateCacheKeys_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_Admin_Client.prototype.admin_Admin_dailyShuffle_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/daily-shuffle";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_dailyShuffle_get_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_dailyShuffle_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_Admin_Client.prototype.admin_Admin_updatePopularityIndex_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/update-popularity-index";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_updatePopularityIndex_get_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_updatePopularityIndex_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_Admin_Client.prototype.admin_Admin_weeklyShuffle_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/weekly-shuffle";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_weeklyShuffle_get_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_weeklyShuffle_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     * @param provider (optional)
     */
    Server_Admin_Client.prototype.admin_Admin_startIntegrationSyncWithProviders_post_V1 = function (provider, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/start-integration-sync-with-providers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(provider);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_startIntegrationSyncWithProviders_post_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_startIntegrationSyncWithProviders_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_Admin_Client.prototype.admin_Admin_addContentIntegrationSyncMetadata_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/add-content-integration-sync-metadata";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_addContentIntegrationSyncMetadata_post_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_addContentIntegrationSyncMetadata_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_Admin_Client.prototype.admin_Admin_cleanUpIntegrationSync_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/clean-up-integration-sync";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_cleanUpIntegrationSync_post_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_cleanUpIntegrationSync_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     * @param route (optional)
     * @param routingKey (optional)
     */
    Server_Admin_Client.prototype.admin_Admin_sendEvent_post_V1 = function (route, routingKey, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/send-event?";
        if (route !== undefined && route !== null)
            url_ += "route=" + encodeURIComponent("" + route) + "&";
        if (routingKey !== undefined && routingKey !== null)
            url_ += "routingKey=" + encodeURIComponent("" + routingKey) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_sendEvent_post_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_sendEvent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_Admin_Client.prototype.admin_Admin_updateSegment_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/update-segment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_updateSegment_post_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_updateSegment_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 136.3) (Scope: Dashboard)
     * @param listId (optional)
     * @param languageId (optional)
     */
    Server_Admin_Client.prototype.admin_Admin_getScormData_get_V1 = function (listId, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/get-scorm-data?";
        if (listId === null)
            throw new Error("The parameter 'listId' cannot be null.");
        else if (listId !== undefined)
            url_ += "ListId=" + encodeURIComponent("" + listId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_getScormData_get_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_getScormData_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 136.1) (Scope: Dashboard)
     * @param orderId (optional)
     */
    Server_Admin_Client.prototype.admin_Admin_lookupOrderId_get_V1 = function (orderId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/Admin/lookup-order-id?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Admin_lookupOrderId_get_V1(_response);
        });
    };
    Server_Admin_Client.prototype.processAdmin_Admin_lookupOrderId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Admin_Client;
}());
exports.Server_Admin_Client = Server_Admin_Client;
var Server_Gifts_Client = /** @class */ (function () {
    function Server_Gifts_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Gifts_Client.prototype.gifts_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Gifts_Client.prototype.gifts_received_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/received";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_received_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_received_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Gifts_Client.prototype.gifts_available_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/available";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_available_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_available_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Gifts_Client.prototype.gifts_consumed_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/consumed";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_consumed_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_consumed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Gifts_Client.prototype.gifts_consume_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/consume";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_consume_post_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_consume_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Gifts_Client.prototype.gifts_receive_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/receive";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_receive_post_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_receive_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param code (optional)
     */
    Server_Gifts_Client.prototype.gifts_checkToken_get_V1 = function (code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/check-token?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_checkToken_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_checkToken_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @deprecated
     */
    Server_Gifts_Client.prototype.gifts_checkPromotionalGift_get_V1 = function (x_app_version, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/check-promotional-gift";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_checkPromotionalGift_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_checkPromotionalGift_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     */
    Server_Gifts_Client.prototype.gifts_checkPromotionalGift_get_V2 = function (x_app_version, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v2/Gifts/check-promotional-gift";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_checkPromotionalGift_get_V2(_response);
        });
    };
    Server_Gifts_Client.prototype.processGifts_checkPromotionalGift_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 72.5) (Scope: Dashboard)
     * @param customerId (optional)
     */
    Server_Gifts_Client.prototype.admin_Gifts_bought_get_V1 = function (customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/bought?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Gifts_bought_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processAdmin_Gifts_bought_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 72.6) (Scope: Dashboard)
     * @param customerId (optional)
     */
    Server_Gifts_Client.prototype.admin_Gifts_consumed_get_V1 = function (customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/consumed?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Gifts_consumed_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processAdmin_Gifts_consumed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 72.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Gifts_Client.prototype.admin_Gifts_consume_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/consume";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Gifts_consume_post_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processAdmin_Gifts_consume_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 72.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Gifts_Client.prototype.admin_Gifts_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Gifts_post_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processAdmin_Gifts_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 72.9) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param giftId (optional)
     */
    Server_Gifts_Client.prototype.admin_Gifts_byId_get_V1 = function (x_app_language_id, giftId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/by-id?";
        if (giftId === null)
            throw new Error("The parameter 'giftId' cannot be null.");
        else if (giftId !== undefined)
            url_ += "GiftId=" + encodeURIComponent("" + giftId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Gifts_byId_get_V1(_response);
        });
    };
    Server_Gifts_Client.prototype.processAdmin_Gifts_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Gifts_Client;
}());
exports.Server_Gifts_Client = Server_Gifts_Client;
var Server_Plans_Client = /** @class */ (function () {
    function Server_Plans_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 2.1) (Scope: Dashboard)
     */
    Server_Plans_Client.prototype.plans_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_post_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.2) (Scope: Dashboard)
     */
    Server_Plans_Client.prototype.plans_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_put_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Plans_Client.prototype.plans_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_get_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Plans_Client.prototype.plans_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_delete_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.0) (Scope: Dashboard)
     * @param planId (optional)
     */
    Server_Plans_Client.prototype.plans_excludedTags_get_V1 = function (planId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/excluded-tags?";
        if (planId === null)
            throw new Error("The parameter 'planId' cannot be null.");
        else if (planId !== undefined)
            url_ += "PlanId=" + encodeURIComponent("" + planId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_excludedTags_get_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_excludedTags_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.2) (Scope: Dashboard)
     */
    Server_Plans_Client.prototype.plans_setExcludedTags_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/set-excluded-tags";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_setExcludedTags_put_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_setExcludedTags_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Plans_Client.prototype.plans_customer_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/customer";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_customer_get_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_customer_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Plans_Client.prototype.plans_customerQuota_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/customer-quota";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_customerQuota_get_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_customerQuota_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Plans_Client.prototype.plans_id_get_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_id_get_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.5) (Scope: Dashboard)
     */
    Server_Plans_Client.prototype.plans_setAsFree_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/set-as-free";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_setAsFree_post_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processPlans_setAsFree_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param customerId (optional)
     */
    Server_Plans_Client.prototype.admin_Plans_customer_get_V1 = function (x_app_language_id, customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Plans/customer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Plans_customer_get_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processAdmin_Plans_customer_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 2.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Plans_Client.prototype.admin_Plans_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Plans/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Plans_multilingualById_get_V1(_response);
        });
    };
    Server_Plans_Client.prototype.processAdmin_Plans_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Plans_Client;
}());
exports.Server_Plans_Client = Server_Plans_Client;
var Server_ProductGroup_Client = /** @class */ (function () {
    function Server_ProductGroup_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 62.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ProductGroup_Client.prototype.productGroup_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_post_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.12) (Scope: Dashboard)
     */
    Server_ProductGroup_Client.prototype.productGroup_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_put_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.2) (Scope: Dashboard)
     */
    Server_ProductGroup_Client.prototype.productGroup_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.2) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ProductGroup_Client.prototype.productGroup_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/by-id?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_byId_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.2) (Scope: Dashboard)
     * @param id (optional)
     * @param languageId (optional)
     * @param platform (optional)
     */
    Server_ProductGroup_Client.prototype.productGroup_byIdWithProducts_get_V1 = function (id, languageId, platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/by-id-with-products?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        if (platform !== undefined && platform !== null)
            url_ += "Platform=" + encodeURIComponent("" + platform) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_byIdWithProducts_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_byIdWithProducts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @param purchaseSource (optional)
     * @param purchaseSources (optional)
     */
    Server_ProductGroup_Client.prototype.productGroup_default_get_V1 = function (x_app_language_id, x_app_platform, purchaseSource, purchaseSources, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/default?";
        if (purchaseSource !== undefined && purchaseSource !== null)
            url_ += "PurchaseSource=" + encodeURIComponent("" + purchaseSource) + "&";
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_default_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_default_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     */
    Server_ProductGroup_Client.prototype.productGroup_gifts_get_V1 = function (x_app_language_id, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/gifts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_gifts_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_gifts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @param code (optional)
     * @param purchaseSource (optional)
     * @param purchaseSources (optional)
     */
    Server_ProductGroup_Client.prototype.productGroup_byPromoCode_get_V1 = function (x_app_language_id, x_app_platform, code, purchaseSource, purchaseSources, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/by-promo-code?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (purchaseSource !== undefined && purchaseSource !== null)
            url_ += "PurchaseSource=" + encodeURIComponent("" + purchaseSource) + "&";
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_byPromoCode_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_byPromoCode_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     */
    Server_ProductGroup_Client.prototype.productGroup_content_get_V1 = function (x_app_language_id, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/content";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_content_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_content_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.4) (Scope: Dashboard)
     */
    Server_ProductGroup_Client.prototype.productGroup_assignProduct_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/assign-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_assignProduct_post_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_assignProduct_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.5) (Scope: Dashboard)
     */
    Server_ProductGroup_Client.prototype.productGroup_unAssignProduct_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/un-assign-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_unAssignProduct_post_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_unAssignProduct_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.10) (Scope: Dashboard)
     */
    Server_ProductGroup_Client.prototype.productGroup_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_datatable_post_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.11) (Scope: Dashboard)
     * @param searchText (optional)
     */
    Server_ProductGroup_Client.prototype.productGroup_lookup_get_V1 = function (searchText, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/lookup?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_lookup_get_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_lookup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 62.13) (Scope: Dashboard)
     */
    Server_ProductGroup_Client.prototype.productGroup_setProducts_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/set-products";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_setProducts_post_V1(_response);
        });
    };
    Server_ProductGroup_Client.prototype.processProductGroup_setProducts_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ProductGroup_Client;
}());
exports.Server_ProductGroup_Client = Server_ProductGroup_Client;
var Server_Products_Client = /** @class */ (function () {
    function Server_Products_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 4.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Products_Client.prototype.products_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_post_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Products_Client.prototype.products_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_put_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Products_Client.prototype.products_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.1) (Scope: Dashboard)
     */
    Server_Products_Client.prototype.products_clone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/clone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_clone_post_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_clone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @param sKU (optional)
     */
    Server_Products_Client.prototype.products_bySku_get_V1 = function (x_app_language_id, x_app_platform, sKU, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/by-sku?";
        if (sKU !== undefined && sKU !== null)
            url_ += "SKU=" + encodeURIComponent("" + sKU) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_bySku_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_bySku_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @param sKUs (optional)
     */
    Server_Products_Client.prototype.products_bySkus_get_V1 = function (x_app_language_id, x_app_platform, sKUs, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/by-skus?";
        if (sKUs !== undefined && sKUs !== null)
            sKUs && sKUs.forEach(function (item) { url_ += "SKUs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_bySkus_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_bySkus_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.5) (Scope: Dashboard)
     * @param productGroupId (optional)
     */
    Server_Products_Client.prototype.products_getByGroup_get_V1 = function (productGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/get-by-group?";
        if (productGroupId === null)
            throw new Error("The parameter 'productGroupId' cannot be null.");
        else if (productGroupId !== undefined)
            url_ += "ProductGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_getByGroup_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_getByGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     */
    Server_Products_Client.prototype.products_getDefaultGroup_get_V1 = function (x_app_language_id, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/get-default-group";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_getDefaultGroup_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_getDefaultGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @param purchaseSource (optional)
     * @param purchaseSources (optional)
     */
    Server_Products_Client.prototype.products_public_get_V1 = function (x_app_language_id, x_app_platform, purchaseSource, purchaseSources, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/public?";
        if (purchaseSource !== undefined && purchaseSource !== null)
            url_ += "PurchaseSource=" + encodeURIComponent("" + purchaseSource) + "&";
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_public_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_public_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @param purchaseSource (optional)
     * @param purchaseSources (optional)
     * @param code (optional)
     */
    Server_Products_Client.prototype.products_getByPromoCode_get_V1 = function (x_app_language_id, x_app_platform, purchaseSource, purchaseSources, code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/get-by-promo-code?";
        if (purchaseSource !== undefined && purchaseSource !== null)
            url_ += "PurchaseSource=" + encodeURIComponent("" + purchaseSource) + "&";
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_getByPromoCode_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_getByPromoCode_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.9) (Scope: Dashboard)
     */
    Server_Products_Client.prototype.products_addCustomerProduct_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/add-customer-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_addCustomerProduct_post_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_addCustomerProduct_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.10) (Scope: Dashboard)
     */
    Server_Products_Client.prototype.products_expireCustomerProduct_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/expire-customer-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_expireCustomerProduct_post_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_expireCustomerProduct_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param productId (optional)
     */
    Server_Products_Client.prototype.products_byId_get_V1 = function (x_app_language_id, productId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/by-id?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_byId_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param purchaseProviderKey (optional)
     * @param offerId (optional)
     * @param applicationUsername (optional)
     */
    Server_Products_Client.prototype.products_appleOfferSignature_get_V1 = function (x_app_language_id, purchaseProviderKey, offerId, applicationUsername, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/apple-offer-signature?";
        if (purchaseProviderKey !== undefined && purchaseProviderKey !== null)
            url_ += "PurchaseProviderKey=" + encodeURIComponent("" + purchaseProviderKey) + "&";
        if (offerId !== undefined && offerId !== null)
            url_ += "OfferId=" + encodeURIComponent("" + offerId) + "&";
        if (applicationUsername !== undefined && applicationUsername !== null)
            url_ += "ApplicationUsername=" + encodeURIComponent("" + applicationUsername) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_appleOfferSignature_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_appleOfferSignature_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param input (optional)
     */
    Server_Products_Client.prototype.products_upgrade_get_V1 = function (x_app_language_id, input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/upgrade?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_upgrade_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_upgrade_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.18) (Scope: Dashboard)
     */
    Server_Products_Client.prototype.products_addCustomerProductSubscription_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/add-customer-product-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_addCustomerProductSubscription_post_V1(_response);
        });
    };
    Server_Products_Client.prototype.processProducts_addCustomerProductSubscription_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.0) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Products_Client.prototype.admin_Products_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_multilingualById_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param purchaseSource (optional)
     * @param productType (optional)
     */
    Server_Products_Client.prototype.admin_Products_customerCareProducts_get_V1 = function (x_app_language_id, purchaseSource, productType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/customer-care-products?";
        if (purchaseSource !== undefined && purchaseSource !== null)
            url_ += "PurchaseSource=" + encodeURIComponent("" + purchaseSource) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_customerCareProducts_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_customerCareProducts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.12) (Scope: Dashboard)
     * @param customerId (optional)
     */
    Server_Products_Client.prototype.admin_Products_subscriptionHistory_get_V1 = function (customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/subscription-history?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_subscriptionHistory_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_subscriptionHistory_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.13) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param source (optional)
     */
    Server_Products_Client.prototype.admin_Products_byPurchaseSource_get_V1 = function (x_app_language_id, source, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/by-purchase-source?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_byPurchaseSource_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_byPurchaseSource_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.16) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Products_Client.prototype.admin_Products_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_datatable_post_V1(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.17) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     */
    Server_Products_Client.prototype.admin_Products_lookup_get_V1 = function (x_app_language_id, searchText, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/lookup?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_lookup_get_V1(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_lookup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.1) (Scope: Dashboard)
     */
    Server_Products_Client.prototype.admin_Products_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v2/admin/Products";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_post_V2(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 4.2) (Scope: Dashboard)
     */
    Server_Products_Client.prototype.admin_Products_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v2/admin/Products";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Products_put_V2(_response);
        });
    };
    Server_Products_Client.prototype.processAdmin_Products_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Products_Client;
}());
exports.Server_Products_Client = Server_Products_Client;
var Server_PromoCode_Client = /** @class */ (function () {
    function Server_PromoCode_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 63.1) (Scope: Dashboard)
     * @param code (optional)
     * @param expiresOn (optional)
     */
    Server_PromoCode_Client.prototype.promoCode_post_V1 = function (code, expiresOn, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (code !== null && code !== undefined)
            content_.append("Code", code.toString());
        if (expiresOn !== null && expiresOn !== undefined)
            content_.append("ExpiresOn", expiresOn.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_post_V1(_response);
        });
    };
    Server_PromoCode_Client.prototype.processPromoCode_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 63.5) (Scope: Dashboard)
     */
    Server_PromoCode_Client.prototype.promoCode_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_put_V1(_response);
        });
    };
    Server_PromoCode_Client.prototype.processPromoCode_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 63.2) (Scope: Dashboard)
     */
    Server_PromoCode_Client.prototype.promoCode_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_get_V1(_response);
        });
    };
    Server_PromoCode_Client.prototype.processPromoCode_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 63.2) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_PromoCode_Client.prototype.promoCode_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_byId_get_V1(_response);
        });
    };
    Server_PromoCode_Client.prototype.processPromoCode_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 63.3) (Scope: Dashboard)
     */
    Server_PromoCode_Client.prototype.promoCode_assignProductGroup_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode/assign-product-group";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_assignProductGroup_post_V1(_response);
        });
    };
    Server_PromoCode_Client.prototype.processPromoCode_assignProductGroup_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 63.4) (Scope: Dashboard)
     */
    Server_PromoCode_Client.prototype.promoCode_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_datatable_post_V1(_response);
        });
    };
    Server_PromoCode_Client.prototype.processPromoCode_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_PromoCode_Client;
}());
exports.Server_PromoCode_Client = Server_PromoCode_Client;
var Server_Test_Client = /** @class */ (function () {
    function Server_Test_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    Server_Test_Client.prototype.test_log_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/log";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_log_post_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_log_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth)
     * @param batchSize (optional)
     * @param phoneNumber (optional)
     */
    Server_Test_Client.prototype.test_get_V1 = function (batchSize, phoneNumber, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test?";
        if (batchSize === null)
            throw new Error("The parameter 'batchSize' cannot be null.");
        else if (batchSize !== undefined)
            url_ += "batchSize=" + encodeURIComponent("" + batchSize) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param id (optional)
     */
    Server_Test_Client.prototype.test_setSignedPayloadNotificationId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/set-signedPayload-notificationId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_setSignedPayloadNotificationId_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_setSignedPayloadNotificationId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param id (optional)
     */
    Server_Test_Client.prototype.test_rehandleSignedPayload_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/rehandle-signedPayload?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_rehandleSignedPayload_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_rehandleSignedPayload_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     */
    Server_Test_Client.prototype.test_rehandleAppleCustomer_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/rehandle-apple-customer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_rehandleAppleCustomer_post_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_rehandleAppleCustomer_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param id (optional)
     */
    Server_Test_Client.prototype.test_rehandleStripe_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/rehandle-stripe?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_rehandleStripe_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_rehandleStripe_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param userId (optional)
     * @param originalTransactionId (optional)
     */
    Server_Test_Client.prototype.test_rehandleAppleCustomer2_get_V1 = function (userId, originalTransactionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/rehandle-apple-customer-2?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (originalTransactionId !== undefined && originalTransactionId !== null)
            url_ += "OriginalTransactionId=" + encodeURIComponent("" + originalTransactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_rehandleAppleCustomer2_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_rehandleAppleCustomer2_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param purchaseToken (optional)
     * @param orderId (optional)
     */
    Server_Test_Client.prototype.test_rehandleGoogleCustomer2_get_V1 = function (purchaseToken, orderId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/rehandle-google-customer-2?";
        if (purchaseToken !== undefined && purchaseToken !== null)
            url_ += "PurchaseToken=" + encodeURIComponent("" + purchaseToken) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_rehandleGoogleCustomer2_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_rehandleGoogleCustomer2_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param input (optional)
     */
    Server_Test_Client.prototype.test_ipLookupOutbound_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/ip-lookup-outbound?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_ipLookupOutbound_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_ipLookupOutbound_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     * @param file (optional)
     */
    Server_Test_Client.prototype.test_convertTo_post_V1 = function (file, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Test/convert-to";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_convertTo_post_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_convertTo_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     */
    Server_Test_Client.prototype.test_saveWebpFromUrl_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Test/save-webp-from-url";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_saveWebpFromUrl_post_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_saveWebpFromUrl_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     * @param fileId (optional)
     */
    Server_Test_Client.prototype.test_checkDuration_post_V1 = function (fileId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Test/check-duration?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_checkDuration_post_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_checkDuration_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Test_Client.prototype.test_deleteFromPublicBucket_post_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Test/delete-from-public-bucket?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_deleteFromPublicBucket_post_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_deleteFromPublicBucket_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Test_Client.prototype.test_teeeeeeeeeeeeeeeeeeeeeeeeeeeeeee_get_V1 = function (listId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Test/teeeeeeeeeeeeeeeeeeeeeeeeeeeeeee?";
        if (listId === null)
            throw new Error("The parameter 'listId' cannot be null.");
        else if (listId !== undefined)
            url_ += "listId=" + encodeURIComponent("" + listId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_teeeeeeeeeeeeeeeeeeeeeeeeeeeeeee_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_teeeeeeeeeeeeeeeeeeeeeeeeeeeeeee_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param id (optional)
     */
    Server_Test_Client.prototype.test_fixAuthProvider_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Test/fix-auth-provider?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_fixAuthProvider_get_V1(_response);
        });
    };
    Server_Test_Client.prototype.processTest_fixAuthProvider_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Test_Client;
}());
exports.Server_Test_Client = Server_Test_Client;
var Server_WebHooks_Client = /** @class */ (function () {
    function Server_WebHooks_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard)
     * @param api_version (optional)
     */
    Server_WebHooks_Client.prototype.purchase_apple_notify_post_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/purchase/apple/notify?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPurchase_apple_notify_post_V1(_response);
        });
    };
    Server_WebHooks_Client.prototype.processPurchase_apple_notify_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param api_version (optional)
     */
    Server_WebHooks_Client.prototype.api_payment_v2_purchase_apple_notify_post_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v2/purchase/apple/notify?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApi_payment_v2_purchase_apple_notify_post_V1(_response);
        });
    };
    Server_WebHooks_Client.prototype.processApi_payment_v2_purchase_apple_notify_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param api_version (optional)
     */
    Server_WebHooks_Client.prototype.notification_apple_post_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/notification/apple?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotification_apple_post_V1(_response);
        });
    };
    Server_WebHooks_Client.prototype.processNotification_apple_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param api_version (optional)
     */
    Server_WebHooks_Client.prototype.api_payment_purchase_google_notify_post_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/purchase/google/notify?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApi_payment_purchase_google_notify_post_V1(_response);
        });
    };
    Server_WebHooks_Client.prototype.processApi_payment_purchase_google_notify_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param api_version (optional)
     */
    Server_WebHooks_Client.prototype.api_payment_notification_google_post_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/notification/google?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApi_payment_notification_google_post_V1(_response);
        });
    };
    Server_WebHooks_Client.prototype.processApi_payment_notification_google_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_WebHooks_Client;
}());
exports.Server_WebHooks_Client = Server_WebHooks_Client;
var Server_BehaviourEvent_Client = /** @class */ (function () {
    function Server_BehaviourEvent_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_BehaviourEvent_Client.prototype.behaviourEvent_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/BehaviourEvent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBehaviourEvent_post_V1(_response);
        });
    };
    Server_BehaviourEvent_Client.prototype.processBehaviourEvent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BehaviourEvent_Client;
}());
exports.Server_BehaviourEvent_Client = Server_BehaviourEvent_Client;
var Server_Campaign_Client = /** @class */ (function () {
    function Server_Campaign_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Campaign_Client.prototype.campaign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Campaign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCampaign_post_V1(_response);
        });
    };
    Server_Campaign_Client.prototype.processCampaign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Campaign_Client;
}());
exports.Server_Campaign_Client = Server_Campaign_Client;
var Server_Countries_Client = /** @class */ (function () {
    function Server_Countries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 5.1) (Scope: Dashboard)
     */
    Server_Countries_Client.prototype.countries_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_post_V1(_response);
        });
    };
    Server_Countries_Client.prototype.processCountries_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 5.2) (Scope: Dashboard)
     */
    Server_Countries_Client.prototype.countries_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_put_V1(_response);
        });
    };
    Server_Countries_Client.prototype.processCountries_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 5.0) (Scope: Dashboard)
     */
    Server_Countries_Client.prototype.countries_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_get_V1(_response);
        });
    };
    Server_Countries_Client.prototype.processCountries_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 5.4) (Scope: Dashboard)
     * @param purchaseProviderKey (optional)
     * @param price (optional)
     */
    Server_Countries_Client.prototype.countries_byPriceAndProduct_get_V1 = function (purchaseProviderKey, price, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries/by-price-and-product?";
        if (purchaseProviderKey !== undefined && purchaseProviderKey !== null)
            url_ += "PurchaseProviderKey=" + encodeURIComponent("" + purchaseProviderKey) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "Price=" + encodeURIComponent("" + price) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_byPriceAndProduct_get_V1(_response);
        });
    };
    Server_Countries_Client.prototype.processCountries_byPriceAndProduct_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 5.5) (Scope: Dashboard)
     */
    Server_Countries_Client.prototype.countries_setExchangeRate_put_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries/set-exchange-rate";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_setExchangeRate_put_V1(_response);
        });
    };
    Server_Countries_Client.prototype.processCountries_setExchangeRate_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Countries_Client;
}());
exports.Server_Countries_Client = Server_Countries_Client;
var Server_Features_Client = /** @class */ (function () {
    function Server_Features_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @param planId (optional)
     */
    Server_Features_Client.prototype.features_byPlan_get_V1 = function (x_app_language_id, x_app_version, x_app_platform, planId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features/by-plan?";
        if (planId === null)
            throw new Error("The parameter 'planId' cannot be null.");
        else if (planId !== undefined)
            url_ += "PlanId=" + encodeURIComponent("" + planId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeatures_byPlan_get_V1(_response);
        });
    };
    Server_Features_Client.prototype.processFeatures_byPlan_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Features_Client.prototype.features_byFreePlan_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features/by-free-plan";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeatures_byFreePlan_get_V1(_response);
        });
    };
    Server_Features_Client.prototype.processFeatures_byFreePlan_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.1) (Scope: Dashboard)
     */
    Server_Features_Client.prototype.admin_Features_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_post_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.2) (Scope: Dashboard)
     */
    Server_Features_Client.prototype.admin_Features_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_put_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Features_Client.prototype.admin_Features_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_get_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Features_Client.prototype.admin_Features_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_delete_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Features_Client.prototype.admin_Features_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_multilingualById_get_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Features_Client.prototype.admin_Features_id_get_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_id_get_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.6) (Scope: Dashboard)
     */
    Server_Features_Client.prototype.admin_Features_assign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_assign_post_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_assign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 6.7) (Scope: Dashboard)
     */
    Server_Features_Client.prototype.admin_Features_unassign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Features/unassign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Features_unassign_post_V1(_response);
        });
    };
    Server_Features_Client.prototype.processAdmin_Features_unassign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Features_Client;
}());
exports.Server_Features_Client = Server_Features_Client;
var Server_Moyasar_Client = /** @class */ (function () {
    function Server_Moyasar_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: ThirdPartyService)
     * @param secret_token (optional)
     */
    Server_Moyasar_Client.prototype.moyasar_webhook_post_V1 = function (secret_token, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/webhook?";
        if (secret_token !== undefined && secret_token !== null)
            url_ += "secret_token=" + encodeURIComponent("" + secret_token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMoyasar_webhook_post_V1(_response);
        });
    };
    Server_Moyasar_Client.prototype.processMoyasar_webhook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Server_Moyasar_Client.prototype.moyasar_initiatePayment_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/initiate-payment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMoyasar_initiatePayment_post_V1(_response);
        });
    };
    Server_Moyasar_Client.prototype.processMoyasar_initiatePayment_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: ThirdPartyService)
     */
    Server_Moyasar_Client.prototype.moyasar_initiateMyPayment_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/initiate-my-payment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMoyasar_initiateMyPayment_post_V1(_response);
        });
    };
    Server_Moyasar_Client.prototype.processMoyasar_initiateMyPayment_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Server_Moyasar_Client.prototype.moyasar_getVoucher_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/get-voucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMoyasar_getVoucher_post_V1(_response);
        });
    };
    Server_Moyasar_Client.prototype.processMoyasar_getVoucher_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Moyasar_Client;
}());
exports.Server_Moyasar_Client = Server_Moyasar_Client;
var Server_Stripe_Client = /** @class */ (function () {
    function Server_Stripe_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     * @param redirectLink (optional)
     * @param lookupKey (optional)
     * @param email (optional)
     * @param clickId (optional)
     * @param promoCode (optional)
     */
    Server_Stripe_Client.prototype.stripe_createCheckoutSession_post_V1 = function (redirectLink, lookupKey, email, clickId, promoCode, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (redirectLink !== null && redirectLink !== undefined)
            content_.append("RedirectLink", redirectLink.toString());
        if (lookupKey !== null && lookupKey !== undefined)
            content_.append("LookupKey", lookupKey.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (clickId !== null && clickId !== undefined)
            content_.append("ClickId", clickId.toString());
        if (promoCode !== null && promoCode !== undefined)
            content_.append("PromoCode", promoCode.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_createCheckoutSession_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_createCheckoutSession_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Stripe_Client.prototype.stripe_createMyCheckoutSession_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-my-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_createMyCheckoutSession_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_createMyCheckoutSession_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Stripe_Client.prototype.stripe_createMyEmbeddedCheckout_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-my-embedded-checkout";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_createMyEmbeddedCheckout_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_createMyEmbeddedCheckout_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param checkoutSessionId (optional)
     */
    Server_Stripe_Client.prototype.stripe_checkoutSessionStatus_get_V1 = function (checkoutSessionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/checkout-session-status?";
        if (checkoutSessionId !== undefined && checkoutSessionId !== null)
            url_ += "CheckoutSessionId=" + encodeURIComponent("" + checkoutSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_checkoutSessionStatus_get_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_checkoutSessionStatus_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Stripe_Client.prototype.stripe_createPaymentIntent_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-payment-intent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_createPaymentIntent_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_createPaymentIntent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Stripe_Client.prototype.stripe_createMyPaymentIntent_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-my-payment-intent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_createMyPaymentIntent_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_createMyPaymentIntent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Stripe_Client.prototype.stripe_ensureStripeCustomerExists_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/ensure-stripe-customer-exists";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_ensureStripeCustomerExists_get_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_ensureStripeCustomerExists_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param checkoutSessionToken (optional)
     * @param stripeCustomerId (optional)
     */
    Server_Stripe_Client.prototype.stripe_getVoucherBySession_post_V1 = function (checkoutSessionToken, stripeCustomerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/get-voucher-by-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (checkoutSessionToken !== null && checkoutSessionToken !== undefined)
            content_.append("CheckoutSessionToken", checkoutSessionToken.toString());
        if (stripeCustomerId !== null && stripeCustomerId !== undefined)
            content_.append("StripeCustomerId", stripeCustomerId.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_getVoucherBySession_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_getVoucherBySession_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Stripe_Client.prototype.stripe_cancellation_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/cancellation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_cancellation_delete_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_cancellation_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Stripe_Client.prototype.stripe_webhook_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_webhook_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_webhook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1) (Scope: Mobile)
     * @param eventId (optional)
     */
    Server_Stripe_Client.prototype.stripe_rehandleWebhook_post_V1 = function (eventId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/rehandle-webhook?";
        if (eventId !== undefined && eventId !== null)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_rehandleWebhook_post_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processStripe_rehandleWebhook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 125.0)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_Stripe_Client.prototype.admin_Stripe_getGrossRevenue_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Stripe/get-gross-revenue?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Stripe_getGrossRevenue_get_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processAdmin_Stripe_getGrossRevenue_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 125.1)
     */
    Server_Stripe_Client.prototype.admin_Stripe_getCurrentBalance_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Stripe/get-current-balance";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Stripe_getCurrentBalance_get_V1(_response);
        });
    };
    Server_Stripe_Client.prototype.processAdmin_Stripe_getCurrentBalance_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Stripe_Client;
}());
exports.Server_Stripe_Client = Server_Stripe_Client;
var Server_Subscriptions_Client = /** @class */ (function () {
    function Server_Subscriptions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Subscriptions_Client.prototype.subscriptions_mySubscriptionHistory_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Subscriptions/my-subscription-history?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubscriptions_mySubscriptionHistory_get_V1(_response);
        });
    };
    Server_Subscriptions_Client.prototype.processSubscriptions_mySubscriptionHistory_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param customerProductIds (optional)
     */
    Server_Subscriptions_Client.prototype.subscriptions_getContracts_get_V1 = function (customerProductIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Subscriptions/get-contracts?";
        if (customerProductIds !== undefined && customerProductIds !== null)
            customerProductIds && customerProductIds.forEach(function (item) { url_ += "CustomerProductIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubscriptions_getContracts_get_V1(_response);
        });
    };
    Server_Subscriptions_Client.prototype.processSubscriptions_getContracts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Subscriptions_Client.prototype.subscriptions_cancelContract_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Subscriptions/cancel-contract";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubscriptions_cancelContract_post_V1(_response);
        });
    };
    Server_Subscriptions_Client.prototype.processSubscriptions_cancelContract_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Subscriptions_Client;
}());
exports.Server_Subscriptions_Client = Server_Subscriptions_Client;
var Server_Tamara_Client = /** @class */ (function () {
    function Server_Tamara_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     */
    Server_Tamara_Client.prototype.tamara_createCheckoutSession_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Tamara/create-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTamara_createCheckoutSession_post_V1(_response);
        });
    };
    Server_Tamara_Client.prototype.processTamara_createCheckoutSession_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Tamara_Client.prototype.tamara_createMyCheckoutSession_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Tamara/create-my-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTamara_createMyCheckoutSession_post_V1(_response);
        });
    };
    Server_Tamara_Client.prototype.processTamara_createMyCheckoutSession_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param tamaraToken (optional)
     */
    Server_Tamara_Client.prototype.tamara_webhook_post_V1 = function (tamaraToken, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Tamara/webhook?";
        if (tamaraToken !== undefined && tamaraToken !== null)
            url_ += "tamaraToken=" + encodeURIComponent("" + tamaraToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTamara_webhook_post_V1(_response);
        });
    };
    Server_Tamara_Client.prototype.processTamara_webhook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Tamara_Client;
}());
exports.Server_Tamara_Client = Server_Tamara_Client;
var Server_TamatemPlus_Client = /** @class */ (function () {
    function Server_TamatemPlus_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     */
    Server_TamatemPlus_Client.prototype.tamatemPlus_validate_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/TamatemPlus/validate";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTamatemPlus_validate_post_V1(_response);
        });
    };
    Server_TamatemPlus_Client.prototype.processTamatemPlus_validate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_TamatemPlus_Client.prototype.tamatemPlus_redeem_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/TamatemPlus/redeem";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTamatemPlus_redeem_post_V1(_response);
        });
    };
    Server_TamatemPlus_Client.prototype.processTamatemPlus_redeem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_TamatemPlus_Client;
}());
exports.Server_TamatemPlus_Client = Server_TamatemPlus_Client;
var Server_Vouchers_Client = /** @class */ (function () {
    function Server_Vouchers_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Vouchers_Client.prototype.vouchers_redeem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Vouchers/redeem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_redeem_post_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processVouchers_redeem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Vouchers_Client.prototype.vouchers_checkValidity_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Vouchers/check-validity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_checkValidity_post_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processVouchers_checkValidity_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.1) (Scope: Dashboard)
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_post_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.2) (Scope: Dashboard)
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_put_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.1) (Scope: Dashboard)
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_batch_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/batch";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_batch_post_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_batch_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.5) (Scope: Dashboard)
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_publish_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/publish";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_publish_put_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_publish_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.6) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_byId_get_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.7) (Scope: Dashboard)
     * @param code (optional)
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_byCode_get_V1 = function (code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/by-code?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_byCode_get_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_byCode_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_datatable_post_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 87.9) (Scope: Dashboard)
     */
    Server_Vouchers_Client.prototype.admin_Vouchers_addRenewalToConsumedVoucher_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/add-renewal-to-consumed-voucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Vouchers_addRenewalToConsumedVoucher_post_V1(_response);
        });
    };
    Server_Vouchers_Client.prototype.processAdmin_Vouchers_addRenewalToConsumedVoucher_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Vouchers_Client;
}());
exports.Server_Vouchers_Client = Server_Vouchers_Client;
var Server_PromoCodeAlias_Client = /** @class */ (function () {
    function Server_PromoCodeAlias_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 116.1) (Scope: Dashboard)
     */
    Server_PromoCodeAlias_Client.prototype.promoCodeAlias_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCodeAlias_post_V1(_response);
        });
    };
    Server_PromoCodeAlias_Client.prototype.processPromoCodeAlias_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 116.2) (Scope: Dashboard)
     */
    Server_PromoCodeAlias_Client.prototype.promoCodeAlias_publication_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias/publication";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCodeAlias_publication_put_V1(_response);
        });
    };
    Server_PromoCodeAlias_Client.prototype.processPromoCodeAlias_publication_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 116.3) (Scope: Dashboard)
     */
    Server_PromoCodeAlias_Client.prototype.promoCodeAlias_update_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCodeAlias_update_put_V1(_response);
        });
    };
    Server_PromoCodeAlias_Client.prototype.processPromoCodeAlias_update_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 116.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_PromoCodeAlias_Client.prototype.promoCodeAlias_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias/byId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCodeAlias_byId_get_V1(_response);
        });
    };
    Server_PromoCodeAlias_Client.prototype.processPromoCodeAlias_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 116.4) (Scope: Dashboard)
     * @param input (optional)
     */
    Server_PromoCodeAlias_Client.prototype.promoCodeAlias_lookups_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias/lookups?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCodeAlias_lookups_get_V1(_response);
        });
    };
    Server_PromoCodeAlias_Client.prototype.processPromoCodeAlias_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 116.4) (Scope: Dashboard)
     */
    Server_PromoCodeAlias_Client.prototype.promoCodeAlias_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCodeAlias_datatable_post_V1(_response);
        });
    };
    Server_PromoCodeAlias_Client.prototype.processPromoCodeAlias_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_PromoCodeAlias_Client;
}());
exports.Server_PromoCodeAlias_Client = Server_PromoCodeAlias_Client;
var Server_Media_Client = /** @class */ (function () {
    function Server_Media_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 32.0) (Scope: Dashboard; Mobile)
     */
    Server_Media_Client.prototype.media_download_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_download_id_get_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_download_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.0) (Scope: Dashboard; Mobile)
     */
    Server_Media_Client.prototype.media_downloadOriginal_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/download-original/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_downloadOriginal_id_get_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_downloadOriginal_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     */
    Server_Media_Client.prototype.media_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_id_get_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     */
    Server_Media_Client.prototype.media_id_head_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_id_head_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_id_head_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.0) (Scope: Dashboard; Mobile)
     */
    Server_Media_Client.prototype.media_signed_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/signed/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_signed_id_get_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_signed_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.0) (Scope: Dashboard)
     * @param ids (optional)
     */
    Server_Media_Client.prototype.media_info_get_V1 = function (ids, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/info?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(function (item) { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_info_get_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_info_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard; Mobile)
     */
    Server_Media_Client.prototype.media_public_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/public/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_public_id_get_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_public_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard; Mobile)
     */
    Server_Media_Client.prototype.media_download_public_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/download/public/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_download_public_id_get_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_download_public_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.1) (Scope: Dashboard)
     * @param contentItemType (optional)
     * @param fieldName (optional)
     * @param file (optional)
     */
    Server_Media_Client.prototype.media_post_V1 = function (contentItemType, fieldName, file, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (contentItemType !== null && contentItemType !== undefined)
            content_.append("ContentItemType", contentItemType.toString());
        if (fieldName !== null && fieldName !== undefined)
            content_.append("FieldName", fieldName.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.1) (Scope: Dashboard)
     */
    Server_Media_Client.prototype.media_uploadUrl_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/upload-url";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_uploadUrl_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_uploadUrl_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.3) (Scope: Dashboard)
     */
    Server_Media_Client.prototype.media_checkUploaded_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/check-uploaded";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_checkUploaded_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_checkUploaded_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.3) (Scope: Dashboard)
     * @param file (optional)
     */
    Server_Media_Client.prototype.media_media_post_V1 = function (file, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/media";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_media_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_media_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.3) (Scope: Dashboard)
     * @param file (optional)
     */
    Server_Media_Client.prototype.media_media_public_post_V1 = function (file, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/media/public";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_media_public_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_media_public_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.3) (Scope: Dashboard)
     */
    Server_Media_Client.prototype.media_mediaUrl_post_V1 = function (audioUrl, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/media-url";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(audioUrl);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_mediaUrl_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_mediaUrl_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.3) (Scope: Dashboard)
     * @param userId (optional)
     */
    Server_Media_Client.prototype.media_recalculateDuration_post_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/recalculate-duration?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_recalculateDuration_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_recalculateDuration_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.4) (Scope: Dashboard)
     * @param file (optional)
     */
    Server_Media_Client.prototype.media_summary_post_V1 = function (file, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/summary";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_summary_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_summary_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.2) (Scope: Dashboard)
     * @param file (optional)
     */
    Server_Media_Client.prototype.media_icon_post_V1 = function (file, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/icon";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_icon_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_icon_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 32.5) (Scope: Dashboard)
     */
    Server_Media_Client.prototype.media_optimizeImage_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/optimize-image";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_optimizeImage_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_optimizeImage_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     */
    Server_Media_Client.prototype.media_hlsConvert_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/media/v1/Media/hls-convert";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMedia_hlsConvert_post_V1(_response);
        });
    };
    Server_Media_Client.prototype.processMedia_hlsConvert_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Media_Client;
}());
exports.Server_Media_Client = Server_Media_Client;
var Server_Account_Client = /** @class */ (function () {
    function Server_Account_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_register_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_register_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_register_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.31) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_syncGoogleWorkspace_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/sync-google-workspace";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_syncGoogleWorkspace_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_syncGoogleWorkspace_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_checkLoginOption_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/check-login-option";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_checkLoginOption_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_checkLoginOption_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param email (optional)
     */
    Server_Account_Client.prototype.account_checkEmail_get_V1 = function (email, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/check-email?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_checkEmail_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_checkEmail_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param email (optional)
     */
    Server_Account_Client.prototype.account_checkEmailExistence_get_V1 = function (email, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/check-email-existence?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_checkEmailExistence_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_checkEmailExistence_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param phoneNumber (optional)
     */
    Server_Account_Client.prototype.account_checkPhoneNumber_get_V1 = function (phoneNumber, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/check-phone-number?";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_checkPhoneNumber_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_checkPhoneNumber_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_changeEmail_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/change-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_changeEmail_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_changeEmail_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_changePassword_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/change-password";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_changePassword_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_changePassword_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_updateName_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/update-name";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_updateName_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_updateName_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_updateFcmToken_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/update-fcm-token";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_updateFcmToken_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_updateFcmToken_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_updateEmailSubscription_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/update-email-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_updateEmailSubscription_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_updateEmailSubscription_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_updateGender_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/update-gender";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_updateGender_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_updateGender_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.9) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_createAdmin_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/create-admin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_createAdmin_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_createAdmin_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.9) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Account_Client.prototype.account_getToken_post_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get-token?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_getToken_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_getToken_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.9) (Scope: Dashboard)
     * @param id (optional)
     * @param minutes (optional)
     */
    Server_Account_Client.prototype.account_getTokenByMinutes_post_V1 = function (id, minutes, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get-token-by-minutes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (minutes === null)
            throw new Error("The parameter 'minutes' cannot be null.");
        else if (minutes !== undefined)
            url_ += "minutes=" + encodeURIComponent("" + minutes) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_getTokenByMinutes_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_getTokenByMinutes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.0) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_get_post_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_get_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_get_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.28) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_getTeam_post_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get-team";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_getTeam_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_getTeam_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.10) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_userId_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_userId_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_userId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.4) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_userId_delete_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_userId_delete_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_userId_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_softDelete_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/soft-delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_softDelete_delete_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_softDelete_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_requestDelete_delete_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/request-delete";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_requestDelete_delete_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_requestDelete_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.7) (Scope: Dashboard)
     * @param userId (optional)
     */
    Server_Account_Client.prototype.account_block_post_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/block?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_block_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_block_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.8) (Scope: Dashboard)
     * @param userId (optional)
     */
    Server_Account_Client.prototype.account_unblock_post_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/unblock?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_unblock_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_unblock_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_authenticate_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_b2b_authenticate_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/b2b/authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_b2b_authenticate_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_b2b_authenticate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile; Dashboard)
     * @deprecated
     */
    Server_Account_Client.prototype.account_token_refresh_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/token/refresh";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_token_refresh_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_token_refresh_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_token_revoke_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/token/revoke";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_token_revoke_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_token_revoke_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_b2b_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/b2b";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_b2b_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_b2b_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_google_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/google";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_google_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_google_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_google_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/google";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_google_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_google_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_guest_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/guest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_guest_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_guest_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_facebook_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/facebook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_facebook_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_facebook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_facebook_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/facebook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_facebook_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_facebook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_delete_facebook_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/delete/facebook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_delete_facebook_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_delete_facebook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_legacy_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/legacy";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_legacy_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_legacy_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_huawei_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/huawei";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_huawei_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_huawei_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_huawei_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/huawei";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_huawei_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_huawei_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @deprecated
     */
    Server_Account_Client.prototype.account_authenticate_twitter_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_twitter_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_twitter_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_twitter_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_twitter_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_twitter_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_twitterBrowserLink_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/twitter-browser-link";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_twitterBrowserLink_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_twitterBrowserLink_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_apple_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/apple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_apple_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_apple_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_apple_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/apple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_apple_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_apple_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authProviders_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/auth-providers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authProviders_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authProviders_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_passwordReset_request_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/password-reset/request";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_passwordReset_request_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_passwordReset_request_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_passwordReset_verify_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/password-reset/verify";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_passwordReset_verify_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_passwordReset_verify_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_passwordReset_reset_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/password-reset/reset";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_passwordReset_reset_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_passwordReset_reset_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_requestEmailVerification_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/request-email-verification";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_requestEmailVerification_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_requestEmailVerification_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_emailValidation_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/email-validation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_emailValidation_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_emailValidation_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.13) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_roles_updateUser_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/roles/update-user";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_roles_updateUser_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_roles_updateUser_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.12) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_roles_getUser_userId_post_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/roles/get-user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_roles_getUser_userId_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_roles_getUser_userId_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.15) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_setPassword_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-password";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_setPassword_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_setPassword_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_setPasswordByToken_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-password-by-token";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_setPasswordByToken_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_setPasswordByToken_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.17) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.account_setEmail_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_setEmail_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_setEmail_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_setMyEmailPassword_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-my-email-password";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_setMyEmailPassword_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_setMyEmailPassword_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     */
    Server_Account_Client.prototype.account_register_toBusinessGroup_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/register/to-business-group";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_register_toBusinessGroup_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_register_toBusinessGroup_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @deprecated
     */
    Server_Account_Client.prototype.account_addMyDeviceDetails_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/add-my-device-details";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_addMyDeviceDetails_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_addMyDeviceDetails_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_phoneNumber_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/phone-number";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_phoneNumber_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_phoneNumber_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_phoneNumber_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/phone-number";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_phoneNumber_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_phoneNumber_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_requestWhatsappOtp_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/request-whatsapp-otp";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_requestWhatsappOtp_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_requestWhatsappOtp_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_whatsapp_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/whatsapp";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_whatsapp_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_whatsapp_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_whatsapp_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/whatsapp";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_whatsapp_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_whatsapp_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_replace_whatsapp_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/replace/whatsapp";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_replace_whatsapp_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_replace_whatsapp_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_replace_phoneNumber_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/replace/phone-number";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_replace_phoneNumber_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_replace_phoneNumber_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param phoneNumber (optional)
     */
    Server_Account_Client.prototype.account_checkLegacyPhoneNumber_get_V1 = function (phoneNumber, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/check-legacy-phone-number?";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_checkLegacyPhoneNumber_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_checkLegacyPhoneNumber_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_apple_loginCallback_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/apple/login-callback";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_apple_loginCallback_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_apple_loginCallback_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Account_Client.prototype.account_loginApple_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/login-apple";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_loginApple_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_loginApple_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth)
     */
    Server_Account_Client.prototype.account_onboardingQuestionnaire_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/onboarding-questionnaire";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_onboardingQuestionnaire_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_onboardingQuestionnaire_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.10) (Scope: Dashboard)
     * @param userId (optional)
     */
    Server_Account_Client.prototype.account_userFcmToken_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/user-fcm-token?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_userFcmToken_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_userFcmToken_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_token_refresh_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/Account/token/refresh";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_token_refresh_post_V2(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_token_refresh_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_google_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/Account/authenticate/google";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_google_post_V2(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_google_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_google_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/Account/link/google";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_google_post_V2(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_google_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_authenticate_twitter_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/Account/authenticate/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_authenticate_twitter_post_V2(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_authenticate_twitter_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_link_twitter_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/Account/link/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_link_twitter_post_V2(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_link_twitter_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     */
    Server_Account_Client.prototype.account_getMyInfo_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get-my-info";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_getMyInfo_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_getMyInfo_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_b2bOnboardingComplteted_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/b2b-onboarding-complteted";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_b2bOnboardingComplteted_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_b2bOnboardingComplteted_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_onboardingComplteted_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/onboarding-complteted";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_onboardingComplteted_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_onboardingComplteted_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_autoplay_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/autoplay";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_autoplay_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_autoplay_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_preferredPlayerMode_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/preferred-player-mode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_preferredPlayerMode_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_preferredPlayerMode_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_nextTitle_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/next-title";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_nextTitle_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_nextTitle_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_addCampaign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/add-campaign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_addCampaign_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_addCampaign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.9) (Scope: Mobile)
     */
    Server_Account_Client.prototype.account_setEmailVerificationState_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-email-verification-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_setEmailVerificationState_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_setEmailVerificationState_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @deprecated
     */
    Server_Account_Client.prototype.account_addDeviceInfo_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/add-device-info";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_addDeviceInfo_post_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAccount_addDeviceInfo_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.22) (Scope: Dashboard)
     * @param email (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Account_Client.prototype.admin_Account_searchByEmail_get_V1 = function (email, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Account/search-by-email?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Account_searchByEmail_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAdmin_Account_searchByEmail_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.22) (Scope: Dashboard)
     * @param searchKey (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Account_Client.prototype.admin_Account_searchUsersByFilter_get_V1 = function (searchKey, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Account/search-users-by-filter?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Account_searchUsersByFilter_get_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAdmin_Account_searchUsersByFilter_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.23) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.admin_Account_updateName_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Account/update-name";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Account_updateName_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAdmin_Account_updateName_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 18.24) (Scope: Dashboard)
     */
    Server_Account_Client.prototype.admin_Account_updateGender_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Account/update-gender";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Account_updateGender_put_V1(_response);
        });
    };
    Server_Account_Client.prototype.processAdmin_Account_updateGender_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Account_Client;
}());
exports.Server_Account_Client = Server_Account_Client;
var Server_Faqs_Client = /** @class */ (function () {
    function Server_Faqs_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 79.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Faqs_Client.prototype.faqs_categories_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_categories_post_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_categories_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 79.3) (Scope: Dashboard)
     * @deprecated
     */
    Server_Faqs_Client.prototype.faqs_categories_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_categories_put_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_categories_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Faqs_Client.prototype.faqs_categories_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_categories_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_categories_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 79.4) (Scope: Dashboard)
     */
    Server_Faqs_Client.prototype.faqs_categories_Id_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_categories_Id_delete_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_categories_Id_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 79.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Faqs_Client.prototype.faqs_categories_id_get_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_categories_id_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_categories_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 79.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Faqs_Client.prototype.faqs_categories_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_categories_paginated_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_categories_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Faqs_Client.prototype.faqs_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_post_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.3) (Scope: Dashboard)
     * @deprecated
     */
    Server_Faqs_Client.prototype.faqs_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_put_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Faqs_Client.prototype.faqs_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.4) (Scope: Dashboard)
     */
    Server_Faqs_Client.prototype.faqs_Id_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_Id_delete_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_Id_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Faqs_Client.prototype.faqs_categories_faqs_get_V1 = function (x_app_language_id, id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/faqs?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_categories_faqs_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_categories_faqs_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Faqs_Client.prototype.faqs_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_datatable_post_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Faqs_Client.prototype.faqs_helpful_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/helpful";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_helpful_post_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_helpful_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Faqs_Client.prototype.faqs_search_post_V1 = function (x_app_language_id, searchText, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_search_post_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_search_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_Faqs_Client.prototype.faqs_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_byId_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processFaqs_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 79.1) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Faqs_Client.prototype.admin_Faqs_categories_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Faqs/categories/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Faqs_categories_multilingualById_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processAdmin_Faqs_categories_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.8) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Faqs_Client.prototype.admin_Faqs_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Faqs/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Faqs_multilingualById_get_V1(_response);
        });
    };
    Server_Faqs_Client.prototype.processAdmin_Faqs_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 79.2) (Scope: Dashboard)
     */
    Server_Faqs_Client.prototype.admin_Faqs_categories_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Faqs_categories_post_V2(_response);
        });
    };
    Server_Faqs_Client.prototype.processAdmin_Faqs_categories_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 79.3) (Scope: Dashboard)
     */
    Server_Faqs_Client.prototype.admin_Faqs_categories_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Faqs_categories_put_V2(_response);
        });
    };
    Server_Faqs_Client.prototype.processAdmin_Faqs_categories_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.1) (Scope: Dashboard)
     */
    Server_Faqs_Client.prototype.admin_Faqs_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Faqs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Faqs_post_V2(_response);
        });
    };
    Server_Faqs_Client.prototype.processAdmin_Faqs_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 78.3) (Scope: Dashboard)
     */
    Server_Faqs_Client.prototype.admin_Faqs_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Faqs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Faqs_put_V2(_response);
        });
    };
    Server_Faqs_Client.prototype.processAdmin_Faqs_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Faqs_Client;
}());
exports.Server_Faqs_Client = Server_Faqs_Client;
var Server_General_Client = /** @class */ (function () {
    function Server_General_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    Server_General_Client.prototype.general_getUserCountryCode_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/General/get-user-country-code";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGeneral_getUserCountryCode_get_V1(_response);
        });
    };
    Server_General_Client.prototype.processGeneral_getUserCountryCode_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_General_Client.prototype.general_getUserCountryCodeResponse_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/General/get-user-country-code-response";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGeneral_getUserCountryCodeResponse_get_V1(_response);
        });
    };
    Server_General_Client.prototype.processGeneral_getUserCountryCodeResponse_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_General_Client;
}());
exports.Server_General_Client = Server_General_Client;
var Server_Points_Client = /** @class */ (function () {
    function Server_Points_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Points_Client.prototype.points_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Points";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPoints_get_V1(_response);
        });
    };
    Server_Points_Client.prototype.processPoints_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 74.2) (Scope: Dashboard)
     * @param userId (optional)
     */
    Server_Points_Client.prototype.admin_Points_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Points?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Points_get_V1(_response);
        });
    };
    Server_Points_Client.prototype.processAdmin_Points_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 74.1) (Scope: Dashboard)
     */
    Server_Points_Client.prototype.admin_Points_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Points";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Points_post_V1(_response);
        });
    };
    Server_Points_Client.prototype.processAdmin_Points_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Points_Client;
}());
exports.Server_Points_Client = Server_Points_Client;
var Server_Policies_Client = /** @class */ (function () {
    function Server_Policies_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 47.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Policies_Client.prototype.policies_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_post_V1(_response);
        });
    };
    Server_Policies_Client.prototype.processPolicies_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 47.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Policies_Client.prototype.policies_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_put_V1(_response);
        });
    };
    Server_Policies_Client.prototype.processPolicies_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 47.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Policies_Client.prototype.policies_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_get_V1(_response);
        });
    };
    Server_Policies_Client.prototype.processPolicies_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 47.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Policies_Client.prototype.policies_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_delete_V1(_response);
        });
    };
    Server_Policies_Client.prototype.processPolicies_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 47.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Policies_Client.prototype.policies_id_get_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_id_get_V1(_response);
        });
    };
    Server_Policies_Client.prototype.processPolicies_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param type (optional)
     */
    Server_Policies_Client.prototype.policies_byType_get_V1 = function (x_app_language_id, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies/by-type?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_byType_get_V1(_response);
        });
    };
    Server_Policies_Client.prototype.processPolicies_byType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 47.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Policies_Client.prototype.admin_Policies_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Policies/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Policies_multilingualById_get_V1(_response);
        });
    };
    Server_Policies_Client.prototype.processAdmin_Policies_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 47.1) (Scope: Dashboard)
     */
    Server_Policies_Client.prototype.admin_Policies_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Policies_post_V2(_response);
        });
    };
    Server_Policies_Client.prototype.processAdmin_Policies_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 47.2) (Scope: Dashboard)
     */
    Server_Policies_Client.prototype.admin_Policies_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Policies_put_V2(_response);
        });
    };
    Server_Policies_Client.prototype.processAdmin_Policies_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Policies_Client;
}());
exports.Server_Policies_Client = Server_Policies_Client;
var Server_PushNotifications_Client = /** @class */ (function () {
    function Server_PushNotifications_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 136.1) (Scope: Dashboard)
     */
    Server_PushNotifications_Client.prototype.admin_PushNotifications_sendToUsers_post_V1 = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/PushNotifications/send-to-users";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PushNotifications_sendToUsers_post_V1(_response);
        });
    };
    Server_PushNotifications_Client.prototype.processAdmin_PushNotifications_sendToUsers_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 136.1) (Scope: Dashboard)
     */
    Server_PushNotifications_Client.prototype.admin_PushNotifications_sendContentToUsers_post_V1 = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/PushNotifications/send-content-to-users";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PushNotifications_sendContentToUsers_post_V1(_response);
        });
    };
    Server_PushNotifications_Client.prototype.processAdmin_PushNotifications_sendContentToUsers_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 136.1) (Scope: Dashboard)
     */
    Server_PushNotifications_Client.prototype.admin_PushNotifications_sendSilentToUsers_post_V1 = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/management/v1/admin/PushNotifications/send-silent-to-users";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PushNotifications_sendSilentToUsers_post_V1(_response);
        });
    };
    Server_PushNotifications_Client.prototype.processAdmin_PushNotifications_sendSilentToUsers_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_PushNotifications_Client;
}());
exports.Server_PushNotifications_Client = Server_PushNotifications_Client;
var Server_ReportProblem_Client = /** @class */ (function () {
    function Server_ReportProblem_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.reportProblem_reportProblem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem/report-problem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_reportProblem_post_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_reportProblem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.reportProblem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_post_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.3) (Scope: Dashboard)
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.reportProblem_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_put_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.4) (Scope: Dashboard)
     * @param id (optional)
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.reportProblem_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_delete_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.reportProblem_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_get_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.reportProblem_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_paginated_get_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.reportProblem_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_datatable_post_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_ReportProblem_Client.prototype.reportProblem_reportProblem_post_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReportProblem/report-problem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_reportProblem_post_V12(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_reportProblem_post_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ReportProblem_Client.prototype.reportProblem_options_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_options_get_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processReportProblem_options_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_options_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_options_post_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_options_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.3) (Scope: Dashboard)
     * @deprecated
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_options_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_options_put_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_options_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_options_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_options_delete_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_options_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_options_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_options_paginated_get_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_options_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_datatable_post_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_byId_get_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.7) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_options_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_options_multilingualById_get_V1(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_options_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.2) (Scope: Dashboard)
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_options_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_options_post_V2(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_options_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 75.3) (Scope: Dashboard)
     */
    Server_ReportProblem_Client.prototype.admin_ReportProblem_options_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportProblem_options_put_V2(_response);
        });
    };
    Server_ReportProblem_Client.prototype.processAdmin_ReportProblem_options_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ReportProblem_Client;
}());
exports.Server_ReportProblem_Client = Server_ReportProblem_Client;
var Server_RoleClaim_Client = /** @class */ (function () {
    function Server_RoleClaim_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 20.0) (Scope: Dashboard)
     */
    Server_RoleClaim_Client.prototype.roleClaim_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_get_V1(_response);
        });
    };
    Server_RoleClaim_Client.prototype.processRoleClaim_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 20.1) (Scope: Dashboard)
     */
    Server_RoleClaim_Client.prototype.roleClaim_post_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_post_V1(_response);
        });
    };
    Server_RoleClaim_Client.prototype.processRoleClaim_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 20.5) (Scope: Dashboard)
     * @param group (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_RoleClaim_Client.prototype.roleClaim_permissions_get_V1 = function (group, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/permissions?";
        if (group !== undefined && group !== null)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_permissions_get_V1(_response);
        });
    };
    Server_RoleClaim_Client.prototype.processRoleClaim_permissions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 20.6) (Scope: Dashboard)
     * @param roleId (optional)
     * @param group (optional)
     */
    Server_RoleClaim_Client.prototype.roleClaim_permissions_byRole_get_V1 = function (roleId, group, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/permissions/by-role?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (group !== undefined && group !== null)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_permissions_byRole_get_V1(_response);
        });
    };
    Server_RoleClaim_Client.prototype.processRoleClaim_permissions_byRole_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 20.7) (Scope: Dashboard)
     */
    Server_RoleClaim_Client.prototype.roleClaim_groups_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/groups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_groups_get_V1(_response);
        });
    };
    Server_RoleClaim_Client.prototype.processRoleClaim_groups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 20.0) (Scope: Dashboard)
     */
    Server_RoleClaim_Client.prototype.roleClaim_getByRole_roleId_get_V1 = function (roleId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/get-by-role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_getByRole_roleId_get_V1(_response);
        });
    };
    Server_RoleClaim_Client.prototype.processRoleClaim_getByRole_roleId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 20.3) (Scope: Dashboard)
     */
    Server_RoleClaim_Client.prototype.roleClaim_id_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_id_delete_V1(_response);
        });
    };
    Server_RoleClaim_Client.prototype.processRoleClaim_id_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_RoleClaim_Client;
}());
exports.Server_RoleClaim_Client = Server_RoleClaim_Client;
var Server_Role_Client = /** @class */ (function () {
    function Server_Role_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 19.0) (Scope: Dashboard)
     */
    Server_Role_Client.prototype.role_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRole_get_V1(_response);
        });
    };
    Server_Role_Client.prototype.processRole_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1) (Scope: Dashboard)
     */
    Server_Role_Client.prototype.role_post_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRole_post_V1(_response);
        });
    };
    Server_Role_Client.prototype.processRole_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.3) (Scope: Dashboard)
     */
    Server_Role_Client.prototype.role_id_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRole_id_delete_V1(_response);
        });
    };
    Server_Role_Client.prototype.processRole_id_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 21.0) (Scope: Dashboard)
     */
    Server_Role_Client.prototype.role_permissions_roleId_get_V1 = function (roleId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role/permissions/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRole_permissions_roleId_get_V1(_response);
        });
    };
    Server_Role_Client.prototype.processRole_permissions_roleId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 21.1) (Scope: Dashboard)
     */
    Server_Role_Client.prototype.role_permissions_update_put_V1 = function (model, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role/permissions/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRole_permissions_update_put_V1(_response);
        });
    };
    Server_Role_Client.prototype.processRole_permissions_update_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Role_Client;
}());
exports.Server_Role_Client = Server_Role_Client;
var Server_SuggestContent_Client = /** @class */ (function () {
    function Server_SuggestContent_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_SuggestContent_Client.prototype.suggestContent_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/SuggestContent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSuggestContent_post_V1(_response);
        });
    };
    Server_SuggestContent_Client.prototype.processSuggestContent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 80.0) (Scope: Dashboard)
     */
    Server_SuggestContent_Client.prototype.suggestContent_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/SuggestContent/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSuggestContent_datatable_post_V1(_response);
        });
    };
    Server_SuggestContent_Client.prototype.processSuggestContent_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_SuggestContent_Client;
}());
exports.Server_SuggestContent_Client = Server_SuggestContent_Client;
var Server_TablePreferences_Client = /** @class */ (function () {
    function Server_TablePreferences_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_TablePreferences_Client.prototype.tablePreferences_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_get_V1(_response);
        });
    };
    Server_TablePreferences_Client.prototype.processTablePreferences_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_TablePreferences_Client.prototype.tablePreferences_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_post_V1(_response);
        });
    };
    Server_TablePreferences_Client.prototype.processTablePreferences_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_TablePreferences_Client.prototype.tablePreferences_delete_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_delete_V1(_response);
        });
    };
    Server_TablePreferences_Client.prototype.processTablePreferences_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param tableName (optional)
     */
    Server_TablePreferences_Client.prototype.tablePreferences_byTableName_get_V1 = function (tableName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/by-table-name?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_byTableName_get_V1(_response);
        });
    };
    Server_TablePreferences_Client.prototype.processTablePreferences_byTableName_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param tableName (optional)
     */
    Server_TablePreferences_Client.prototype.tablePreferences_byTableName_delete_V1 = function (tableName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/by-table-name?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_byTableName_delete_V1(_response);
        });
    };
    Server_TablePreferences_Client.prototype.processTablePreferences_byTableName_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_TablePreferences_Client.prototype.tablePreferences_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_id_get_V1(_response);
        });
    };
    Server_TablePreferences_Client.prototype.processTablePreferences_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_TablePreferences_Client.prototype.tablePreferences_id_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_id_delete_V1(_response);
        });
    };
    Server_TablePreferences_Client.prototype.processTablePreferences_id_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_TablePreferences_Client;
}());
exports.Server_TablePreferences_Client = Server_TablePreferences_Client;
var Server_UserSummaries_Client = /** @class */ (function () {
    function Server_UserSummaries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_UserSummaries_Client.prototype.userSummaries_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/UserSummaries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserSummaries_post_V1(_response);
        });
    };
    Server_UserSummaries_Client.prototype.processUserSummaries_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 81.0) (Scope: Dashboard)
     */
    Server_UserSummaries_Client.prototype.userSummaries_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/UserSummaries/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserSummaries_datatable_post_V1(_response);
        });
    };
    Server_UserSummaries_Client.prototype.processUserSummaries_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_UserSummaries_Client;
}());
exports.Server_UserSummaries_Client = Server_UserSummaries_Client;
var Server_Sales_Client = /** @class */ (function () {
    function Server_Sales_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 139.7) (Scope: Dashboard)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_users_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/users";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_users_post_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_users_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.8) (Scope: Dashboard)
     * @param id (optional)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_users_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/users?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_users_get_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_users_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.13) (Scope: Dashboard)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_users_updateActivation_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/users/update-activation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_users_updateActivation_put_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_users_updateActivation_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.8) (Scope: Dashboard)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_users_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/users/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_users_datatable_post_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_users_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_promocode_assign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/promocode/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_promocode_assign_post_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_promocode_assign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.11) (Scope: Dashboard)
     * @param voucherId (optional)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_checkState_get_V1 = function (voucherId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/check-state?";
        if (voucherId === null)
            throw new Error("The parameter 'voucherId' cannot be null.");
        else if (voucherId !== undefined)
            url_ += "VoucherId=" + encodeURIComponent("" + voucherId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_checkState_get_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_checkState_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.12) (Scope: Dashboard)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_updatePaymentMethod_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/update-payment-method";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_updatePaymentMethod_put_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_updatePaymentMethod_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.6) (Scope: Dashboard)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_voucher_generate_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/voucher/generate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_voucher_generate_post_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_voucher_generate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.5) (Scope: Dashboard; Web)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_voucher_get_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/voucher/get";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_voucher_get_post_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_voucher_get_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.10) (Scope: Dashboard; Web)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_vouchers_analysis_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/vouchers/analysis";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_vouchers_analysis_post_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_vouchers_analysis_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.11) (Scope: Dashboard; Web)
     * @param input (optional)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_promocode_analysis_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/promocode/analysis?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_promocode_analysis_get_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_promocode_analysis_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.9) (Scope: Dashboard; Web)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_sales_analysis_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/sales/analysis";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_sales_analysis_post_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_sales_analysis_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.8) (Scope: Dashboard)
     * @param input (optional)
     * @deprecated
     */
    Server_Sales_Client.prototype.admin_Sales_users_lookups_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Sales/users/lookups?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Sales_users_lookups_get_V1(_response);
        });
    };
    Server_Sales_Client.prototype.processAdmin_Sales_users_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Sales_Client;
}());
exports.Server_Sales_Client = Server_Sales_Client;
var Server_AppRates_Client = /** @class */ (function () {
    function Server_AppRates_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_AppRates_Client.prototype.appRates_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAppRates_post_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAppRates_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_AppRates_Client.prototype.appRates_options_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates/options";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAppRates_options_get_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAppRates_options_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 85.1) (Scope: Dashboard)
     */
    Server_AppRates_Client.prototype.admin_AppRates_options_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/AppRates/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_AppRates_options_post_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAdmin_AppRates_options_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 85.2) (Scope: Dashboard)
     */
    Server_AppRates_Client.prototype.admin_AppRates_options_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/AppRates/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_AppRates_options_put_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAdmin_AppRates_options_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 85.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_AppRates_Client.prototype.admin_AppRates_options_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/AppRates/options?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_AppRates_options_delete_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAdmin_AppRates_options_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 85.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_AppRates_Client.prototype.admin_AppRates_options_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/AppRates/options/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_AppRates_options_paginated_get_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAdmin_AppRates_options_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 85.5) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_AppRates_Client.prototype.admin_AppRates_options_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/AppRates/options/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_AppRates_options_multilingualById_get_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAdmin_AppRates_options_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 85.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_AppRates_Client.prototype.admin_AppRates_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/AppRates/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_AppRates_datatable_post_V1(_response);
        });
    };
    Server_AppRates_Client.prototype.processAdmin_AppRates_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_AppRates_Client;
}());
exports.Server_AppRates_Client = Server_AppRates_Client;
var Server_Auth_Client = /** @class */ (function () {
    function Server_Auth_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    Server_Auth_Client.prototype.auth_Hikma_Login__V1 = function (returnUrl, aiccSid, aicc_url, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/Hikma/Login?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (aiccSid !== undefined && aiccSid !== null)
            url_ += "AICC_SID=" + encodeURIComponent("" + aiccSid) + "&";
        if (aicc_url !== undefined && aicc_url !== null)
            url_ += "AICC_URL=" + encodeURIComponent("" + aicc_url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_Hikma_Login__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_Hikma_Login__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_Hikma_AssertionConsumerService__V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/Hikma/AssertionConsumerService";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_Hikma_AssertionConsumerService__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_Hikma_AssertionConsumerService__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth)
     * @param aiccSid (optional)
     * @param aicc_url (optional)
     */
    Server_Auth_Client.prototype.auth_Hikma_SetStudentId__V1 = function (aiccSid, aicc_url, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/Hikma/SetStudentId?";
        if (aiccSid !== undefined && aiccSid !== null)
            url_ += "AICC_SID=" + encodeURIComponent("" + aiccSid) + "&";
        if (aicc_url !== undefined && aicc_url !== null)
            url_ += "AICC_URL=" + encodeURIComponent("" + aicc_url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_Hikma_SetStudentId__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_Hikma_SetStudentId__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_Hikma_spMetadata_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/Hikma/sp-metadata";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_Hikma_spMetadata_get_V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_Hikma_spMetadata_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_PIF_Login__V1 = function (returnUrl, aiccSid, aicc_url, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/PIF/Login?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (aiccSid !== undefined && aiccSid !== null)
            url_ += "AICC_SID=" + encodeURIComponent("" + aiccSid) + "&";
        if (aicc_url !== undefined && aicc_url !== null)
            url_ += "AICC_URL=" + encodeURIComponent("" + aicc_url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_PIF_Login__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_PIF_Login__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_PIF_AssertionConsumerService__V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/PIF/AssertionConsumerService";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_PIF_AssertionConsumerService__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_PIF_AssertionConsumerService__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth)
     * @param aiccSid (optional)
     * @param aicc_url (optional)
     */
    Server_Auth_Client.prototype.auth_PIF_SetStudentId__V1 = function (aiccSid, aicc_url, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/PIF/SetStudentId?";
        if (aiccSid !== undefined && aiccSid !== null)
            url_ += "AICC_SID=" + encodeURIComponent("" + aiccSid) + "&";
        if (aicc_url !== undefined && aicc_url !== null)
            url_ += "AICC_URL=" + encodeURIComponent("" + aicc_url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_PIF_SetStudentId__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_PIF_SetStudentId__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_PIF_spMetadata_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/PIF/sp-metadata";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_PIF_spMetadata_get_V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_PIF_spMetadata_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_OKTA_Login__V1 = function (returnUrl, aiccSid, aicc_url, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/OKTA/Login?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (aiccSid !== undefined && aiccSid !== null)
            url_ += "AICC_SID=" + encodeURIComponent("" + aiccSid) + "&";
        if (aicc_url !== undefined && aicc_url !== null)
            url_ += "AICC_URL=" + encodeURIComponent("" + aicc_url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_OKTA_Login__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_OKTA_Login__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_OKTA_AssertionConsumerService__V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/OKTA/AssertionConsumerService";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_OKTA_AssertionConsumerService__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_OKTA_AssertionConsumerService__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth)
     * @param aiccSid (optional)
     * @param aicc_url (optional)
     */
    Server_Auth_Client.prototype.auth_OKTA_SetStudentId__V1 = function (aiccSid, aicc_url, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/OKTA/SetStudentId?";
        if (aiccSid !== undefined && aiccSid !== null)
            url_ += "AICC_SID=" + encodeURIComponent("" + aiccSid) + "&";
        if (aicc_url !== undefined && aicc_url !== null)
            url_ += "AICC_URL=" + encodeURIComponent("" + aicc_url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_OKTA_SetStudentId__V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_OKTA_SetStudentId__V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Auth_Client.prototype.auth_OKTA_spMetadata_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Auth/OKTA/sp-metadata";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuth_OKTA_spMetadata_get_V1(_response);
        });
    };
    Server_Auth_Client.prototype.processAuth_OKTA_spMetadata_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Auth_Client;
}());
exports.Server_Auth_Client = Server_Auth_Client;
var Server_BusinessGroup_Client = /** @class */ (function () {
    function Server_BusinessGroup_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard)
     * @param voucher (optional)
     */
    Server_BusinessGroup_Client.prototype.businessGroup_byVoucher_get_V1 = function (voucher, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroup/by-voucher?";
        if (voucher !== undefined && voucher !== null)
            url_ += "Voucher=" + encodeURIComponent("" + voucher) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_byVoucher_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusinessGroup_byVoucher_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param input (optional)
     */
    Server_BusinessGroup_Client.prototype.businessGroup_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroup?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusinessGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_BusinessGroup_Client.prototype.businessGroup_myBusinessGroup_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroup/my-business-group";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_myBusinessGroup_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusinessGroup_myBusinessGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param input (optional)
     */
    Server_BusinessGroup_Client.prototype.businessGroup_get_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/BusinessGroup?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_get_V2(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusinessGroup_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.3) (Scope: Dashboard)
     */
    Server_BusinessGroup_Client.prototype.business_BusinessGroup_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroup_put_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusiness_BusinessGroup_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param input (optional)
     */
    Server_BusinessGroup_Client.prototype.business_BusinessGroup_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroup?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroup_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusiness_BusinessGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param input (optional)
     */
    Server_BusinessGroup_Client.prototype.business_BusinessGroup_get_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/business/BusinessGroup?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroup_get_V2(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusiness_BusinessGroup_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.1) (Scope: Dashboard)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_post_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.2) (Scope: Dashboard)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_put_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.0) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_byId_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_multilingualById_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.4) (Scope: Dashboard)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_monthlyReport_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/monthly-report?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_monthlyReport_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_monthlyReport_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.4) (Scope: Dashboard)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_skillCompletionReport_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/skill-completion-report?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_skillCompletionReport_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_skillCompletionReport_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.8) (Scope: Dashboard)
     * @param userId (optional)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_byUser_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/by-user?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_byUser_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_byUser_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.1) (Scope: Dashboard)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_post_V2(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 88.2) (Scope: Dashboard)
     */
    Server_BusinessGroup_Client.prototype.admin_BusinessGroup_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroup_put_V2(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processAdmin_BusinessGroup_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_BusinessGroup_Client.prototype.businessGroup_notificationTime_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/BusinessGroup/notification-time";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_notificationTime_put_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusinessGroup_notificationTime_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_BusinessGroup_Client.prototype.businessGroup_notificationTime_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/BusinessGroup/notification-time";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_notificationTime_get_V1(_response);
        });
    };
    Server_BusinessGroup_Client.prototype.processBusinessGroup_notificationTime_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroup_Client;
}());
exports.Server_BusinessGroup_Client = Server_BusinessGroup_Client;
var Server_BusinessGroupDepartments_Client = /** @class */ (function () {
    function Server_BusinessGroupDepartments_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param searchName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupDepartments_Client.prototype.businessGroupDepartments_getBusinessGroupDepartments_get_V1 = function (searchName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroupDepartments/get-business-group-departments?";
        if (searchName !== undefined && searchName !== null)
            url_ += "SearchName=" + encodeURIComponent("" + searchName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupDepartments_getBusinessGroupDepartments_get_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusinessGroupDepartments_getBusinessGroupDepartments_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_BusinessGroupDepartments_Client.prototype.businessGroupDepartments_getMyDepartment_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroupDepartments/get-my-department";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupDepartments_getMyDepartment_get_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusinessGroupDepartments_getMyDepartment_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.3) (Scope: BusinessGroup)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_post_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.4) (Scope: BusinessGroup)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_put_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.9) (Scope: BusinessGroup)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_delete_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.7) (Scope: BusinessGroup)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_createMultiple_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments/create-multiple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_createMultiple_post_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_createMultiple_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.5) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_getMyBusinessGroupDepartments_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments/get-my-business-group-departments?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_getMyBusinessGroupDepartments_get_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_getMyBusinessGroupDepartments_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.6) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_getMyBusinessGroupDepartmentsDetails_get_V1 = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments/get-my-business-group-departments-details?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_getMyBusinessGroupDepartmentsDetails_get_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_getMyBusinessGroupDepartmentsDetails_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.8) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param departmentId (optional)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_getById_get_V1 = function (businessGroupId, departmentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments/get-by-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_getById_get_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_getById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.8) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param departmentId (optional)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_multilingualById_get_V1 = function (businessGroupId, departmentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupDepartments/multilingual-by-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_multilingualById_get_V1(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.3) (Scope: BusinessGroup)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/business/BusinessGroupDepartments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_post_V2(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 137.4) (Scope: BusinessGroup)
     */
    Server_BusinessGroupDepartments_Client.prototype.business_BusinessGroupDepartments_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/business/BusinessGroupDepartments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupDepartments_put_V2(_response);
        });
    };
    Server_BusinessGroupDepartments_Client.prototype.processBusiness_BusinessGroupDepartments_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupDepartments_Client;
}());
exports.Server_BusinessGroupDepartments_Client = Server_BusinessGroupDepartments_Client;
var Server_BusinessGroupUser_Client = /** @class */ (function () {
    function Server_BusinessGroupUser_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_BusinessGroupUser_Client.prototype.businessGroupUser_changeMyDepartment_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroupUser/change-my-department";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_changeMyDepartment_put_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusinessGroupUser_changeMyDepartment_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_BusinessGroupUser_Client.prototype.businessGroupUser_leave_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroupUser/leave";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_leave_delete_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusinessGroupUser_leave_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.8) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.6) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_get_V1 = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_get_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.8) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_withProvider_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/with-provider";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_withProvider_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_withProvider_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.18) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_unLink_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/un-link";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_unLink_delete_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_unLink_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.8) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_resendWelcome_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/resend-welcome";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_resendWelcome_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_resendWelcome_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.11) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pricesFile (optional)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_bulk_post_V1 = function (businessGroupId, pricesFile, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/bulk";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (businessGroupId === null || businessGroupId === undefined)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else
            content_.append("BusinessGroupId", businessGroupId.toString());
        if (pricesFile !== null && pricesFile !== undefined)
            content_.append("PricesFile", pricesFile.data, pricesFile.fileName ? pricesFile.fileName : "PricesFile");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_bulk_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_bulk_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.9) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_setRole_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/set-role";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_setRole_put_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_setRole_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.10) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_setState_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/set-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_setState_put_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_setState_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.12) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param email (optional)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_searchByEmail_get_V1 = function (x_app_language_id, businessGroupId, email, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/search-by-email?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_searchByEmail_get_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_searchByEmail_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.13) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param userId (optional)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_userById_get_V1 = function (x_app_language_id, businessGroupId, userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/user-by-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_userById_get_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_userById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.15) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param name (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_searchUsersWithoutADepartment_get_V1 = function (businessGroupId, name, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/search-users-without-a-department?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_searchUsersWithoutADepartment_get_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_searchUsersWithoutADepartment_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.16) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_changeMyBusinessUsersDepartment_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/change-my-business-users-department";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_changeMyBusinessUsersDepartment_put_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_changeMyBusinessUsersDepartment_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.21) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_setAsDepartmentModerator_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/set-as-department-moderator";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_setAsDepartmentModerator_put_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_setAsDepartmentModerator_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.17) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param departmentId (optional)
     * @param searchKey (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupUser_Client.prototype.business_BusinessGroupUser_departmentUsersByDepartmentId_get_V1 = function (businessGroupId, departmentId, searchKey, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/department-users-by-department-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupUser_departmentUsersByDepartmentId_get_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processBusiness_BusinessGroupUser_departmentUsersByDepartmentId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.1) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_get_V1 = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_get_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.1) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_withProvider_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/with-provider";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_withProvider_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_withProvider_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.2) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_createAdmin_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/create-admin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_createAdmin_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_createAdmin_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.1) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_resendWelcome_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/resend-welcome";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_resendWelcome_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_resendWelcome_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.18) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_unLink_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/un-link";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_unLink_delete_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_unLink_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.2) (Scope: Dashboard)
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_setRole_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/set-role";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_setRole_put_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_setRole_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 91.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroupUser_Client.prototype.admin_BusinessGroupUser_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupUser_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroupUser_Client.prototype.processAdmin_BusinessGroupUser_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupUser_Client;
}());
exports.Server_BusinessGroupUser_Client = Server_BusinessGroupUser_Client;
var Server_BusinessGroupVoucher_Client = /** @class */ (function () {
    function Server_BusinessGroupVoucher_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_consume_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroupVoucher/consume";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_consume_post_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_consume_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 95.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupVoucher_Client.prototype.business_BusinessGroupVoucher_get_V1 = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupVoucher_get_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusiness_BusinessGroupVoucher_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 95.0) (Scope: Dashboard)
     */
    Server_BusinessGroupVoucher_Client.prototype.business_BusinessGroupVoucher_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupVoucher_post_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusiness_BusinessGroupVoucher_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 95.7) (Scope: Dashboard)
     */
    Server_BusinessGroupVoucher_Client.prototype.business_BusinessGroupVoucher_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupVoucher_put_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusiness_BusinessGroupVoucher_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 95.6) (Scope: Dashboard)
     * @param businessGroupVoucherId (optional)
     */
    Server_BusinessGroupVoucher_Client.prototype.business_BusinessGroupVoucher_byId_get_V1 = function (businessGroupVoucherId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/by-id?";
        if (businessGroupVoucherId === null)
            throw new Error("The parameter 'businessGroupVoucherId' cannot be null.");
        else if (businessGroupVoucherId !== undefined)
            url_ += "BusinessGroupVoucherId=" + encodeURIComponent("" + businessGroupVoucherId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupVoucher_byId_get_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusiness_BusinessGroupVoucher_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 95.5) (Scope: Dashboard)
     */
    Server_BusinessGroupVoucher_Client.prototype.business_BusinessGroupVoucher_setPublished_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/set-published";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupVoucher_setPublished_put_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusiness_BusinessGroupVoucher_setPublished_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 95.4) (Scope: Dashboard)
     */
    Server_BusinessGroupVoucher_Client.prototype.business_BusinessGroupVoucher_expire_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/expire";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupVoucher_expire_put_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusiness_BusinessGroupVoucher_expire_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 95.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroupVoucher_Client.prototype.business_BusinessGroupVoucher_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupVoucher_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroupVoucher_Client.prototype.processBusiness_BusinessGroupVoucher_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupVoucher_Client;
}());
exports.Server_BusinessGroupVoucher_Client = Server_BusinessGroupVoucher_Client;
var Server_ContactUs_Client = /** @class */ (function () {
    function Server_ContactUs_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_ContactUs_Client.prototype.contactUs_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ContactUs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContactUs_post_V1(_response);
        });
    };
    Server_ContactUs_Client.prototype.processContactUs_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Server_ContactUs_Client.prototype.contactUs_public_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ContactUs/public";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContactUs_public_post_V1(_response);
        });
    };
    Server_ContactUs_Client.prototype.processContactUs_public_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 86.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContactUs_Client.prototype.admin_ContactUs_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/ContactUs/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContactUs_datatable_post_V1(_response);
        });
    };
    Server_ContactUs_Client.prototype.processAdmin_ContactUs_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 86.2) (Scope: Dashboard)
     */
    Server_ContactUs_Client.prototype.admin_ContactUs_answer_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/ContactUs/answer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContactUs_answer_post_V1(_response);
        });
    };
    Server_ContactUs_Client.prototype.processAdmin_ContactUs_answer_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContactUs_Client;
}());
exports.Server_ContactUs_Client = Server_ContactUs_Client;
var Server_EventKeyMapping_Client = /** @class */ (function () {
    function Server_EventKeyMapping_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     */
    Server_EventKeyMapping_Client.prototype.eventKeyMapping_post_V1 = function (input, x_app_version, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/EventKeyMapping";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEventKeyMapping_post_V1(_response);
        });
    };
    Server_EventKeyMapping_Client.prototype.processEventKeyMapping_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 143.0)
     * @param x_app_language_id (optional) Language Id
     * @param platform (optional)
     * @param appVersion (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_EventKeyMapping_Client.prototype.admin_EventKeyMapping_get_V1 = function (x_app_language_id, platform, appVersion, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/EventKeyMapping?";
        if (platform !== undefined && platform !== null)
            url_ += "Platform=" + encodeURIComponent("" + platform) + "&";
        if (appVersion !== undefined && appVersion !== null)
            url_ += "AppVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_EventKeyMapping_get_V1(_response);
        });
    };
    Server_EventKeyMapping_Client.prototype.processAdmin_EventKeyMapping_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 143.4)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_EventKeyMapping_Client.prototype.admin_EventKeyMapping_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/EventKeyMapping/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_EventKeyMapping_byId_get_V1(_response);
        });
    };
    Server_EventKeyMapping_Client.prototype.processAdmin_EventKeyMapping_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 143.2)
     */
    Server_EventKeyMapping_Client.prototype.admin_EventKeyMapping_eventValue_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/EventKeyMapping/event-value";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_EventKeyMapping_eventValue_put_V1(_response);
        });
    };
    Server_EventKeyMapping_Client.prototype.processAdmin_EventKeyMapping_eventValue_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 143.5)
     */
    Server_EventKeyMapping_Client.prototype.admin_EventKeyMapping_publishingState_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/EventKeyMapping/publishing-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_EventKeyMapping_publishingState_put_V1(_response);
        });
    };
    Server_EventKeyMapping_Client.prototype.processAdmin_EventKeyMapping_publishingState_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 143.0)
     */
    Server_EventKeyMapping_Client.prototype.admin_EventKeyMapping_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/EventKeyMapping/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_EventKeyMapping_datatable_post_V1(_response);
        });
    };
    Server_EventKeyMapping_Client.prototype.processAdmin_EventKeyMapping_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_EventKeyMapping_Client;
}());
exports.Server_EventKeyMapping_Client = Server_EventKeyMapping_Client;
var Server_Feedback_Client = /** @class */ (function () {
    function Server_Feedback_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param type (optional)
     */
    Server_Feedback_Client.prototype.feedback_getUserFeedbackOptions_get_V1 = function (x_app_language_id, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Feedback/get-user-feedback-options?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeedback_getUserFeedbackOptions_get_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processFeedback_getUserFeedbackOptions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param type (optional)
     */
    Server_Feedback_Client.prototype.feedback_getFeedbackOptions_get_V1 = function (x_app_language_id, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Feedback/get-feedback-options?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeedback_getFeedbackOptions_get_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processFeedback_getFeedbackOptions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Feedback_Client.prototype.feedback_submitFeedback_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Feedback/submit-feedback";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeedback_submitFeedback_post_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processFeedback_submitFeedback_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Feedback_Client.prototype.admin_Feedback_options_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_options_post_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_options_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.3) (Scope: Dashboard)
     * @deprecated
     */
    Server_Feedback_Client.prototype.admin_Feedback_options_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_options_put_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_options_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Feedback_Client.prototype.admin_Feedback_options_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/options?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_options_delete_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_options_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.7) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Feedback_Client.prototype.admin_Feedback_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_multilingualById_get_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_Feedback_Client.prototype.admin_Feedback_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_byId_get_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param type (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Feedback_Client.prototype.admin_Feedback_options_paginated_get_V1 = function (x_app_language_id, type, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/options/paginated?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_options_paginated_get_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_options_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Feedback_Client.prototype.admin_Feedback_options_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/options/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_options_datatable_post_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_options_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.5) (Scope: Dashboard)
     */
    Server_Feedback_Client.prototype.admin_Feedback_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Feedback/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_datatable_post_V1(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.2) (Scope: Dashboard)
     */
    Server_Feedback_Client.prototype.admin_Feedback_options_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Feedback/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_options_post_V2(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_options_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 141.3) (Scope: Dashboard)
     */
    Server_Feedback_Client.prototype.admin_Feedback_options_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/admin/Feedback/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Feedback_options_put_V2(_response);
        });
    };
    Server_Feedback_Client.prototype.processAdmin_Feedback_options_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Feedback_Client;
}());
exports.Server_Feedback_Client = Server_Feedback_Client;
var Server_Languages_Client = /** @class */ (function () {
    function Server_Languages_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     */
    Server_Languages_Client.prototype.languages_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Languages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLanguages_get_V1(_response);
        });
    };
    Server_Languages_Client.prototype.processLanguages_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 24.1) (Scope: Dashboard)
     */
    Server_Languages_Client.prototype.admin_Languages_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Languages";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Languages_post_V1(_response);
        });
    };
    Server_Languages_Client.prototype.processAdmin_Languages_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 24.2) (Scope: Dashboard)
     */
    Server_Languages_Client.prototype.admin_Languages_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Languages";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Languages_put_V1(_response);
        });
    };
    Server_Languages_Client.prototype.processAdmin_Languages_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 24.0) (Scope: Dashboard; Mobile)
     */
    Server_Languages_Client.prototype.admin_Languages_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Languages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Languages_get_V1(_response);
        });
    };
    Server_Languages_Client.prototype.processAdmin_Languages_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 24.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Languages_Client.prototype.admin_Languages_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Languages?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Languages_delete_V1(_response);
        });
    };
    Server_Languages_Client.prototype.processAdmin_Languages_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 24.2) (Scope: Dashboard)
     */
    Server_Languages_Client.prototype.admin_Languages_archive_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Languages/archive";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Languages_archive_put_V1(_response);
        });
    };
    Server_Languages_Client.prototype.processAdmin_Languages_archive_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Languages_Client;
}());
exports.Server_Languages_Client = Server_Languages_Client;
var Server_UserReferral_Client = /** @class */ (function () {
    function Server_UserReferral_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @deprecated
     */
    Server_UserReferral_Client.prototype.userReferral_referralState_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/UserReferral/referral-state";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserReferral_referralState_get_V1(_response);
        });
    };
    Server_UserReferral_Client.prototype.processUserReferral_referralState_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_UserReferral_Client.prototype.userReferral_redeemReferralReward_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/UserReferral/redeem-referral-reward";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserReferral_redeemReferralReward_post_V1(_response);
        });
    };
    Server_UserReferral_Client.prototype.processUserReferral_redeemReferralReward_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_UserReferral_Client.prototype.userReferral_redeemReferralCode_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/UserReferral/redeem-referral-code";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserReferral_redeemReferralCode_post_V1(_response);
        });
    };
    Server_UserReferral_Client.prototype.processUserReferral_redeemReferralCode_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_UserReferral_Client.prototype.userReferral_referralState_get_V2 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/UserReferral/referral-state";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserReferral_referralState_get_V2(_response);
        });
    };
    Server_UserReferral_Client.prototype.processUserReferral_referralState_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_UserReferral_Client;
}());
exports.Server_UserReferral_Client = Server_UserReferral_Client;
var Server_BusinessGroupRequest_Client = /** @class */ (function () {
    function Server_BusinessGroupRequest_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 96.0) (Scope: Dashboard)
     * @param businessGroupVoucherId (optional)
     * @param requestState (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_get_V1 = function (businessGroupVoucherId, requestState, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest?";
        if (businessGroupVoucherId === null)
            throw new Error("The parameter 'businessGroupVoucherId' cannot be null.");
        else if (businessGroupVoucherId !== undefined)
            url_ += "BusinessGroupVoucherId=" + encodeURIComponent("" + businessGroupVoucherId) + "&";
        if (requestState !== undefined && requestState !== null)
            url_ += "RequestState=" + encodeURIComponent("" + requestState) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_get_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 96.6) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param requestState (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_byGroupId_get_V1 = function (businessGroupId, requestState, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/by-group-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (requestState !== undefined && requestState !== null)
            url_ += "RequestState=" + encodeURIComponent("" + requestState) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_byGroupId_get_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_byGroupId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 96.2) (Scope: Dashboard)
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_approve_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/approve";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_approve_post_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_approve_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 96.3) (Scope: Dashboard)
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_approveAll_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/approve-all";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_approveAll_post_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_approveAll_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 96.4) (Scope: Dashboard)
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_reject_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/reject";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_reject_post_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_reject_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 96.5) (Scope: Dashboard)
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_rejectAll_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/reject-all";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_rejectAll_post_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_rejectAll_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 96.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 96.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroupRequest_Client.prototype.business_BusinessGroupRequest_byGroupId_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/by-group-id/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupRequest_byGroupId_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroupRequest_Client.prototype.processBusiness_BusinessGroupRequest_byGroupId_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupRequest_Client;
}());
exports.Server_BusinessGroupRequest_Client = Server_BusinessGroupRequest_Client;
var Server_BusinessGroupSoftSkills_Client = /** @class */ (function () {
    function Server_BusinessGroupSoftSkills_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 118.14) (Scope: BusinessGroup)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_addMultipleSkillsToDepartment_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/add-multiple-skills-to-department";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_addMultipleSkillsToDepartment_post_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_addMultipleSkillsToDepartment_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.15) (Scope: BusinessGroup)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_removeMultipleSkillsFromDepartment_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/remove-multiple-skills-from-department";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_removeMultipleSkillsFromDepartment_post_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_removeMultipleSkillsFromDepartment_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.16) (Scope: BusinessGroup)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_addMultipleSkillsToUser_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/add-multiple-skills-to-user";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_addMultipleSkillsToUser_post_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_addMultipleSkillsToUser_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.17) (Scope: BusinessGroup)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_removeMultipleSkillsFromUser_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/remove-multiple-skills-from-user";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_removeMultipleSkillsFromUser_post_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_removeMultipleSkillsFromUser_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.0) (Scope: BusinessGroup)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_setSkills_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/set-skills";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_setSkills_put_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_setSkills_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.1) (Scope: BusinessGroup)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_assignSkill_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/assign-skill";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_assignSkill_post_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_assignSkill_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.2) (Scope: BusinessGroup)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_unassignSkill_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/unassign-skill";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_unassignSkill_delete_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_unassignSkill_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.3) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param departmentId (optional)
     * @param userId (optional)
     * @param type (optional)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_selectedSkills_get_V1 = function (x_app_language_id, businessGroupId, departmentId, userId, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/selected-skills?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_selectedSkills_get_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_selectedSkills_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.9) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_skills_paginated_get_V1 = function (x_app_language_id, businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/skills/paginated?";
        if (businessGroupId !== undefined && businessGroupId !== null)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_skills_paginated_get_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_skills_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.4) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupSoftSkills_Client.prototype.business_BusinessGroupSoftSkills_skills_get_V1 = function (x_app_language_id, businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/skills?";
        if (businessGroupId !== undefined && businessGroupId !== null)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupSoftSkills_skills_get_V1(_response);
        });
    };
    Server_BusinessGroupSoftSkills_Client.prototype.processBusiness_BusinessGroupSoftSkills_skills_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupSoftSkills_Client;
}());
exports.Server_BusinessGroupSoftSkills_Client = Server_BusinessGroupSoftSkills_Client;
var Server_BusinessGroupQuantity_Client = /** @class */ (function () {
    function Server_BusinessGroupQuantity_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 93.1) (Scope: Dashboard)
     */
    Server_BusinessGroupQuantity_Client.prototype.admin_BusinessGroupQuantity_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupQuantity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupQuantity_post_V1(_response);
        });
    };
    Server_BusinessGroupQuantity_Client.prototype.processAdmin_BusinessGroupQuantity_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 93.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupQuantity_Client.prototype.admin_BusinessGroupQuantity_get_V1 = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupQuantity?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupQuantity_get_V1(_response);
        });
    };
    Server_BusinessGroupQuantity_Client.prototype.processAdmin_BusinessGroupQuantity_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 93.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroupQuantity_Client.prototype.admin_BusinessGroupQuantity_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupQuantity/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupQuantity_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroupQuantity_Client.prototype.processAdmin_BusinessGroupQuantity_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupQuantity_Client;
}());
exports.Server_BusinessGroupQuantity_Client = Server_BusinessGroupQuantity_Client;
var Server_BusinessGroupSubscription_Client = /** @class */ (function () {
    function Server_BusinessGroupSubscription_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 92.1) (Scope: Dashboard)
     */
    Server_BusinessGroupSubscription_Client.prototype.admin_BusinessGroupSubscription_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupSubscription_post_V1(_response);
        });
    };
    Server_BusinessGroupSubscription_Client.prototype.processAdmin_BusinessGroupSubscription_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 92.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupSubscription_Client.prototype.admin_BusinessGroupSubscription_get_V1 = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupSubscription_get_V1(_response);
        });
    };
    Server_BusinessGroupSubscription_Client.prototype.processAdmin_BusinessGroupSubscription_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 92.2) (Scope: Dashboard)
     */
    Server_BusinessGroupSubscription_Client.prototype.admin_BusinessGroupSubscription_expire_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription/expire";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupSubscription_expire_put_V1(_response);
        });
    };
    Server_BusinessGroupSubscription_Client.prototype.processAdmin_BusinessGroupSubscription_expire_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 92.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_BusinessGroupSubscription_Client.prototype.admin_BusinessGroupSubscription_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_BusinessGroupSubscription_datatable_post_V1(_response);
        });
    };
    Server_BusinessGroupSubscription_Client.prototype.processAdmin_BusinessGroupSubscription_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupSubscription_Client;
}());
exports.Server_BusinessGroupSubscription_Client = Server_BusinessGroupSubscription_Client;
var Server_SystemConfig_Client = /** @class */ (function () {
    function Server_SystemConfig_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 144.1) (Scope: Dashboard)
     */
    Server_SystemConfig_Client.prototype.admin_SystemConfig_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/SystemConfig";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_SystemConfig_put_V1(_response);
        });
    };
    Server_SystemConfig_Client.prototype.processAdmin_SystemConfig_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 144.0) (Scope: Dashboard)
     */
    Server_SystemConfig_Client.prototype.admin_SystemConfig_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/SystemConfig/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_SystemConfig_datatable_post_V1(_response);
        });
    };
    Server_SystemConfig_Client.prototype.processAdmin_SystemConfig_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 144.0) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_SystemConfig_Client.prototype.admin_SystemConfig_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/SystemConfig/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_SystemConfig_byId_get_V1(_response);
        });
    };
    Server_SystemConfig_Client.prototype.processAdmin_SystemConfig_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_SystemConfig_Client;
}());
exports.Server_SystemConfig_Client = Server_SystemConfig_Client;
var Server_UserApiKey_Client = /** @class */ (function () {
    function Server_UserApiKey_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 124.0) (Scope: Dashboard)
     */
    Server_UserApiKey_Client.prototype.admin_UserApiKey_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UserApiKey_post_V1(_response);
        });
    };
    Server_UserApiKey_Client.prototype.processAdmin_UserApiKey_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 124.1) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_UserApiKey_Client.prototype.admin_UserApiKey_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UserApiKey_delete_V1(_response);
        });
    };
    Server_UserApiKey_Client.prototype.processAdmin_UserApiKey_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 124.3) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_UserApiKey_Client.prototype.admin_UserApiKey_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UserApiKey_get_V1(_response);
        });
    };
    Server_UserApiKey_Client.prototype.processAdmin_UserApiKey_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 124.2) (Scope: Dashboard)
     */
    Server_UserApiKey_Client.prototype.admin_UserApiKey_state_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UserApiKey_state_put_V1(_response);
        });
    };
    Server_UserApiKey_Client.prototype.processAdmin_UserApiKey_state_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_UserApiKey_Client;
}());
exports.Server_UserApiKey_Client = Server_UserApiKey_Client;
var Server_UtilityUser_Client = /** @class */ (function () {
    function Server_UtilityUser_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Dashboard; Mobile; Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_authenticate_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_authenticate_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_authenticate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.7) (Scope: Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_users_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/users";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_users_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_users_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.8) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_users_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/users?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_users_get_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_users_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.13) (Scope: Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_users_updateActivation_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/users/update-activation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_users_updateActivation_put_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_users_updateActivation_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.8) (Scope: Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_users_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/users/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_users_datatable_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_users_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.2) (Scope: Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_promocode_assign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/promocode/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_promocode_assign_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_promocode_assign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.11) (Scope: Dashboard)
     * @param voucherId (optional)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_checkState_get_V1 = function (voucherId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/check-state?";
        if (voucherId === null)
            throw new Error("The parameter 'voucherId' cannot be null.");
        else if (voucherId !== undefined)
            url_ += "VoucherId=" + encodeURIComponent("" + voucherId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_checkState_get_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_checkState_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.12) (Scope: Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_updatePaymentMethod_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/update-payment-method";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_updatePaymentMethod_put_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_updatePaymentMethod_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.6) (Scope: Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_voucher_generate_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/voucher/generate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_voucher_generate_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_voucher_generate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.5) (Scope: Dashboard; Web)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_voucher_get_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/voucher/get";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_voucher_get_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_voucher_get_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.10) (Scope: Dashboard; Web)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_vouchers_analysis_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/vouchers/analysis";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_vouchers_analysis_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_vouchers_analysis_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.11) (Scope: Dashboard; Web)
     * @param input (optional)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_promocode_analysis_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/promocode/analysis?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_promocode_analysis_get_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_promocode_analysis_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.9) (Scope: Dashboard; Web)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_utility_analysis_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/utility/analysis";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_utility_analysis_post_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_utility_analysis_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.8) (Scope: Dashboard)
     * @param input (optional)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_users_lookups_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/users/lookups?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_users_lookups_get_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_users_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 139.12) (Scope: Dashboard)
     */
    Server_UtilityUser_Client.prototype.admin_UtilityUser_updatePublisher_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UtilityUser/update-publisher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_UtilityUser_updatePublisher_put_V1(_response);
        });
    };
    Server_UtilityUser_Client.prototype.processAdmin_UtilityUser_updatePublisher_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_UtilityUser_Client;
}());
exports.Server_UtilityUser_Client = Server_UtilityUser_Client;
var Server_NotificationTypes_Client = /** @class */ (function () {
    function Server_NotificationTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_NotificationTypes_Client.prototype.notificationTypes_receiver_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTypes/receiver";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_receiver_get_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processNotificationTypes_receiver_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_NotificationTypes_Client.prototype.notificationTypes_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_get_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processNotificationTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_NotificationTypes_Client.prototype.notificationTypes_set_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTypes/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_set_post_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processNotificationTypes_set_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 46.1)
     */
    Server_NotificationTypes_Client.prototype.admin_NotificationTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_NotificationTypes_post_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processAdmin_NotificationTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 46.2) (Scope: Dashboard)
     */
    Server_NotificationTypes_Client.prototype.admin_NotificationTypes_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_NotificationTypes_put_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processAdmin_NotificationTypes_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_NotificationTypes_Client.prototype.admin_NotificationTypes_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_NotificationTypes_get_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processAdmin_NotificationTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 46.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_NotificationTypes_Client.prototype.admin_NotificationTypes_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_NotificationTypes_delete_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processAdmin_NotificationTypes_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 46.7)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_NotificationTypes_Client.prototype.admin_NotificationTypes_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_NotificationTypes_paginated_get_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processAdmin_NotificationTypes_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 46.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_NotificationTypes_Client.prototype.admin_NotificationTypes_id_get_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_NotificationTypes_id_get_V1(_response);
        });
    };
    Server_NotificationTypes_Client.prototype.processAdmin_NotificationTypes_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_NotificationTypes_Client;
}());
exports.Server_NotificationTypes_Client = Server_NotificationTypes_Client;
var Server_Reciever_Client = /** @class */ (function () {
    function Server_Reciever_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @deprecated
     */
    Server_Reciever_Client.prototype.reciever_setPlayerId_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Reciever/set-player-id";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReciever_setPlayerId_post_V1(_response);
        });
    };
    Server_Reciever_Client.prototype.processReciever_setPlayerId_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Reciever_Client;
}());
exports.Server_Reciever_Client = Server_Reciever_Client;
var Server_EmailTemplates_Client = /** @class */ (function () {
    function Server_EmailTemplates_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 142.1) (Scope: Dashboard)
     */
    Server_EmailTemplates_Client.prototype.emailTemplates_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/EmailTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailTemplates_post_V1(_response);
        });
    };
    Server_EmailTemplates_Client.prototype.processEmailTemplates_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 142.2) (Scope: Dashboard)
     */
    Server_EmailTemplates_Client.prototype.emailTemplates_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/EmailTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailTemplates_put_V1(_response);
        });
    };
    Server_EmailTemplates_Client.prototype.processEmailTemplates_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 142.0) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_EmailTemplates_Client.prototype.emailTemplates_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/EmailTemplates?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailTemplates_get_V1(_response);
        });
    };
    Server_EmailTemplates_Client.prototype.processEmailTemplates_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 142.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_EmailTemplates_Client.prototype.emailTemplates_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/EmailTemplates?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailTemplates_delete_V1(_response);
        });
    };
    Server_EmailTemplates_Client.prototype.processEmailTemplates_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 142.5) (Scope: Dashboard)
     */
    Server_EmailTemplates_Client.prototype.emailTemplates_publishState_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/EmailTemplates/publish-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailTemplates_publishState_put_V1(_response);
        });
    };
    Server_EmailTemplates_Client.prototype.processEmailTemplates_publishState_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 142.0) (Scope: Dashboard)
     */
    Server_EmailTemplates_Client.prototype.emailTemplates_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/EmailTemplates/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailTemplates_datatable_post_V1(_response);
        });
    };
    Server_EmailTemplates_Client.prototype.processEmailTemplates_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 142.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_EmailTemplates_Client.prototype.emailTemplates_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/EmailTemplates/byId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailTemplates_byId_get_V1(_response);
        });
    };
    Server_EmailTemplates_Client.prototype.processEmailTemplates_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_EmailTemplates_Client;
}());
exports.Server_EmailTemplates_Client = Server_EmailTemplates_Client;
var Server_NotificationSubtype_Client = /** @class */ (function () {
    function Server_NotificationSubtype_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 10.1) (Scope: Dashboard)
     */
    Server_NotificationSubtype_Client.prototype.admin_NotificationSubtype_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationSubtype";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_NotificationSubtype_post_V1(_response);
        });
    };
    Server_NotificationSubtype_Client.prototype.processAdmin_NotificationSubtype_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_NotificationSubtype_Client;
}());
exports.Server_NotificationSubtype_Client = Server_NotificationSubtype_Client;
var Server_NotificationTemplates_Client = /** @class */ (function () {
    function Server_NotificationTemplates_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 10.1) (Scope: Dashboard)
     */
    Server_NotificationTemplates_Client.prototype.notificationTemplates_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_post_V1(_response);
        });
    };
    Server_NotificationTemplates_Client.prototype.processNotificationTemplates_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 10.2) (Scope: Dashboard)
     */
    Server_NotificationTemplates_Client.prototype.notificationTemplates_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_put_V1(_response);
        });
    };
    Server_NotificationTemplates_Client.prototype.processNotificationTemplates_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 10.0) (Scope: Dashboard)
     */
    Server_NotificationTemplates_Client.prototype.notificationTemplates_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_get_V1(_response);
        });
    };
    Server_NotificationTemplates_Client.prototype.processNotificationTemplates_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 10.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_NotificationTemplates_Client.prototype.notificationTemplates_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_delete_V1(_response);
        });
    };
    Server_NotificationTemplates_Client.prototype.processNotificationTemplates_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 10.4) (Scope: Dashboard)
     */
    Server_NotificationTemplates_Client.prototype.notificationTemplates_id_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_id_get_V1(_response);
        });
    };
    Server_NotificationTemplates_Client.prototype.processNotificationTemplates_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_NotificationTemplates_Client;
}());
exports.Server_NotificationTemplates_Client = Server_NotificationTemplates_Client;
var Server_Allowings_Client = /** @class */ (function () {
    function Server_Allowings_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Allowings_Client.prototype.allowings_buyPoints_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Allowings/buy-points";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllowings_buyPoints_post_V1(_response);
        });
    };
    Server_Allowings_Client.prototype.processAllowings_buyPoints_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Allowings_Client.prototype.allowings_redeemPoints_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Allowings/redeem-points";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllowings_redeemPoints_post_V1(_response);
        });
    };
    Server_Allowings_Client.prototype.processAllowings_redeemPoints_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Allowings_Client.prototype.allowings_onboardingOpenContentEntity_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Allowings/onboarding-open-content-entity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllowings_onboardingOpenContentEntity_post_V1(_response);
        });
    };
    Server_Allowings_Client.prototype.processAllowings_onboardingOpenContentEntity_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Allowings_Client.prototype.allowings_redeemCredit_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Allowings/redeem-credit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllowings_redeemCredit_post_V1(_response);
        });
    };
    Server_Allowings_Client.prototype.processAllowings_redeemCredit_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Allowings_Client.prototype.allowings_ids_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Allowings/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllowings_ids_get_V1(_response);
        });
    };
    Server_Allowings_Client.prototype.processAllowings_ids_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Allowings_Client;
}());
exports.Server_Allowings_Client = Server_Allowings_Client;
var Server_Authors_Client = /** @class */ (function () {
    function Server_Authors_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 31.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Authors_Client.prototype.authors_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_post_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Authors_Client.prototype.authors_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_put_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.0) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Authors_Client.prototype.authors_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_get_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Authors_Client.prototype.authors_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_delete_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.9)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_Authors_Client.prototype.authors_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_byId_get_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Authors_Client.prototype.authors_byContentEntity_get_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/by-content-entity?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_byContentEntity_get_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_byContentEntity_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.4) (Scope: Dashboard)
     */
    Server_Authors_Client.prototype.authors_assign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_assign_post_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_assign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.5) (Scope: Dashboard)
     */
    Server_Authors_Client.prototype.authors_unAssign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/un-assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_unAssign_post_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_unAssign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.7) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Server_Authors_Client.prototype.authors_lookups_get_V1 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_lookups_get_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Authors_Client.prototype.authors_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_datatable_post_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAuthors_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.9)
     * @param id (optional)
     */
    Server_Authors_Client.prototype.admin_Authors_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Authors/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Authors_multilingualById_get_V1(_response);
        });
    };
    Server_Authors_Client.prototype.processAdmin_Authors_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.1) (Scope: Dashboard)
     */
    Server_Authors_Client.prototype.admin_Authors_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Authors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Authors_post_V2(_response);
        });
    };
    Server_Authors_Client.prototype.processAdmin_Authors_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 31.2) (Scope: Dashboard)
     */
    Server_Authors_Client.prototype.admin_Authors_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Authors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Authors_put_V2(_response);
        });
    };
    Server_Authors_Client.prototype.processAdmin_Authors_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Authors_Client;
}());
exports.Server_Authors_Client = Server_Authors_Client;
var Server_Bookmarks_Client = /** @class */ (function () {
    function Server_Bookmarks_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Bookmarks_Client.prototype.bookmarks_add_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBookmarks_add_post_V1(_response);
        });
    };
    Server_Bookmarks_Client.prototype.processBookmarks_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Bookmarks_Client.prototype.bookmarks_remove_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBookmarks_remove_post_V1(_response);
        });
    };
    Server_Bookmarks_Client.prototype.processBookmarks_remove_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Bookmarks_Client.prototype.bookmarks_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBookmarks_get_V1(_response);
        });
    };
    Server_Bookmarks_Client.prototype.processBookmarks_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param contentEntityId (optional)
     * @deprecated
     */
    Server_Bookmarks_Client.prototype.bookmarks_byContentEntity_post_V1 = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/by-content-entity?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBookmarks_byContentEntity_post_V1(_response);
        });
    };
    Server_Bookmarks_Client.prototype.processBookmarks_byContentEntity_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param containerId (optional)
     */
    Server_Bookmarks_Client.prototype.bookmarks_byContainerContentEntityId_get_V1 = function (x_app_language_id, containerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/by-container-content-entity-id?";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "ContainerId=" + encodeURIComponent("" + containerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBookmarks_byContainerContentEntityId_get_V1(_response);
        });
    };
    Server_Bookmarks_Client.prototype.processBookmarks_byContainerContentEntityId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Bookmarks_Client.prototype.bookmarks_ids_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBookmarks_ids_get_V1(_response);
        });
    };
    Server_Bookmarks_Client.prototype.processBookmarks_ids_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Bookmarks_Client;
}());
exports.Server_Bookmarks_Client = Server_Bookmarks_Client;
var Server_Collections_Client = /** @class */ (function () {
    function Server_Collections_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 28.1) (Scope: Dashboard)
     */
    Server_Collections_Client.prototype.collections_assignItem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/assign-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollections_assignItem_post_V1(_response);
        });
    };
    Server_Collections_Client.prototype.processCollections_assignItem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.24, 28.1) (Scope: Dashboard)
     */
    Server_Collections_Client.prototype.collections_assignItemAdmin_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/assign-item-admin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollections_assignItemAdmin_post_V1(_response);
        });
    };
    Server_Collections_Client.prototype.processCollections_assignItemAdmin_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 28.4) (Scope: Dashboard)
     */
    Server_Collections_Client.prototype.collections_unAssignItem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/un-assign-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollections_unAssignItem_post_V1(_response);
        });
    };
    Server_Collections_Client.prototype.processCollections_unAssignItem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.24, 28.4) (Scope: Dashboard)
     */
    Server_Collections_Client.prototype.collections_unAssignItemAdmin_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/un-assign-item-admin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollections_unAssignItemAdmin_post_V1(_response);
        });
    };
    Server_Collections_Client.prototype.processCollections_unAssignItemAdmin_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 28.5) (Scope: Dashboard)
     */
    Server_Collections_Client.prototype.collections_orderItem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/order-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollections_orderItem_post_V1(_response);
        });
    };
    Server_Collections_Client.prototype.processCollections_orderItem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.24, 28.5) (Scope: Dashboard)
     */
    Server_Collections_Client.prototype.collections_orderItemAdmn_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/order-item-admn";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollections_orderItemAdmn_post_V1(_response);
        });
    };
    Server_Collections_Client.prototype.processCollections_orderItemAdmn_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 28.2) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Collections_Client.prototype.collections_countChildren_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/count-children";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollections_countChildren_post_V1(_response);
        });
    };
    Server_Collections_Client.prototype.processCollections_countChildren_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Collections_Client;
}());
exports.Server_Collections_Client = Server_Collections_Client;
var Server_ContentEntityTexts_Client = /** @class */ (function () {
    function Server_ContentEntityTexts_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 70.4) (Scope: Dashboard)
     */
    Server_ContentEntityTexts_Client.prototype.contentEntityTexts_addText_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/add-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTexts_addText_post_V1(_response);
        });
    };
    Server_ContentEntityTexts_Client.prototype.processContentEntityTexts_addText_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 70.5) (Scope: Dashboard)
     */
    Server_ContentEntityTexts_Client.prototype.contentEntityTexts_removeText_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/remove-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTexts_removeText_post_V1(_response);
        });
    };
    Server_ContentEntityTexts_Client.prototype.processContentEntityTexts_removeText_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 70.6) (Scope: Dashboard)
     */
    Server_ContentEntityTexts_Client.prototype.contentEntityTexts_setDefaultText_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/set-default-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTexts_setDefaultText_post_V1(_response);
        });
    };
    Server_ContentEntityTexts_Client.prototype.processContentEntityTexts_setDefaultText_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 70.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param includeNotDefault (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntityTexts_Client.prototype.contentEntityTexts_get_V1 = function (x_app_language_id, contentEntityId, includeNotDefault, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (includeNotDefault === null)
            throw new Error("The parameter 'includeNotDefault' cannot be null.");
        else if (includeNotDefault !== undefined)
            url_ += "IncludeNotDefault=" + encodeURIComponent("" + includeNotDefault) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTexts_get_V1(_response);
        });
    };
    Server_ContentEntityTexts_Client.prototype.processContentEntityTexts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 70.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntityTexts_Client.prototype.contentEntityTexts_updateText_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/update-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTexts_updateText_put_V1(_response);
        });
    };
    Server_ContentEntityTexts_Client.prototype.processContentEntityTexts_updateText_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentEntityTexts_Client;
}());
exports.Server_ContentEntityTexts_Client = Server_ContentEntityTexts_Client;
var Server_ContentSubscriptions_Client = /** @class */ (function () {
    function Server_ContentSubscriptions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentSubscriptions_Client.prototype.contentSubscriptions_add_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentSubscriptions/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentSubscriptions_add_post_V1(_response);
        });
    };
    Server_ContentSubscriptions_Client.prototype.processContentSubscriptions_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentSubscriptions_Client.prototype.contentSubscriptions_remove_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentSubscriptions/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentSubscriptions_remove_post_V1(_response);
        });
    };
    Server_ContentSubscriptions_Client.prototype.processContentSubscriptions_remove_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_ContentSubscriptions_Client.prototype.contentSubscriptions_removeMulti_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentSubscriptions/remove-multi";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentSubscriptions_removeMulti_post_V1(_response);
        });
    };
    Server_ContentSubscriptions_Client.prototype.processContentSubscriptions_removeMulti_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_ContentSubscriptions_Client.prototype.contentSubscriptions_ids_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentSubscriptions/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentSubscriptions_ids_get_V1(_response);
        });
    };
    Server_ContentSubscriptions_Client.prototype.processContentSubscriptions_ids_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param contentEntityIds (optional)
     */
    Server_ContentSubscriptions_Client.prototype.contentSubscriptions_byContentEntities_get_V1 = function (contentEntityIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentSubscriptions/by-content-entities?";
        if (contentEntityIds !== undefined && contentEntityIds !== null)
            contentEntityIds && contentEntityIds.forEach(function (item) { url_ += "ContentEntityIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentSubscriptions_byContentEntities_get_V1(_response);
        });
    };
    Server_ContentSubscriptions_Client.prototype.processContentSubscriptions_byContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param contentEntityId (optional)
     */
    Server_ContentSubscriptions_Client.prototype.contentSubscriptions_itemState_get_V1 = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentSubscriptions/item-state?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentSubscriptions_itemState_get_V1(_response);
        });
    };
    Server_ContentSubscriptions_Client.prototype.processContentSubscriptions_itemState_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentSubscriptions_Client;
}());
exports.Server_ContentSubscriptions_Client = Server_ContentSubscriptions_Client;
var Server_DailyContent_Client = /** @class */ (function () {
    function Server_DailyContent_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 83.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_DailyContent_Client.prototype.dailyContent_addDate_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent/add-date";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDailyContent_addDate_post_V1(_response);
        });
    };
    Server_DailyContent_Client.prototype.processDailyContent_addDate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 83.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_DailyContent_Client.prototype.dailyContent_add_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDailyContent_add_post_V1(_response);
        });
    };
    Server_DailyContent_Client.prototype.processDailyContent_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 83.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param startingFrom (optional)
     * @param typeName (optional)
     */
    Server_DailyContent_Client.prototype.dailyContent_get_V1 = function (x_app_language_id, startingFrom, typeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent?";
        if (startingFrom !== undefined && startingFrom !== null)
            url_ += "StartingFrom=" + encodeURIComponent("" + startingFrom) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDailyContent_get_V1(_response);
        });
    };
    Server_DailyContent_Client.prototype.processDailyContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_DailyContent_Client.prototype.dailyContent_timer_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent/timer?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDailyContent_timer_get_V1(_response);
        });
    };
    Server_DailyContent_Client.prototype.processDailyContent_timer_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_DailyContent_Client;
}());
exports.Server_DailyContent_Client = Server_DailyContent_Client;
var Server_DynamicLinks_Client = /** @class */ (function () {
    function Server_DynamicLinks_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param x_app_language_id (optional) Language Id
     */
    Server_DynamicLinks_Client.prototype.dynamicLinks_content_ContentEntityId_get_V1 = function (contentEntityId, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DynamicLinks/content/{ContentEntityId}";
        if (contentEntityId === undefined || contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' must be defined.");
        url_ = url_.replace("{ContentEntityId}", encodeURIComponent("" + contentEntityId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDynamicLinks_content_ContentEntityId_get_V1(_response);
        });
    };
    Server_DynamicLinks_Client.prototype.processDynamicLinks_content_ContentEntityId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_DynamicLinks_Client;
}());
exports.Server_DynamicLinks_Client = Server_DynamicLinks_Client;
var Server_Followings_Client = /** @class */ (function () {
    function Server_Followings_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Followings_Client.prototype.followings_add_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFollowings_add_post_V1(_response);
        });
    };
    Server_Followings_Client.prototype.processFollowings_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Followings_Client.prototype.followings_addMultiple_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/add-multiple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFollowings_addMultiple_post_V1(_response);
        });
    };
    Server_Followings_Client.prototype.processFollowings_addMultiple_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Followings_Client.prototype.followings_remove_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFollowings_remove_post_V1(_response);
        });
    };
    Server_Followings_Client.prototype.processFollowings_remove_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Followings_Client.prototype.followings_removeMulti_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/remove-multi";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFollowings_removeMulti_post_V1(_response);
        });
    };
    Server_Followings_Client.prototype.processFollowings_removeMulti_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Followings_Client.prototype.followings_ids_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFollowings_ids_get_V1(_response);
        });
    };
    Server_Followings_Client.prototype.processFollowings_ids_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param contentEntityIds (optional)
     */
    Server_Followings_Client.prototype.followings_byContentEntities_get_V1 = function (contentEntityIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/by-content-entities?";
        if (contentEntityIds !== undefined && contentEntityIds !== null)
            contentEntityIds && contentEntityIds.forEach(function (item) { url_ += "ContentEntityIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFollowings_byContentEntities_get_V1(_response);
        });
    };
    Server_Followings_Client.prototype.processFollowings_byContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Followings_Client;
}());
exports.Server_Followings_Client = Server_Followings_Client;
var Server_FullAudioTask_Client = /** @class */ (function () {
    function Server_FullAudioTask_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 149.0) (Scope: ThirdPartyService)
     * @param x_app_language_id (optional) Language Id
     */
    Server_FullAudioTask_Client.prototype.fullAudioTask_getFullAudioTask_post_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/FullAudioTask/get-full-audio-task";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFullAudioTask_getFullAudioTask_post_V1(_response);
        });
    };
    Server_FullAudioTask_Client.prototype.processFullAudioTask_getFullAudioTask_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 149.1) (Scope: ThirdPartyService)
     * @param x_app_language_id (optional) Language Id
     */
    Server_FullAudioTask_Client.prototype.fullAudioTask_completeFullAudioTask_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/FullAudioTask/complete-full-audio-task";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFullAudioTask_completeFullAudioTask_post_V1(_response);
        });
    };
    Server_FullAudioTask_Client.prototype.processFullAudioTask_completeFullAudioTask_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_FullAudioTask_Client;
}());
exports.Server_FullAudioTask_Client = Server_FullAudioTask_Client;
var Server_Goals_Client = /** @class */ (function () {
    function Server_Goals_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Goals_Client.prototype.goals_set_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_set_post_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processGoals_set_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Goals_Client.prototype.goals_reader_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals/reader";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_reader_get_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processGoals_reader_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 41.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Goals_Client.prototype.goals_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_post_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processGoals_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 41.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Goals_Client.prototype.goals_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_put_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processGoals_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Goals_Client.prototype.goals_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_get_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processGoals_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 41.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Goals_Client.prototype.goals_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_delete_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processGoals_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 41.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Goals_Client.prototype.goals_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_paginated_get_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processGoals_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 41.7) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Goals_Client.prototype.admin_Goals_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Goals/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Goals_multilingualById_get_V1(_response);
        });
    };
    Server_Goals_Client.prototype.processAdmin_Goals_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 41.1) (Scope: Dashboard)
     */
    Server_Goals_Client.prototype.admin_Goals_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Goals_post_V2(_response);
        });
    };
    Server_Goals_Client.prototype.processAdmin_Goals_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 41.2) (Scope: Dashboard)
     */
    Server_Goals_Client.prototype.admin_Goals_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Goals_put_V2(_response);
        });
    };
    Server_Goals_Client.prototype.processAdmin_Goals_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Goals_Client;
}());
exports.Server_Goals_Client = Server_Goals_Client;
var Server_Highlights_Client = /** @class */ (function () {
    function Server_Highlights_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Highlights_Client.prototype.highlights_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_post_V1(_response);
        });
    };
    Server_Highlights_Client.prototype.processHighlights_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_Highlights_Client.prototype.highlights_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_get_V1(_response);
        });
    };
    Server_Highlights_Client.prototype.processHighlights_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param id (optional)
     */
    Server_Highlights_Client.prototype.highlights_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_delete_V1(_response);
        });
    };
    Server_Highlights_Client.prototype.processHighlights_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param containerId (optional)
     */
    Server_Highlights_Client.prototype.highlights_byContainerId_get_V1 = function (x_app_language_id, containerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights/by-container-id?";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "ContainerId=" + encodeURIComponent("" + containerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_byContainerId_get_V1(_response);
        });
    };
    Server_Highlights_Client.prototype.processHighlights_byContainerId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Highlights_Client.prototype.highlights_paginated_get_V1 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights/paginated?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_paginated_get_V1(_response);
        });
    };
    Server_Highlights_Client.prototype.processHighlights_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Highlights_Client;
}());
exports.Server_Highlights_Client = Server_Highlights_Client;
var Server_Interests_Client = /** @class */ (function () {
    function Server_Interests_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Interests_Client.prototype.interests_set_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInterests_set_post_V1(_response);
        });
    };
    Server_Interests_Client.prototype.processInterests_set_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Interests_Client.prototype.interests_getAllInterests_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/get-all-interests";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInterests_getAllInterests_get_V1(_response);
        });
    };
    Server_Interests_Client.prototype.processInterests_getAllInterests_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Interests_Client.prototype.interests_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInterests_get_V1(_response);
        });
    };
    Server_Interests_Client.prototype.processInterests_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Interests_Client.prototype.interests_reader_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/reader";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInterests_reader_get_V1(_response);
        });
    };
    Server_Interests_Client.prototype.processInterests_reader_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Interests_Client.prototype.interests_readerSubcategories_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/reader-subcategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInterests_readerSubcategories_get_V1(_response);
        });
    };
    Server_Interests_Client.prototype.processInterests_readerSubcategories_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Interests_Client.prototype.interests_readerWithProgress_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/reader-with-progress";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInterests_readerWithProgress_get_V1(_response);
        });
    };
    Server_Interests_Client.prototype.processInterests_readerWithProgress_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Interests_Client;
}());
exports.Server_Interests_Client = Server_Interests_Client;
var Server_LandingPage_Client = /** @class */ (function () {
    function Server_LandingPage_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Web)
     */
    Server_LandingPage_Client.prototype.landingPage_getContentEntityTypes_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-content-entity-types";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getContentEntityTypes_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getContentEntityTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     */
    Server_LandingPage_Client.prototype.landingPage_getCategories_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-categories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getCategories_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getCategories_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeId (optional)
     * @param categoryId (optional)
     */
    Server_LandingPage_Client.prototype.landingPage_getContentEntitiesByCategory_get_V1 = function (x_app_language_id, contentEntityTypeId, categoryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-content-entities-by-category?";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getContentEntitiesByCategory_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getContentEntitiesByCategory_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     */
    Server_LandingPage_Client.prototype.landingPage_getCategoriesExplore_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-categories-explore";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getCategoriesExplore_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getCategoriesExplore_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     * @param categoryId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_LandingPage_Client.prototype.landingPage_getContentEntitiesByCategoryExplore_get_V1 = function (x_app_language_id, categoryId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-content-entities-by-category-explore?";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getContentEntitiesByCategoryExplore_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getContentEntitiesByCategoryExplore_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_LandingPage_Client.prototype.landingPage_getContentEntityById_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-content-entity-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getContentEntityById_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getContentEntityById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_LandingPage_Client.prototype.landingPage_getSimilarContentEntities_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-similar-content-entities?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getSimilarContentEntities_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getSimilarContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     */
    Server_LandingPage_Client.prototype.landingPage_getCategoriesExploreWithSlug_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-categories-explore-with-slug";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getCategoriesExploreWithSlug_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getCategoriesExploreWithSlug_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     * @param slug (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_LandingPage_Client.prototype.landingPage_getContentEntitiesByCategoryExploreWithSlug_get_V1 = function (x_app_language_id, slug, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-content-entities-by-category-explore-with-slug?";
        if (slug !== undefined && slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getContentEntitiesByCategoryExploreWithSlug_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getContentEntitiesByCategoryExploreWithSlug_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     * @param slug (optional)
     */
    Server_LandingPage_Client.prototype.landingPage_getContentEntityBySlug_get_V1 = function (x_app_language_id, slug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-content-entity-by-slug?";
        if (slug !== undefined && slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getContentEntityBySlug_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getContentEntityBySlug_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Web)
     * @param x_app_language_id (optional) Language Id
     * @param slug (optional)
     */
    Server_LandingPage_Client.prototype.landingPage_getSimilarContentEntitiesWithSlug_get_V1 = function (x_app_language_id, slug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/LandingPage/get-similar-content-entities-with-slug?";
        if (slug !== undefined && slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLandingPage_getSimilarContentEntitiesWithSlug_get_V1(_response);
        });
    };
    Server_LandingPage_Client.prototype.processLandingPage_getSimilarContentEntitiesWithSlug_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_LandingPage_Client;
}());
exports.Server_LandingPage_Client = Server_LandingPage_Client;
var Server_Narrators_Client = /** @class */ (function () {
    function Server_Narrators_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 68.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Narrators_Client.prototype.narrators_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_post_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processNarrators_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Narrators_Client.prototype.narrators_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_put_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processNarrators_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.0) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Narrators_Client.prototype.narrators_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_get_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processNarrators_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Narrators_Client.prototype.narrators_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_delete_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processNarrators_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Server_Narrators_Client.prototype.narrators_lookups_get_V1 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_lookups_get_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processNarrators_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.8) (Scope: Dashboard)
     */
    Server_Narrators_Client.prototype.narrators_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_datatable_post_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processNarrators_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.9) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_Narrators_Client.prototype.narrators_defaultByContentEntityId_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators/default-by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_defaultByContentEntityId_get_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processNarrators_defaultByContentEntityId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.0) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Narrators_Client.prototype.admin_Narrators_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Narrators/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Narrators_multilingualById_get_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processAdmin_Narrators_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.0) (Scope: Dashboard)
     * @param narratorIds (optional)
     */
    Server_Narrators_Client.prototype.admin_Narrators_sync_get_V1 = function (narratorIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Narrators/sync?";
        if (narratorIds !== undefined && narratorIds !== null)
            narratorIds && narratorIds.forEach(function (item) { url_ += "NarratorIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Narrators_sync_get_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processAdmin_Narrators_sync_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.0) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Narrators_Client.prototype.admin_Narrators_syncAll_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Narrators/sync-all?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Narrators_syncAll_get_V1(_response);
        });
    };
    Server_Narrators_Client.prototype.processAdmin_Narrators_syncAll_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.1) (Scope: Dashboard)
     */
    Server_Narrators_Client.prototype.admin_Narrators_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Narrators";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Narrators_post_V2(_response);
        });
    };
    Server_Narrators_Client.prototype.processAdmin_Narrators_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 68.2) (Scope: Dashboard)
     */
    Server_Narrators_Client.prototype.admin_Narrators_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Narrators";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Narrators_put_V2(_response);
        });
    };
    Server_Narrators_Client.prototype.processAdmin_Narrators_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Narrators_Client;
}());
exports.Server_Narrators_Client = Server_Narrators_Client;
var Server_PlaylistAllowedType_Client = /** @class */ (function () {
    function Server_PlaylistAllowedType_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 66.1) (Scope: Dashboard)
     */
    Server_PlaylistAllowedType_Client.prototype.playlistAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PlaylistAllowedType";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylistAllowedType_post_V1(_response);
        });
    };
    Server_PlaylistAllowedType_Client.prototype.processPlaylistAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 66.0) (Scope: Dashboard)
     */
    Server_PlaylistAllowedType_Client.prototype.playlistAllowedType_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PlaylistAllowedType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylistAllowedType_get_V1(_response);
        });
    };
    Server_PlaylistAllowedType_Client.prototype.processPlaylistAllowedType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 66.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_PlaylistAllowedType_Client.prototype.playlistAllowedType_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PlaylistAllowedType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylistAllowedType_delete_V1(_response);
        });
    };
    Server_PlaylistAllowedType_Client.prototype.processPlaylistAllowedType_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_PlaylistAllowedType_Client;
}());
exports.Server_PlaylistAllowedType_Client = Server_PlaylistAllowedType_Client;
var Server_Playlists_Client = /** @class */ (function () {
    function Server_Playlists_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Playlists_Client.prototype.playlists_add_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_add_post_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Playlists_Client.prototype.playlists_setCurrentItem_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/set-current-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_setCurrentItem_post_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_setCurrentItem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Playlists_Client.prototype.playlists_arrange_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/arrange";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_arrange_post_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_arrange_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Playlists_Client.prototype.playlists_remove_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_remove_post_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_remove_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Playlists_Client.prototype.playlists_removeMultiple_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/remove-multiple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_removeMultiple_post_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_removeMultiple_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Playlists_Client.prototype.playlists_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_post_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Playlists_Client.prototype.playlists_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_put_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     */
    Server_Playlists_Client.prototype.playlists_get_V1 = function (x_app_language_id, sortBy, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_get_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param id (optional)
     */
    Server_Playlists_Client.prototype.playlists_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_delete_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Playlists_Client.prototype.playlists_paginated_get_V1 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/paginated?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_paginated_get_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param playlistId (optional)
     */
    Server_Playlists_Client.prototype.playlists_itemIds_get_V1 = function (x_app_language_id, playlistId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/item-ids?";
        if (playlistId === null)
            throw new Error("The parameter 'playlistId' cannot be null.");
        else if (playlistId !== undefined)
            url_ += "PlaylistId=" + encodeURIComponent("" + playlistId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_itemIds_get_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_itemIds_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_Playlists_Client.prototype.playlists_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_byId_get_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Playlists_Client.prototype.playlists_moveToPlaylist_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/move-to-playlist";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_moveToPlaylist_put_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_moveToPlaylist_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Playlists_Client.prototype.playlists_arrangePlaylists_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/arrange-playlists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_arrangePlaylists_post_V1(_response);
        });
    };
    Server_Playlists_Client.prototype.processPlaylists_arrangePlaylists_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Playlists_Client;
}());
exports.Server_Playlists_Client = Server_Playlists_Client;
var Server_PublishersAnalysis_Client = /** @class */ (function () {
    function Server_PublishersAnalysis_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_durationConsumption_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/duration-consumption?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_durationConsumption_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_durationConsumption_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_uniqueConsumedUsers_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/unique-consumed-users?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_uniqueConsumedUsers_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_uniqueConsumedUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_usedCredits_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/used-credits?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_usedCredits_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_usedCredits_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_completedContent_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/completed-content?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_completedContent_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_completedContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param limit (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_consumptionByCountry_get_V1 = function (fromDate, toDate, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/consumption-by-country?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_consumptionByCountry_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_consumptionByCountry_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param limit (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_consumptionByCategory_get_V1 = function (fromDate, toDate, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/consumption-by-category?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_consumptionByCategory_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_consumptionByCategory_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param limit (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_mostListened_get_V1 = function (fromDate, toDate, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/most-listened?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_mostListened_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_mostListened_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param limit (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_mostConsumed_get_V1 = function (fromDate, toDate, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/most-consumed?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_mostConsumed_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_mostConsumed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param searchKey (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_content_get_V1 = function (searchKey, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/content?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_content_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_content_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Web)
     * @param id (optional)
     */
    Server_PublishersAnalysis_Client.prototype.publishersAnalysis_contentById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/publisher/v1/PublishersAnalysis/content-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublishersAnalysis_contentById_get_V1(_response);
        });
    };
    Server_PublishersAnalysis_Client.prototype.processPublishersAnalysis_contentById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_PublishersAnalysis_Client;
}());
exports.Server_PublishersAnalysis_Client = Server_PublishersAnalysis_Client;
var Server_Quote_Client = /** @class */ (function () {
    function Server_Quote_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 57.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Quote_Client.prototype.quote_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_post_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 57.3) (Scope: Dashboard)
     * @deprecated
     */
    Server_Quote_Client.prototype.quote_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_put_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_Quote_Client.prototype.quote_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_get_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 57.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Quote_Client.prototype.quote_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_delete_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 57.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Quote_Client.prototype.quote_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_paginated_get_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Quote_Client.prototype.quote_user_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/user";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_user_get_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_user_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_Quote_Client.prototype.quote_contentEntity_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/content-entity?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_contentEntity_get_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_contentEntity_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_Quote_Client.prototype.quote_addToFavorite_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/add-to-favorite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_addToFavorite_post_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_addToFavorite_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     */
    Server_Quote_Client.prototype.quote_removeFromFavorite_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/remove-from-favorite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_removeFromFavorite_post_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processQuote_removeFromFavorite_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 57.9)
     * @param id (optional)
     */
    Server_Quote_Client.prototype.admin_Quote_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Quote/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Quote_multilingualById_get_V1(_response);
        });
    };
    Server_Quote_Client.prototype.processAdmin_Quote_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 57.2) (Scope: Dashboard)
     */
    Server_Quote_Client.prototype.admin_Quote_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Quote";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Quote_post_V2(_response);
        });
    };
    Server_Quote_Client.prototype.processAdmin_Quote_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 57.3) (Scope: Dashboard)
     */
    Server_Quote_Client.prototype.admin_Quote_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Quote";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Quote_put_V2(_response);
        });
    };
    Server_Quote_Client.prototype.processAdmin_Quote_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Quote_Client;
}());
exports.Server_Quote_Client = Server_Quote_Client;
var Server_Rating_Client = /** @class */ (function () {
    function Server_Rating_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Server_Rating_Client.prototype.rating_rate_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating/rate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_rate_post_V1(_response);
        });
    };
    Server_Rating_Client.prototype.processRating_rate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 49.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Rating_Client.prototype.rating_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_post_V1(_response);
        });
    };
    Server_Rating_Client.prototype.processRating_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 49.3) (Scope: Dashboard)
     * @deprecated
     */
    Server_Rating_Client.prototype.rating_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_put_V1(_response);
        });
    };
    Server_Rating_Client.prototype.processRating_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Server_Rating_Client.prototype.rating_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_get_V1(_response);
        });
    };
    Server_Rating_Client.prototype.processRating_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 49.4) (Scope: Dashboard)
     * @param id (optional)
     * @deprecated
     */
    Server_Rating_Client.prototype.rating_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_delete_V1(_response);
        });
    };
    Server_Rating_Client.prototype.processRating_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 49.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @deprecated
     */
    Server_Rating_Client.prototype.rating_paginated_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_paginated_get_V1(_response);
        });
    };
    Server_Rating_Client.prototype.processRating_paginated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Rating_Client.prototype.rating_rate_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/Rating/rate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_rate_post_V2(_response);
        });
    };
    Server_Rating_Client.prototype.processRating_rate_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Rating_Client;
}());
exports.Server_Rating_Client = Server_Rating_Client;
var Server_ReaderStatistics_Client = /** @class */ (function () {
    function Server_ReaderStatistics_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_ReaderStatistics_Client.prototype.readerStatistics_user_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderStatistics/user";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderStatistics_user_get_V1(_response);
        });
    };
    Server_ReaderStatistics_Client.prototype.processReaderStatistics_user_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param timeInWeek (optional)
     */
    Server_ReaderStatistics_Client.prototype.readerStatistics_userWeekly_get_V1 = function (timeInWeek, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderStatistics/user-weekly?";
        if (timeInWeek === null)
            throw new Error("The parameter 'timeInWeek' cannot be null.");
        else if (timeInWeek !== undefined)
            url_ += "TimeInWeek=" + encodeURIComponent("" + timeInWeek) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderStatistics_userWeekly_get_V1(_response);
        });
    };
    Server_ReaderStatistics_Client.prototype.processReaderStatistics_userWeekly_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ReaderStatistics_Client.prototype.readerStatistics_profile_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderStatistics/profile";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderStatistics_profile_get_V1(_response);
        });
    };
    Server_ReaderStatistics_Client.prototype.processReaderStatistics_profile_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param limit (optional)
     */
    Server_ReaderStatistics_Client.prototype.readerStatistics_topConsumedCategories_get_V1 = function (x_app_language_id, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderStatistics/top-consumed-categories?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderStatistics_topConsumedCategories_get_V1(_response);
        });
    };
    Server_ReaderStatistics_Client.prototype.processReaderStatistics_topConsumedCategories_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param input (optional)
     */
    Server_ReaderStatistics_Client.prototype.readerStatistics_creditInformation_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderStatistics/credit-information?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderStatistics_creditInformation_get_V1(_response);
        });
    };
    Server_ReaderStatistics_Client.prototype.processReaderStatistics_creditInformation_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ReaderStatistics_Client;
}());
exports.Server_ReaderStatistics_Client = Server_ReaderStatistics_Client;
var Server_Sessions_Client = /** @class */ (function () {
    function Server_Sessions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     */
    Server_Sessions_Client.prototype.sessions_addEvent_post_V1 = function (input, x_app_language_id, x_app_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/add-event";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSessions_addEvent_post_V1(_response);
        });
    };
    Server_Sessions_Client.prototype.processSessions_addEvent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Sessions_Client.prototype.sessions_markCompleted_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/mark-completed";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSessions_markCompleted_post_V1(_response);
        });
    };
    Server_Sessions_Client.prototype.processSessions_markCompleted_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Sessions_Client.prototype.sessions_allMyProgress_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/all-my-progress";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSessions_allMyProgress_post_V1(_response);
        });
    };
    Server_Sessions_Client.prototype.processSessions_allMyProgress_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Sessions_Client.prototype.sessions_myContentProgresses_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/my-content-progresses";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSessions_myContentProgresses_post_V1(_response);
        });
    };
    Server_Sessions_Client.prototype.processSessions_myContentProgresses_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @deprecated
     */
    Server_Sessions_Client.prototype.sessions_myContentCreditConsumption_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/my-content-credit-consumption";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSessions_myContentCreditConsumption_post_V1(_response);
        });
    };
    Server_Sessions_Client.prototype.processSessions_myContentCreditConsumption_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Sessions_Client.prototype.sessions_myContentProgress_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/my-content-progress";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSessions_myContentProgress_post_V1(_response);
        });
    };
    Server_Sessions_Client.prototype.processSessions_myContentProgress_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Sessions_Client.prototype.sessions_resetProgress_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/reset-progress";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSessions_resetProgress_put_V1(_response);
        });
    };
    Server_Sessions_Client.prototype.processSessions_resetProgress_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Sessions_Client;
}());
exports.Server_Sessions_Client = Server_Sessions_Client;
var Server_Tests_Client = /** @class */ (function () {
    function Server_Tests_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth)
     * @param input (optional)
     * @param number (optional)
     */
    Server_Tests_Client.prototype.tests_test_post_V1 = function (input, number, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/test?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_test_post_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_test_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Server_Tests_Client.prototype.tests_convertToMarkdown_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/convert-to-markdown";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_convertToMarkdown_post_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_convertToMarkdown_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param userId (optional)
     */
    Server_Tests_Client.prototype.tests_getPlans_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/get-plans?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_getPlans_get_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_getPlans_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     * @param userId (optional)
     * @param contentEntityId (optional)
     * @param title (optional)
     * @param body (optional)
     */
    Server_Tests_Client.prototype.tests_testNotificationSendingForUser_get_V1 = function (userId, contentEntityId, title, body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/test-notification-sending-for-user?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (body !== undefined && body !== null)
            url_ += "body=" + encodeURIComponent("" + body) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_testNotificationSendingForUser_get_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_testNotificationSendingForUser_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     * @param userId (optional)
     * @param streak (optional)
     */
    Server_Tests_Client.prototype.tests_sendStreakNotification_get_V1 = function (userId, streak, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/send-streak-notification?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (streak === null)
            throw new Error("The parameter 'streak' cannot be null.");
        else if (streak !== undefined)
            url_ += "streak=" + encodeURIComponent("" + streak) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_sendStreakNotification_get_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_sendStreakNotification_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     * @param userId (optional)
     * @param title (optional)
     * @param contentEntityId (optional)
     * @param typeId (optional)
     */
    Server_Tests_Client.prototype.tests_sendChallengeCompletedNotification_get_V1 = function (userId, title, contentEntityId, typeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/send-challenge-completed-notification?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_sendChallengeCompletedNotification_get_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_sendChallengeCompletedNotification_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     * @param userName (optional)
     * @param skillName (optional)
     * @param date (optional)
     * @param languageId (optional)
     * @param groupImageId (optional)
     */
    Server_Tests_Client.prototype.tests_getCertificate_get_V1 = function (userName, skillName, date, languageId, groupImageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/get-certificate?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (skillName !== undefined && skillName !== null)
            url_ += "skillName=" + encodeURIComponent("" + skillName) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (groupImageId === null)
            throw new Error("The parameter 'groupImageId' cannot be null.");
        else if (groupImageId !== undefined)
            url_ += "groupImageId=" + encodeURIComponent("" + groupImageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_getCertificate_get_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_getCertificate_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     */
    Server_Tests_Client.prototype.tests_updateContent_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/update-content";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_updateContent_post_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_updateContent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     * @param contentEntityId (optional)
     */
    Server_Tests_Client.prototype.tests_getContentById_get_V1 = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/get-content-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTests_getContentById_get_V1(_response);
        });
    };
    Server_Tests_Client.prototype.processTests_getContentById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Tests_Client;
}());
exports.Server_Tests_Client = Server_Tests_Client;
var Server_UserContentUsageHistory_Client = /** @class */ (function () {
    function Server_UserContentUsageHistory_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     */
    Server_UserContentUsageHistory_Client.prototype.userContentUsageHistory_consume_post_V1 = function (x_app_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/UserContentUsageHistory/consume";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserContentUsageHistory_consume_post_V1(_response);
        });
    };
    Server_UserContentUsageHistory_Client.prototype.processUserContentUsageHistory_consume_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     */
    Server_UserContentUsageHistory_Client.prototype.userContentUsageHistory_restore_post_V1 = function (x_app_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/UserContentUsageHistory/restore";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserContentUsageHistory_restore_post_V1(_response);
        });
    };
    Server_UserContentUsageHistory_Client.prototype.processUserContentUsageHistory_restore_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_UserContentUsageHistory_Client.prototype.userContentUsageHistory_consecutiveConsumptionDays_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/UserContentUsageHistory/consecutive-consumption-days?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserContentUsageHistory_consecutiveConsumptionDays_get_V1(_response);
        });
    };
    Server_UserContentUsageHistory_Client.prototype.processUserContentUsageHistory_consecutiveConsumptionDays_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_UserContentUsageHistory_Client.prototype.userContentUsageHistory_currentConsecutiveConsumptionDaysCount_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/UserContentUsageHistory/current-consecutive-consumption-days-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserContentUsageHistory_currentConsecutiveConsumptionDaysCount_get_V1(_response);
        });
    };
    Server_UserContentUsageHistory_Client.prototype.processUserContentUsageHistory_currentConsecutiveConsumptionDaysCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_UserContentUsageHistory_Client.prototype.userContentUsageHistory_profileStreakStats_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/UserContentUsageHistory/profile-streak-stats";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserContentUsageHistory_profileStreakStats_get_V1(_response);
        });
    };
    Server_UserContentUsageHistory_Client.prototype.processUserContentUsageHistory_profileStreakStats_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_UserContentUsageHistory_Client;
}());
exports.Server_UserContentUsageHistory_Client = Server_UserContentUsageHistory_Client;
var Server_WajeezRSSFeed_Client = /** @class */ (function () {
    function Server_WajeezRSSFeed_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 151.0) (Scope: Web)
     * @param languageId (optional)
     */
    Server_WajeezRSSFeed_Client.prototype.wajeezRSSFeed_id_get_V1 = function (id, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/WajeezRSSFeed/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (languageId !== undefined && languageId !== null)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWajeezRSSFeed_id_get_V1(_response);
        });
    };
    Server_WajeezRSSFeed_Client.prototype.processWajeezRSSFeed_id_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 151.0) (Scope: Web)
     * @param languageId (optional)
     */
    Server_WajeezRSSFeed_Client.prototype.wajeezRSSFeed_id_head_V1 = function (id, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/WajeezRSSFeed/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (languageId !== undefined && languageId !== null)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWajeezRSSFeed_id_head_V1(_response);
        });
    };
    Server_WajeezRSSFeed_Client.prototype.processWajeezRSSFeed_id_head_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_WajeezRSSFeed_Client;
}());
exports.Server_WajeezRSSFeed_Client = Server_WajeezRSSFeed_Client;
var Server_ContentEntities_Client = /** @class */ (function () {
    function Server_ContentEntities_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 27.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeNameSearchText (optional)
     * @param contentItemType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_get_V1 = function (x_app_language_id, contentEntityTypeNameSearchText, contentItemType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities?";
        if (contentEntityTypeNameSearchText !== undefined && contentEntityTypeNameSearchText !== null)
            url_ += "ContentEntityTypeNameSearchText=" + encodeURIComponent("" + contentEntityTypeNameSearchText) + "&";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_ContentEntities_Client.prototype.contentEntities_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.5) (Scope: Dashboard)
     * @deprecated
     */
    Server_ContentEntities_Client.prototype.contentEntities_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.23) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_setAdminOrder_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/set-admin-order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_setAdminOrder_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_setAdminOrder_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_byType_get_V1 = function (x_app_language_id, contentEntityTypeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-type?";
        if (contentEntityTypeName !== undefined && contentEntityTypeName !== null)
            url_ += "ContentEntityTypeName=" + encodeURIComponent("" + contentEntityTypeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_byType_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_byType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_ContentEntities_Client.prototype.contentEntities_byType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_byType_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_byType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_byId_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_byId_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param narratorId (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_itemsById_get_V1 = function (x_app_language_id, contentEntityId, narratorId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/items-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (narratorId !== undefined && narratorId !== null)
            url_ += "NarratorId=" + encodeURIComponent("" + narratorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_itemsById_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_itemsById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_detailsById_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/details-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_detailsById_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_detailsById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param playlistId (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_byPlaylist_get_V1 = function (x_app_language_id, playlistId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-playlist?";
        if (playlistId === null)
            throw new Error("The parameter 'playlistId' cannot be null.");
        else if (playlistId !== undefined)
            url_ += "PlaylistId=" + encodeURIComponent("" + playlistId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_byPlaylist_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_byPlaylist_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param playlistId (optional)
     * @param contentEntityId (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_nextByPlaylist_get_V1 = function (x_app_language_id, playlistId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/next-by-playlist?";
        if (playlistId === null)
            throw new Error("The parameter 'playlistId' cannot be null.");
        else if (playlistId !== undefined)
            url_ += "PlaylistId=" + encodeURIComponent("" + playlistId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_nextByPlaylist_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_nextByPlaylist_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param type (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_recommended_get_V1 = function (x_app_language_id, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/recommended?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_recommended_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_recommended_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_allMyFollowed_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/all-my-followed";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_allMyFollowed_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_allMyFollowed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myFollowed_get_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-followed?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myFollowed_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myFollowed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myDownloaded_get_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-downloaded?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myDownloaded_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myDownloaded_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myRedeemed_get_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-redeemed?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myRedeemed_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myRedeemed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_allMyBookmarked_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/all-my-bookmarked";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_allMyBookmarked_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_allMyBookmarked_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myBookmarked_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-bookmarked?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myBookmarked_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myBookmarked_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myStarted_get_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-started?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myStarted_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myStarted_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myConsumed_get_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-consumed?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myConsumed_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myConsumed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myCompleted_get_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-completed?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myCompleted_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myCompleted_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myBookmarkedContainer_get_V1 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-bookmarked-container?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myBookmarkedContainer_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myBookmarkedContainer_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_myHighlightedContainer_get_V1 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-highlighted-container?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_myHighlightedContainer_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_myHighlightedContainer_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_libraryCount_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/library-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_libraryCount_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_libraryCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_b2bLibraryCount_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/b2b-library-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_b2bLibraryCount_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_b2bLibraryCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 28.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contenteEntityId (optional)
     * @param contenteEntityType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_getCollection_get_V1 = function (x_app_language_id, contenteEntityId, contenteEntityType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/get-collection?";
        if (contenteEntityId === null)
            throw new Error("The parameter 'contenteEntityId' cannot be null.");
        else if (contenteEntityId !== undefined)
            url_ += "ContenteEntityId=" + encodeURIComponent("" + contenteEntityId) + "&";
        if (contenteEntityType !== undefined && contenteEntityType !== null)
            url_ += "ContenteEntityType=" + encodeURIComponent("" + contenteEntityType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_getCollection_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_getCollection_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contenteEntityId (optional)
     * @param contenteEntityType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_getCollectionWithMedia_get_V1 = function (x_app_language_id, contenteEntityId, contenteEntityType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/get-collection-with-media?";
        if (contenteEntityId === null)
            throw new Error("The parameter 'contenteEntityId' cannot be null.");
        else if (contenteEntityId !== undefined)
            url_ += "ContenteEntityId=" + encodeURIComponent("" + contenteEntityId) + "&";
        if (contenteEntityType !== undefined && contenteEntityType !== null)
            url_ += "ContenteEntityType=" + encodeURIComponent("" + contenteEntityType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_getCollectionWithMedia_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_getCollectionWithMedia_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contenteEntityId (optional)
     * @param contenteEntityType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_getParents_get_V1 = function (x_app_language_id, contenteEntityId, contenteEntityType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/get-parents?";
        if (contenteEntityId === null)
            throw new Error("The parameter 'contenteEntityId' cannot be null.");
        else if (contenteEntityId !== undefined)
            url_ += "ContenteEntityId=" + encodeURIComponent("" + contenteEntityId) + "&";
        if (contenteEntityType !== undefined && contenteEntityType !== null)
            url_ += "ContenteEntityType=" + encodeURIComponent("" + contenteEntityType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_getParents_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_getParents_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param country (optional) 3 Digit Country Code
     */
    Server_ContentEntities_Client.prototype.contentEntities_bySelectors_post_V1 = function (input, x_app_language_id, country, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-selectors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "country": country !== undefined && country !== null ? "" + country : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_bySelectors_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_bySelectors_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_nextBySelectors_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/next-by-selectors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_nextBySelectors_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_nextBySelectors_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_next_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/next";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_next_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_next_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param typeName (optional)
     * @param types (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @deprecated
     */
    Server_ContentEntities_Client.prototype.contentEntities_search_get_V1 = function (x_app_language_id, searchText, typeName, types, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(function (item) { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_search_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_search_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param typeName (optional)
     * @param types (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_searchTracked_get_V1 = function (x_app_language_id, searchText, typeName, types, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/search-tracked?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(function (item) { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_searchTracked_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_searchTracked_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param numberOfResults (optional)
     * @param typeName (optional)
     * @deprecated
     */
    Server_ContentEntities_Client.prototype.contentEntities_topSearches_get_V1 = function (x_app_language_id, numberOfResults, typeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/top-searches?";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "NumberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_topSearches_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_topSearches_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.19) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.contentEntities_updatePlan_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/update-plan";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_updatePlan_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_updatePlan_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.21) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_lookups_get_V1 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_lookups_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.22) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_lookups_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_lookups_datatable_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_lookups_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.24) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_publish_state_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/publish/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_publish_state_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_publish_state_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.32) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_publish_expectedDate_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/publish/expected-date";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_publish_expectedDate_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_publish_expectedDate_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.24) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_multiplePublish_state_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/multiple-publish/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_multiplePublish_state_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_multiplePublish_state_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.25) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_publish_date_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/publish/date";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_publish_date_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_publish_date_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.26) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_withAuthor_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/with-author/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_withAuthor_datatable_post_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_withAuthor_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.28) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.contentEntities_setViewCount_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/set-view-count";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_setViewCount_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_setViewCount_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_badges_get_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/badges?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_badges_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_badges_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_getMagicContent_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/get-magic-content";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_getMagicContent_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_getMagicContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntities_Client.prototype.contentEntities_onboardingGetUserRandomContentEntities_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/onboarding-get-user-random-content-entities";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_onboardingGetUserRandomContentEntities_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_onboardingGetUserRandomContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param followedInterestIds (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_onboardingGetRandomContentEntities_get_V1 = function (x_app_language_id, followedInterestIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/onboarding-get-random-content-entities?";
        if (followedInterestIds !== undefined && followedInterestIds !== null)
            followedInterestIds && followedInterestIds.forEach(function (item) { url_ += "FollowedInterestIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_onboardingGetRandomContentEntities_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_onboardingGetRandomContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param structureName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_search_get_V1_1 = function (x_app_language_id, searchText, structureName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1.1/ContentEntities/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (structureName !== undefined && structureName !== null)
            url_ += "StructureName=" + encodeURIComponent("" + structureName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_search_get_V1_1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_search_get_V1_1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param numberOfResults (optional)
     * @param structureName (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_topSearches_get_V1_1 = function (x_app_language_id, numberOfResults, structureName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1.1/ContentEntities/top-searches?";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "NumberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (structureName !== undefined && structureName !== null)
            url_ += "StructureName=" + encodeURIComponent("" + structureName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_topSearches_get_V1_1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_topSearches_get_V1_1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param narratorId (optional)
     */
    Server_ContentEntities_Client.prototype.contentEntities_itemsById_get_V2 = function (x_app_language_id, contentEntityId, narratorId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/ContentEntities/items-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (narratorId !== undefined && narratorId !== null)
            url_ += "NarratorId=" + encodeURIComponent("" + narratorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_itemsById_get_V2(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processContentEntities_itemsById_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param typeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_search_get_V1 = function (x_app_language_id, searchText, typeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_search_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_search_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.3) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_delete_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_delete_delete_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_delete_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.31) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_setTags_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/set-tags";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_setTags_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_setTags_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.0) (Scope: Dashboard)
     * @param contentEntityId (optional)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_tags_get_V1 = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/tags?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_tags_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_tags_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.0) (Scope: Dashboard)
     * @param contentEntityId (optional)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_multilingualById_get_V1 = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/multilingual-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_multilingualById_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.0) (Scope: Dashboard)
     * @param contentEntityIds (optional)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_sync_get_V1 = function (contentEntityIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/sync?";
        if (contentEntityIds !== undefined && contentEntityIds !== null)
            contentEntityIds && contentEntityIds.forEach(function (item) { url_ += "ContentEntityIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_sync_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_sync_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.0) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_syncAll_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/sync-all?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_syncAll_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_syncAll_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.33) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_setBadge_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/set-badge";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_setBadge_put_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_setBadge_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_badges_get_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/badges?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_badges_get_V1(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_badges_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.5) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/ContentEntities";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_post_V2(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.2) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/ContentEntities";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_put_V2(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 27.1) (Scope: Dashboard)
     */
    Server_ContentEntities_Client.prototype.admin_ContentEntities_byType_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/ContentEntities/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntities_byType_post_V2(_response);
        });
    };
    Server_ContentEntities_Client.prototype.processAdmin_ContentEntities_byType_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentEntities_Client;
}());
exports.Server_ContentEntities_Client = Server_ContentEntities_Client;
var Server_ContentEntityTypes_Client = /** @class */ (function () {
    function Server_ContentEntityTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 36.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentItemType (optional)
     * @param name (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_get_V1 = function (x_app_language_id, contentItemType, name, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes?";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_lookups_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/lookups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_lookups_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_lookupsWithFields_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/lookups-with-fields";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_lookupsWithFields_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_lookupsWithFields_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeId (optional)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_byId_get_V1 = function (x_app_language_id, contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/by-id?";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_byId_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeName (optional)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_byType_get_V1 = function (x_app_language_id, contentEntityTypeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/by-type?";
        if (contentEntityTypeName !== undefined && contentEntityTypeName !== null)
            url_ += "ContentEntityTypeName=" + encodeURIComponent("" + contentEntityTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_byType_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_byType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.12) (Scope: Dashboard)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_setNames_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/set-names";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_setNames_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_setNames_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.13) (Scope: Dashboard)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_setOrder_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/set-order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_setOrder_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_setOrder_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.4) (Scope: Dashboard)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_addAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/add-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_addAllowedType_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_addAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.6) (Scope: Dashboard)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_removeAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/remove-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_removeAllowedType_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_removeAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.16) (Scope: Dashboard)
     */
    Server_ContentEntityTypes_Client.prototype.contentEntityTypes_editFlags_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/edit-flags";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_editFlags_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processContentEntityTypes_editFlags_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.2)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_put_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.3)
     * @param contentEntityTypeId (optional)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_multilingualById_get_V1 = function (contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/multilingual-by-id?";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_multilingualById_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.8)
     * @param contentEntityTypeName (optional)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_multilingualByType_get_V1 = function (contentEntityTypeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/multilingual-by-type?";
        if (contentEntityTypeName !== undefined && contentEntityTypeName !== null)
            url_ += "ContentEntityTypeName=" + encodeURIComponent("" + contentEntityTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_multilingualByType_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_multilingualByType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.11) (Scope: Dashboard)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_selectSortFactors_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/select-sort-factors";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_selectSortFactors_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_selectSortFactors_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.1) (Scope: Dashboard)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_addField_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/add-field";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_addField_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_addField_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.17)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_datatable_post_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.0)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_lookups_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/lookups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_lookups_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.3)
     * @param contentEntityTypeIds (optional)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_sync_get_V1 = function (contentEntityTypeIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/sync?";
        if (contentEntityTypeIds !== undefined && contentEntityTypeIds !== null)
            contentEntityTypeIds && contentEntityTypeIds.forEach(function (item) { url_ += "ContentEntityTypeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_sync_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_sync_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.3)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_syncAll_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypes/sync-all?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_syncAll_get_V1(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_syncAll_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 36.1)
     */
    Server_ContentEntityTypes_Client.prototype.admin_ContentEntityTypes_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/ContentEntityTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypes_post_V2(_response);
        });
    };
    Server_ContentEntityTypes_Client.prototype.processAdmin_ContentEntityTypes_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentEntityTypes_Client;
}());
exports.Server_ContentEntityTypes_Client = Server_ContentEntityTypes_Client;
var Server_Downloads_Client = /** @class */ (function () {
    function Server_Downloads_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Downloads_Client.prototype.downloads_add_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDownloads_add_post_V1(_response);
        });
    };
    Server_Downloads_Client.prototype.processDownloads_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Downloads_Client.prototype.downloads_remove_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDownloads_remove_post_V1(_response);
        });
    };
    Server_Downloads_Client.prototype.processDownloads_remove_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Downloads_Client.prototype.downloads_removeMulti_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/remove-multi";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDownloads_removeMulti_post_V1(_response);
        });
    };
    Server_Downloads_Client.prototype.processDownloads_removeMulti_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Downloads_Client.prototype.downloads_ids_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDownloads_ids_get_V1(_response);
        });
    };
    Server_Downloads_Client.prototype.processDownloads_ids_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Downloads_Client;
}());
exports.Server_Downloads_Client = Server_Downloads_Client;
var Server_Components_Client = /** @class */ (function () {
    function Server_Components_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 51.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeNameSearchText (optional)
     * @param contentItemType (optional)
     * @param usageType (optional)
     * @param withArchived (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Components_Client.prototype.components_get_V1 = function (x_app_language_id, componentTypeNameSearchText, contentItemType, usageType, withArchived, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components?";
        if (componentTypeNameSearchText !== undefined && componentTypeNameSearchText !== null)
            url_ += "ComponentTypeNameSearchText=" + encodeURIComponent("" + componentTypeNameSearchText) + "&";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (usageType !== undefined && usageType !== null)
            url_ += "UsageType=" + encodeURIComponent("" + usageType) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_get_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.5) (Scope: Dashboard)
     * @deprecated
     */
    Server_Components_Client.prototype.components_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_post_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_Components_Client.prototype.components_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_put_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Components_Client.prototype.components_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_delete_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param collectionComponentTypeId (optional)
     * @param collectionComponentTypeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Components_Client.prototype.components_allowedForCollectionComponentType_get_V1 = function (x_app_language_id, searchText, collectionComponentTypeId, collectionComponentTypeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/allowed-for-collection-component-type?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (collectionComponentTypeId === null)
            throw new Error("The parameter 'collectionComponentTypeId' cannot be null.");
        else if (collectionComponentTypeId !== undefined)
            url_ += "CollectionComponentTypeId=" + encodeURIComponent("" + collectionComponentTypeId) + "&";
        if (collectionComponentTypeName !== undefined && collectionComponentTypeName !== null)
            url_ += "CollectionComponentTypeName=" + encodeURIComponent("" + collectionComponentTypeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_allowedForCollectionComponentType_get_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_allowedForCollectionComponentType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Components_Client.prototype.components_byType_get_V1 = function (x_app_language_id, componentTypeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/by-type?";
        if (componentTypeName !== undefined && componentTypeName !== null)
            url_ += "ComponentTypeName=" + encodeURIComponent("" + componentTypeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_byType_get_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_byType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Components_Client.prototype.components_byType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_byType_post_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_byType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentId (optional)
     */
    Server_Components_Client.prototype.components_byId_get_V1 = function (x_app_language_id, componentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/by-id?";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "ComponentId=" + encodeURIComponent("" + componentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_byId_get_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.5) (Scope: Dashboard)
     */
    Server_Components_Client.prototype.components_clone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/clone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_clone_post_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_clone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.7) (Scope: Dashboard)
     */
    Server_Components_Client.prototype.components_setItemTemplate_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/set-item-template";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_setItemTemplate_post_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_setItemTemplate_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.8) (Scope: Dashboard)
     * @deprecated
     */
    Server_Components_Client.prototype.components_setSeeAllPage_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/set-see-all-page";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_setSeeAllPage_post_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_setSeeAllPage_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.9) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchKey (optional)
     * @param usageType (optional)
     * @param withArchived (optional)
     */
    Server_Components_Client.prototype.components_lookups_get_V1 = function (x_app_language_id, searchKey, usageType, withArchived, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/lookups?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (usageType !== undefined && usageType !== null)
            url_ += "UsageType=" + encodeURIComponent("" + usageType) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_lookups_get_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Components_Client.prototype.components_lookups_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_lookups_datatable_post_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_lookups_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeIds (optional)
     * @param searchKey (optional)
     */
    Server_Components_Client.prototype.components_lookups_byComponentTypes_get_V1 = function (x_app_language_id, componentTypeIds, searchKey, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/lookups/by-component-types?";
        if (componentTypeIds !== undefined && componentTypeIds !== null)
            componentTypeIds && componentTypeIds.forEach(function (item) { url_ += "ComponentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_lookups_byComponentTypes_get_V1(_response);
        });
    };
    Server_Components_Client.prototype.processComponents_lookups_byComponentTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.4) (Scope: Dashboard)
     * @param componentId (optional)
     */
    Server_Components_Client.prototype.admin_Components_multilingualById_get_V1 = function (componentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Components/multilingual-by-id?";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "ComponentId=" + encodeURIComponent("" + componentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Components_multilingualById_get_V1(_response);
        });
    };
    Server_Components_Client.prototype.processAdmin_Components_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.5) (Scope: Dashboard)
     */
    Server_Components_Client.prototype.admin_Components_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Components";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Components_post_V2(_response);
        });
    };
    Server_Components_Client.prototype.processAdmin_Components_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.2) (Scope: Dashboard)
     */
    Server_Components_Client.prototype.admin_Components_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Components";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Components_put_V2(_response);
        });
    };
    Server_Components_Client.prototype.processAdmin_Components_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 51.1) (Scope: Dashboard)
     */
    Server_Components_Client.prototype.admin_Components_byType_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Components/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Components_byType_post_V2(_response);
        });
    };
    Server_Components_Client.prototype.processAdmin_Components_byType_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Components_Client;
}());
exports.Server_Components_Client = Server_Components_Client;
var Server_ComponentTypes_Client = /** @class */ (function () {
    function Server_ComponentTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 52.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentItemType (optional)
     * @param usageType (optional)
     * @param name (optional)
     * @param withArchived (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_get_V1 = function (x_app_language_id, contentItemType, usageType, name, withArchived, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes?";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (usageType !== undefined && usageType !== null)
            url_ += "UsageType=" + encodeURIComponent("" + usageType) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_ComponentTypes_Client.prototype.componentTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_post_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.11) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_delete_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.0) (Scope: Dashboard)
     * @param componentTypeId (optional)
     * @param componentType (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_seed_get_V1 = function (componentTypeId, componentType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/seed?";
        if (componentTypeId !== undefined && componentTypeId !== null)
            url_ += "ComponentTypeId=" + encodeURIComponent("" + componentTypeId) + "&";
        if (componentType !== undefined && componentType !== null)
            url_ += "ComponentType=" + encodeURIComponent("" + componentType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_seed_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_seed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.0) (Scope: Dashboard)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_seed_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/seed";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_seed_post_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_seed_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.0) (Scope: Dashboard)
     * @param componentId (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_seedByComponent_get_V1 = function (componentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/seed-by-component?";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "ComponentId=" + encodeURIComponent("" + componentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_seedByComponent_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_seedByComponent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeId (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_byId_get_V1 = function (x_app_language_id, componentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/by-id?";
        if (componentTypeId === null)
            throw new Error("The parameter 'componentTypeId' cannot be null.");
        else if (componentTypeId !== undefined)
            url_ += "ComponentTypeId=" + encodeURIComponent("" + componentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_byId_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeName (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_byName_get_V1 = function (x_app_language_id, componentTypeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/by-name?";
        if (componentTypeName !== undefined && componentTypeName !== null)
            url_ += "ComponentTypeName=" + encodeURIComponent("" + componentTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_byName_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_byName_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.14) (Scope: Dashboard)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_addComponentTypeField_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/add-component-type-field";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_addComponentTypeField_post_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_addComponentTypeField_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.2) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_archive_put_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/archive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_archive_put_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_archive_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.4) (Scope: Dashboard)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_addAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/add-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_addAllowedType_post_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_addAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.6) (Scope: Dashboard)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_removeAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/remove-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_removeAllowedType_post_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_removeAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.12) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchKey (optional)
     * @param usageType (optional)
     * @param withArchived (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_lookups_get_V1 = function (x_app_language_id, searchKey, usageType, withArchived, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/lookups?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (usageType !== undefined && usageType !== null)
            url_ += "UsageType=" + encodeURIComponent("" + usageType) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_lookups_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.13) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ComponentTypes_Client.prototype.componentTypes_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_datatable_post_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.12) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchKey (optional)
     * @param collectionComponentId (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_lookups_allowedComponentTypesByCollectionComponentId_get_V1 = function (x_app_language_id, searchKey, collectionComponentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/lookups/allowed-component-types-by-collection-component-id?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (collectionComponentId === null)
            throw new Error("The parameter 'collectionComponentId' cannot be null.");
        else if (collectionComponentId !== undefined)
            url_ += "CollectionComponentId=" + encodeURIComponent("" + collectionComponentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_lookups_allowedComponentTypesByCollectionComponentId_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_lookups_allowedComponentTypesByCollectionComponentId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.12) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchKey (optional)
     * @param collectionComponentTypeId (optional)
     */
    Server_ComponentTypes_Client.prototype.componentTypes_lookups_allowedComponentTypesByCollectionComponentTypeId_get_V1 = function (x_app_language_id, searchKey, collectionComponentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/lookups/allowed-component-types-by-collection-component-type-id?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (collectionComponentTypeId === null)
            throw new Error("The parameter 'collectionComponentTypeId' cannot be null.");
        else if (collectionComponentTypeId !== undefined)
            url_ += "CollectionComponentTypeId=" + encodeURIComponent("" + collectionComponentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_lookups_allowedComponentTypesByCollectionComponentTypeId_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processComponentTypes_lookups_allowedComponentTypesByCollectionComponentTypeId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.3) (Scope: Dashboard)
     * @param componentTypeId (optional)
     */
    Server_ComponentTypes_Client.prototype.admin_ComponentTypes_multilingualById_get_V1 = function (componentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ComponentTypes/multilingual-by-id?";
        if (componentTypeId === null)
            throw new Error("The parameter 'componentTypeId' cannot be null.");
        else if (componentTypeId !== undefined)
            url_ += "ComponentTypeId=" + encodeURIComponent("" + componentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ComponentTypes_multilingualById_get_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processAdmin_ComponentTypes_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.2) (Scope: Dashboard)
     */
    Server_ComponentTypes_Client.prototype.admin_ComponentTypes_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ComponentTypes_put_V1(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processAdmin_ComponentTypes_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 52.1) (Scope: Dashboard)
     */
    Server_ComponentTypes_Client.prototype.admin_ComponentTypes_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/ComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ComponentTypes_post_V2(_response);
        });
    };
    Server_ComponentTypes_Client.prototype.processAdmin_ComponentTypes_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ComponentTypes_Client;
}());
exports.Server_ComponentTypes_Client = Server_ComponentTypes_Client;
var Server_CollectionComponents_Client = /** @class */ (function () {
    function Server_CollectionComponents_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 54.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeNameSearchText (optional)
     * @param withArchived (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_get_V1 = function (x_app_language_id, collectionComponentTypeNameSearchText, withArchived, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents?";
        if (collectionComponentTypeNameSearchText !== undefined && collectionComponentTypeNameSearchText !== null)
            url_ += "CollectionComponentTypeNameSearchText=" + encodeURIComponent("" + collectionComponentTypeNameSearchText) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_get_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     * @deprecated
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.2) (Scope: Dashboard)
     * @deprecated
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_put_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_delete_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_byType_get_V1 = function (x_app_language_id, collectionComponentTypeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/by-type?";
        if (collectionComponentTypeName !== undefined && collectionComponentTypeName !== null)
            url_ += "CollectionComponentTypeName=" + encodeURIComponent("" + collectionComponentTypeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_byType_get_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_byType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_byType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_byType_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_byType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentId (optional)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_byId_get_V1 = function (x_app_language_id, collectionComponentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/by-id?";
        if (collectionComponentId === null)
            throw new Error("The parameter 'collectionComponentId' cannot be null.");
        else if (collectionComponentId !== undefined)
            url_ += "CollectionComponentId=" + encodeURIComponent("" + collectionComponentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_byId_get_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_clone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/clone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_clone_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_clone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.7) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_addToDynamicZone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/add-to-dynamic-zone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_addToDynamicZone_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_addToDynamicZone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.7) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_setDynamicZone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/set-dynamic-zone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_setDynamicZone_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_setDynamicZone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.8) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_removeFromDynamicZone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/remove-from-dynamic-zone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_removeFromDynamicZone_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_removeFromDynamicZone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.8) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_reArrangeDynamicZone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/re-arrange-dynamic-zone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_reArrangeDynamicZone_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_reArrangeDynamicZone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     * @param usageType (optional)
     * @param withArchived (optional)
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_lookups_get_V1 = function (x_app_language_id, searchString, usageType, withArchived, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (usageType !== undefined && usageType !== null)
            url_ += "UsageType=" + encodeURIComponent("" + usageType) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_lookups_get_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_CollectionComponents_Client.prototype.collectionComponents_lookups_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_lookups_datatable_post_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processCollectionComponents_lookups_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.4) (Scope: Dashboard)
     * @param collectionComponentId (optional)
     */
    Server_CollectionComponents_Client.prototype.admin_CollectionComponents_multilingualById_get_V1 = function (collectionComponentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/CollectionComponents/multilingual-by-id?";
        if (collectionComponentId === null)
            throw new Error("The parameter 'collectionComponentId' cannot be null.");
        else if (collectionComponentId !== undefined)
            url_ += "CollectionComponentId=" + encodeURIComponent("" + collectionComponentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_CollectionComponents_multilingualById_get_V1(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processAdmin_CollectionComponents_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.5) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.admin_CollectionComponents_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/CollectionComponents";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_CollectionComponents_post_V2(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processAdmin_CollectionComponents_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.2) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.admin_CollectionComponents_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/CollectionComponents";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_CollectionComponents_put_V2(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processAdmin_CollectionComponents_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 54.1) (Scope: Dashboard)
     */
    Server_CollectionComponents_Client.prototype.admin_CollectionComponents_byType_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/CollectionComponents/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_CollectionComponents_byType_post_V2(_response);
        });
    };
    Server_CollectionComponents_Client.prototype.processAdmin_CollectionComponents_byType_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_CollectionComponents_Client;
}());
exports.Server_CollectionComponents_Client = Server_CollectionComponents_Client;
var Server_CollectionComponentTypes_Client = /** @class */ (function () {
    function Server_CollectionComponentTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 55.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param name (optional)
     * @param usageType (optional)
     * @param withArchived (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_get_V1 = function (x_app_language_id, name, usageType, withArchived, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (usageType !== undefined && usageType !== null)
            url_ += "UsageType=" + encodeURIComponent("" + usageType) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_get_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_post_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.9) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_delete_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.0) (Scope: Dashboard)
     * @param collectionComponentTypeId (optional)
     * @param collectionComponentType (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_seed_get_V1 = function (collectionComponentTypeId, collectionComponentType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/seed?";
        if (collectionComponentTypeId !== undefined && collectionComponentTypeId !== null)
            url_ += "CollectionComponentTypeId=" + encodeURIComponent("" + collectionComponentTypeId) + "&";
        if (collectionComponentType !== undefined && collectionComponentType !== null)
            url_ += "CollectionComponentType=" + encodeURIComponent("" + collectionComponentType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_seed_get_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_seed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_seed_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/seed";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_seed_post_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_seed_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeId (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_byId_get_V1 = function (x_app_language_id, collectionComponentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/by-id?";
        if (collectionComponentTypeId === null)
            throw new Error("The parameter 'collectionComponentTypeId' cannot be null.");
        else if (collectionComponentTypeId !== undefined)
            url_ += "CollectionComponentTypeId=" + encodeURIComponent("" + collectionComponentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_byId_get_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeName (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_byName_get_V1 = function (x_app_language_id, collectionComponentTypeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/by-name?";
        if (collectionComponentTypeName !== undefined && collectionComponentTypeName !== null)
            url_ += "CollectionComponentTypeName=" + encodeURIComponent("" + collectionComponentTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_byName_get_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_byName_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.2) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_archive_put_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/archive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_archive_put_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_archive_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.4) (Scope: Dashboard)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_addAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/add-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_addAllowedType_post_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_addAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.6) (Scope: Dashboard)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_removeAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/remove-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_removeAllowedType_post_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_removeAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     * @param usageType (optional)
     * @param withArchived (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_lookups_get_V1 = function (x_app_language_id, searchString, usageType, withArchived, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (usageType !== undefined && usageType !== null)
            url_ += "UsageType=" + encodeURIComponent("" + usageType) + "&";
        if (withArchived === null)
            throw new Error("The parameter 'withArchived' cannot be null.");
        else if (withArchived !== undefined)
            url_ += "WithArchived=" + encodeURIComponent("" + withArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_lookups_get_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_lookups_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_lookups_datatable_post_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_lookups_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.12) (Scope: Dashboard)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_addCollectionComponentTypeField_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/add-collection-component-type-field";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_addCollectionComponentTypeField_post_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_addCollectionComponentTypeField_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.13) (Scope: Dashboard)
     */
    Server_CollectionComponentTypes_Client.prototype.collectionComponentTypes_setAllowedComponentTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/set-allowed-component-types";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_setAllowedComponentTypes_post_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_setAllowedComponentTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.3) (Scope: Dashboard)
     * @param collectionComponentTypeId (optional)
     */
    Server_CollectionComponentTypes_Client.prototype.admin_CollectionComponentTypes_multilingualById_get_V1 = function (collectionComponentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/CollectionComponentTypes/multilingual-by-id?";
        if (collectionComponentTypeId === null)
            throw new Error("The parameter 'collectionComponentTypeId' cannot be null.");
        else if (collectionComponentTypeId !== undefined)
            url_ += "CollectionComponentTypeId=" + encodeURIComponent("" + collectionComponentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_CollectionComponentTypes_multilingualById_get_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processAdmin_CollectionComponentTypes_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.2) (Scope: Dashboard)
     */
    Server_CollectionComponentTypes_Client.prototype.admin_CollectionComponentTypes_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/CollectionComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_CollectionComponentTypes_put_V1(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processAdmin_CollectionComponentTypes_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1) (Scope: Dashboard)
     */
    Server_CollectionComponentTypes_Client.prototype.admin_CollectionComponentTypes_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/CollectionComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_CollectionComponentTypes_post_V2(_response);
        });
    };
    Server_CollectionComponentTypes_Client.prototype.processAdmin_CollectionComponentTypes_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_CollectionComponentTypes_Client;
}());
exports.Server_CollectionComponentTypes_Client = Server_CollectionComponentTypes_Client;
var Server_Badges_Client = /** @class */ (function () {
    function Server_Badges_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param input (optional)
     */
    Server_Badges_Client.prototype.badges_my_get_V1 = function (x_app_language_id, input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Badges/my?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadges_my_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processBadges_my_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param badgeIds (optional)
     */
    Server_Badges_Client.prototype.badges_myByIds_get_V1 = function (x_app_language_id, badgeIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Badges/my-by-ids?";
        if (badgeIds !== undefined && badgeIds !== null)
            badgeIds && badgeIds.forEach(function (item) { url_ += "BadgeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadges_myByIds_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processBadges_myByIds_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Badges_Client.prototype.badges_streak_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Badges/streak?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadges_streak_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processBadges_streak_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Badges_Client.prototype.badges_byContentId_get_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Badges/by-content-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadges_byContentId_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processBadges_byContentId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Badges_Client.prototype.badges_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Badges?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadges_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processBadges_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.2) (Scope: Dashboard)
     */
    Server_Badges_Client.prototype.admin_Badges_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_post_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.3) (Scope: Dashboard)
     */
    Server_Badges_Client.prototype.admin_Badges_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_put_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.0) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param forUserId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Badges_Client.prototype.admin_Badges_get_V1 = function (x_app_language_id, forUserId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges?";
        if (forUserId !== undefined && forUserId !== null)
            url_ += "ForUserId=" + encodeURIComponent("" + forUserId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Badges_Client.prototype.admin_Badges_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_delete_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.6)
     * @param id (optional)
     */
    Server_Badges_Client.prototype.admin_Badges_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_multilingualById_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.6)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_Badges_Client.prototype.admin_Badges_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_byId_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Server_Badges_Client.prototype.admin_Badges_lookups_get_V1 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_lookups_get_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 76.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_Badges_Client.prototype.admin_Badges_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Badges/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Badges_datatable_post_V1(_response);
        });
    };
    Server_Badges_Client.prototype.processAdmin_Badges_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Badges_Client;
}());
exports.Server_Badges_Client = Server_Badges_Client;
var Server_Certificate_Client = /** @class */ (function () {
    function Server_Certificate_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Certificate_Client.prototype.certificate_myCertificates_get_V1 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Certificate/my-certificates?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCertificate_myCertificates_get_V1(_response);
        });
    };
    Server_Certificate_Client.prototype.processCertificate_myCertificates_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_Certificate_Client.prototype.certificate_byContentEntityId_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Certificate/by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCertificate_byContentEntityId_get_V1(_response);
        });
    };
    Server_Certificate_Client.prototype.processCertificate_byContentEntityId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 135.3) (Scope: Mobile)
     * @param userId (optional)
     * @param languageId (optional)
     */
    Server_Certificate_Client.prototype.certificate_create_post_V1 = function (userId, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Certificate/create?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCertificate_create_post_V1(_response);
        });
    };
    Server_Certificate_Client.prototype.processCertificate_create_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Certificate_Client;
}());
exports.Server_Certificate_Client = Server_Certificate_Client;
var Server_ContentEntityAudios_Client = /** @class */ (function () {
    function Server_ContentEntityAudios_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_ContentEntityAudios_Client.prototype.contentEntityAudios_voiceOvers_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityAudios/voice-overs?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_voiceOvers_get_V1(_response);
        });
    };
    Server_ContentEntityAudios_Client.prototype.processContentEntityAudios_voiceOvers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 94.1) (Scope: Dashboard)
     */
    Server_ContentEntityAudios_Client.prototype.admin_ContentEntityAudios_checkAudio_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/check-audio";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityAudios_checkAudio_post_V1(_response);
        });
    };
    Server_ContentEntityAudios_Client.prototype.processAdmin_ContentEntityAudios_checkAudio_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 94.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntityAudios_Client.prototype.admin_ContentEntityAudios_get_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityAudios_get_V1(_response);
        });
    };
    Server_ContentEntityAudios_Client.prototype.processAdmin_ContentEntityAudios_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 94.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_ContentEntityAudios_Client.prototype.admin_ContentEntityAudios_download_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/download?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityAudios_download_get_V1(_response);
        });
    };
    Server_ContentEntityAudios_Client.prototype.processAdmin_ContentEntityAudios_download_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentEntityAudios_Client;
}());
exports.Server_ContentEntityAudios_Client = Server_ContentEntityAudios_Client;
var Server_ContentEntityStructures_Client = /** @class */ (function () {
    function Server_ContentEntityStructures_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ContentEntityStructures_Client.prototype.contentEntityStructures_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityStructures";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityStructures_get_V1(_response);
        });
    };
    Server_ContentEntityStructures_Client.prototype.processContentEntityStructures_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 99.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param name (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntityStructures_Client.prototype.admin_ContentEntityStructures_get_V1 = function (x_app_language_id, name, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityStructures_get_V1(_response);
        });
    };
    Server_ContentEntityStructures_Client.prototype.processAdmin_ContentEntityStructures_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 99.1) (Scope: Dashboard)
     */
    Server_ContentEntityStructures_Client.prototype.admin_ContentEntityStructures_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityStructures_post_V1(_response);
        });
    };
    Server_ContentEntityStructures_Client.prototype.processAdmin_ContentEntityStructures_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 99.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityStructureId (optional)
     */
    Server_ContentEntityStructures_Client.prototype.admin_ContentEntityStructures_byId_get_V1 = function (x_app_language_id, contentEntityStructureId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures/by-id?";
        if (contentEntityStructureId === null)
            throw new Error("The parameter 'contentEntityStructureId' cannot be null.");
        else if (contentEntityStructureId !== undefined)
            url_ += "ContentEntityStructureId=" + encodeURIComponent("" + contentEntityStructureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityStructures_byId_get_V1(_response);
        });
    };
    Server_ContentEntityStructures_Client.prototype.processAdmin_ContentEntityStructures_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 99.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ContentEntityStructures_Client.prototype.admin_ContentEntityStructures_multilingualById_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures/multilingual-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityStructures_multilingualById_get_V1(_response);
        });
    };
    Server_ContentEntityStructures_Client.prototype.processAdmin_ContentEntityStructures_multilingualById_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 99.4) (Scope: Dashboard)
     */
    Server_ContentEntityStructures_Client.prototype.admin_ContentEntityStructures_setNames_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures/set-names";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityStructures_setNames_post_V1(_response);
        });
    };
    Server_ContentEntityStructures_Client.prototype.processAdmin_ContentEntityStructures_setNames_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 99.5) (Scope: Dashboard)
     */
    Server_ContentEntityStructures_Client.prototype.admin_ContentEntityStructures_setOrder_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures/set-order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityStructures_setOrder_post_V1(_response);
        });
    };
    Server_ContentEntityStructures_Client.prototype.processAdmin_ContentEntityStructures_setOrder_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentEntityStructures_Client;
}());
exports.Server_ContentEntityStructures_Client = Server_ContentEntityStructures_Client;
var Server_Flows_Client = /** @class */ (function () {
    function Server_Flows_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param country (optional) 3 Digit Country Code
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     * @deprecated
     */
    Server_Flows_Client.prototype.flows_reader_get_V1 = function (x_app_language_id, country, x_app_version, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Flows/reader";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "country": country !== undefined && country !== null ? "" + country : "",
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_reader_get_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processFlows_reader_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.9) (Scope: Mobile)
     * @param groupState (optional)
     * @param nowDateTime (optional)
     * @param planIds (optional)
     * @param businessGroupIds (optional)
     * @param platform (optional)
     * @param readerId (optional)
     * @param iSOThreeDigitCountryCode (optional)
     * @param appVersionMajor (optional)
     * @param appVersionMiddle (optional)
     * @param appVersionMinor (optional)
     * @param languageId (optional)
     * @deprecated
     */
    Server_Flows_Client.prototype.flows_getFlow_get_V1 = function (groupState, nowDateTime, planIds, businessGroupIds, platform, readerId, iSOThreeDigitCountryCode, appVersionMajor, appVersionMiddle, appVersionMinor, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Flows/get-flow?";
        if (groupState !== undefined && groupState !== null)
            url_ += "GroupState=" + encodeURIComponent("" + groupState) + "&";
        if (nowDateTime === null)
            throw new Error("The parameter 'nowDateTime' cannot be null.");
        else if (nowDateTime !== undefined)
            url_ += "NowDateTime=" + encodeURIComponent("" + nowDateTime) + "&";
        if (planIds !== undefined && planIds !== null)
            planIds && planIds.forEach(function (item) { url_ += "PlanIds=" + encodeURIComponent("" + item) + "&"; });
        if (businessGroupIds !== undefined && businessGroupIds !== null)
            businessGroupIds && businessGroupIds.forEach(function (item) { url_ += "BusinessGroupIds=" + encodeURIComponent("" + item) + "&"; });
        if (platform !== undefined && platform !== null)
            url_ += "Platform=" + encodeURIComponent("" + platform) + "&";
        if (readerId === null)
            throw new Error("The parameter 'readerId' cannot be null.");
        else if (readerId !== undefined)
            url_ += "ReaderId=" + encodeURIComponent("" + readerId) + "&";
        if (iSOThreeDigitCountryCode !== undefined && iSOThreeDigitCountryCode !== null)
            url_ += "ISOThreeDigitCountryCode=" + encodeURIComponent("" + iSOThreeDigitCountryCode) + "&";
        if (appVersionMajor !== undefined && appVersionMajor !== null)
            url_ += "AppVersionMajor=" + encodeURIComponent("" + appVersionMajor) + "&";
        if (appVersionMiddle !== undefined && appVersionMiddle !== null)
            url_ += "AppVersionMiddle=" + encodeURIComponent("" + appVersionMiddle) + "&";
        if (appVersionMinor !== undefined && appVersionMinor !== null)
            url_ += "AppVersionMinor=" + encodeURIComponent("" + appVersionMinor) + "&";
        if (languageId !== undefined && languageId !== null)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_getFlow_get_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processFlows_getFlow_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param country (optional) 3 Digit Country Code
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web,Android_HMS)
     */
    Server_Flows_Client.prototype.flows_reader_get_V2 = function (x_app_language_id, country, x_app_version, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/Flows/reader";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "country": country !== undefined && country !== null ? "" + country : "",
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_reader_get_V2(_response);
        });
    };
    Server_Flows_Client.prototype.processFlows_reader_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.9) (Scope: Mobile)
     * @param groupState (optional)
     * @param nowDateTime (optional)
     * @param planIds (optional)
     * @param businessGroupIds (optional)
     * @param platform (optional)
     * @param readerId (optional)
     * @param iSOThreeDigitCountryCode (optional)
     * @param appVersionMajor (optional)
     * @param appVersionMiddle (optional)
     * @param appVersionMinor (optional)
     * @param languageId (optional)
     */
    Server_Flows_Client.prototype.flows_getFlow_get_V2 = function (groupState, nowDateTime, planIds, businessGroupIds, platform, readerId, iSOThreeDigitCountryCode, appVersionMajor, appVersionMiddle, appVersionMinor, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/Flows/get-flow?";
        if (groupState !== undefined && groupState !== null)
            url_ += "GroupState=" + encodeURIComponent("" + groupState) + "&";
        if (nowDateTime === null)
            throw new Error("The parameter 'nowDateTime' cannot be null.");
        else if (nowDateTime !== undefined)
            url_ += "NowDateTime=" + encodeURIComponent("" + nowDateTime) + "&";
        if (planIds !== undefined && planIds !== null)
            planIds && planIds.forEach(function (item) { url_ += "PlanIds=" + encodeURIComponent("" + item) + "&"; });
        if (businessGroupIds !== undefined && businessGroupIds !== null)
            businessGroupIds && businessGroupIds.forEach(function (item) { url_ += "BusinessGroupIds=" + encodeURIComponent("" + item) + "&"; });
        if (platform !== undefined && platform !== null)
            url_ += "Platform=" + encodeURIComponent("" + platform) + "&";
        if (readerId === null)
            throw new Error("The parameter 'readerId' cannot be null.");
        else if (readerId !== undefined)
            url_ += "ReaderId=" + encodeURIComponent("" + readerId) + "&";
        if (iSOThreeDigitCountryCode !== undefined && iSOThreeDigitCountryCode !== null)
            url_ += "ISOThreeDigitCountryCode=" + encodeURIComponent("" + iSOThreeDigitCountryCode) + "&";
        if (appVersionMajor !== undefined && appVersionMajor !== null)
            url_ += "AppVersionMajor=" + encodeURIComponent("" + appVersionMajor) + "&";
        if (appVersionMiddle !== undefined && appVersionMiddle !== null)
            url_ += "AppVersionMiddle=" + encodeURIComponent("" + appVersionMiddle) + "&";
        if (appVersionMinor !== undefined && appVersionMinor !== null)
            url_ += "AppVersionMinor=" + encodeURIComponent("" + appVersionMinor) + "&";
        if (languageId !== undefined && languageId !== null)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_getFlow_get_V2(_response);
        });
    };
    Server_Flows_Client.prototype.processFlows_getFlow_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.0) (Scope: Dashboard)
     * @deprecated
     */
    Server_Flows_Client.prototype.admin_Flows_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_post_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Flows_Client.prototype.admin_Flows_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_put_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.2) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @deprecated
     */
    Server_Flows_Client.prototype.admin_Flows_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_get_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.0) (Scope: Dashboard)
     */
    Server_Flows_Client.prototype.admin_Flows_clone_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/clone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_clone_post_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_clone_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.7) (Scope: Dashboard)
     */
    Server_Flows_Client.prototype.admin_Flows_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_datatable_post_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.8) (Scope: Dashboard)
     * @param searchString (optional)
     * @deprecated
     */
    Server_Flows_Client.prototype.admin_Flows_lookups_get_V1 = function (searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_lookups_get_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.3) (Scope: Dashboard)
     * @param flowId (optional)
     * @deprecated
     */
    Server_Flows_Client.prototype.admin_Flows_byId_get_V1 = function (flowId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/by-id?";
        if (flowId === null)
            throw new Error("The parameter 'flowId' cannot be null.");
        else if (flowId !== undefined)
            url_ += "FlowId=" + encodeURIComponent("" + flowId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_byId_get_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.5) (Scope: Dashboard)
     */
    Server_Flows_Client.prototype.admin_Flows_assign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_assign_post_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_assign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.5) (Scope: Dashboard)
     */
    Server_Flows_Client.prototype.admin_Flows_set_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_set_post_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_set_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.6) (Scope: Dashboard)
     */
    Server_Flows_Client.prototype.admin_Flows_unAssign_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/un-assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_unAssign_post_V1(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_unAssign_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.0) (Scope: Dashboard)
     */
    Server_Flows_Client.prototype.admin_Flows_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Flows";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_post_V2(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.1) (Scope: Dashboard)
     */
    Server_Flows_Client.prototype.admin_Flows_put_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Flows";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_put_V2(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_put_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.2) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Flows_Client.prototype.admin_Flows_get_V2 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Flows?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_get_V2(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.8) (Scope: Dashboard)
     * @param searchString (optional)
     */
    Server_Flows_Client.prototype.admin_Flows_lookups_get_V2 = function (searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Flows/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_lookups_get_V2(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_lookups_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 101.3) (Scope: Dashboard)
     * @param flowId (optional)
     */
    Server_Flows_Client.prototype.admin_Flows_byId_get_V2 = function (flowId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Flows/by-id?";
        if (flowId === null)
            throw new Error("The parameter 'flowId' cannot be null.");
        else if (flowId !== undefined)
            url_ += "FlowId=" + encodeURIComponent("" + flowId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Flows_byId_get_V2(_response);
        });
    };
    Server_Flows_Client.prototype.processAdmin_Flows_byId_get_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Flows_Client;
}());
exports.Server_Flows_Client = Server_Flows_Client;
var Server_Likings_Client = /** @class */ (function () {
    function Server_Likings_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Likings_Client.prototype.likings_add_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Likings/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLikings_add_post_V1(_response);
        });
    };
    Server_Likings_Client.prototype.processLikings_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_Likings_Client.prototype.likings_remove_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Likings/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLikings_remove_post_V1(_response);
        });
    };
    Server_Likings_Client.prototype.processLikings_remove_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param contentEntityIds (optional)
     */
    Server_Likings_Client.prototype.likings_byContentEntities_get_V1 = function (contentEntityIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Likings/by-content-entities?";
        if (contentEntityIds !== undefined && contentEntityIds !== null)
            contentEntityIds && contentEntityIds.forEach(function (item) { url_ += "ContentEntityIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLikings_byContentEntities_get_V1(_response);
        });
    };
    Server_Likings_Client.prototype.processLikings_byContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Likings_Client;
}());
exports.Server_Likings_Client = Server_Likings_Client;
var Server_QuizTries_Client = /** @class */ (function () {
    function Server_QuizTries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_QuizTries_Client.prototype.quizTries_getContentEntitiesQuizAction_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/get-content-entities-quiz-action";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_getContentEntitiesQuizAction_post_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_getContentEntitiesQuizAction_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_QuizTries_Client.prototype.quizTries_startQuiz_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/start-quiz";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_startQuiz_post_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_startQuiz_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param quizTryId (optional)
     */
    Server_QuizTries_Client.prototype.quizTries_getQuizQuestionsAndAnswers_get_V1 = function (quizTryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/get-quiz-questions-and-answers?";
        if (quizTryId === null)
            throw new Error("The parameter 'quizTryId' cannot be null.");
        else if (quizTryId !== undefined)
            url_ += "QuizTryId=" + encodeURIComponent("" + quizTryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_getQuizQuestionsAndAnswers_get_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_getQuizQuestionsAndAnswers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param quizTryId (optional)
     */
    Server_QuizTries_Client.prototype.quizTries_getQuizResult_get_V1 = function (quizTryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/get-quiz-result?";
        if (quizTryId === null)
            throw new Error("The parameter 'quizTryId' cannot be null.");
        else if (quizTryId !== undefined)
            url_ += "QuizTryId=" + encodeURIComponent("" + quizTryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_getQuizResult_get_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_getQuizResult_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_QuizTries_Client.prototype.quizTries_submitAnswer_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/submit-answer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_submitAnswer_put_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_submitAnswer_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_QuizTries_Client.prototype.quizTries_cancel_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/cancel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_cancel_put_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_cancel_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Server_QuizTries_Client.prototype.quizTries_complete_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/complete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_complete_put_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_complete_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_QuizTries_Client.prototype.quizTries_getQuizInstructions_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/get-quiz-instructions?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_getQuizInstructions_get_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_getQuizInstructions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_QuizTries_Client.prototype.quizTries_canStartQuizCheck_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/can-start-quiz-check?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_canStartQuizCheck_get_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_canStartQuizCheck_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_QuizTries_Client.prototype.quizTries_getAvailableQuiz_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/get-available-quiz?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_getAvailableQuiz_get_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_getAvailableQuiz_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Server_QuizTries_Client.prototype.quizTries_contentEntityQuizzesProgressStatus_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/content-entity-quizzes-progress-status?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuizTries_contentEntityQuizzesProgressStatus_get_V1(_response);
        });
    };
    Server_QuizTries_Client.prototype.processQuizTries_contentEntityQuizzesProgressStatus_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_QuizTries_Client;
}());
exports.Server_QuizTries_Client = Server_QuizTries_Client;
var Server_Reels_Client = /** @class */ (function () {
    function Server_Reels_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Server_Reels_Client.prototype.reels_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Reels";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReels_get_V1(_response);
        });
    };
    Server_Reels_Client.prototype.processReels_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Server_Reels_Client.prototype.reels_saved_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Reels/saved";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReels_saved_get_V1(_response);
        });
    };
    Server_Reels_Client.prototype.processReels_saved_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Reels_Client;
}());
exports.Server_Reels_Client = Server_Reels_Client;
var Server_ReportTextProblems_Client = /** @class */ (function () {
    function Server_ReportTextProblems_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     */
    Server_ReportTextProblems_Client.prototype.reportTextProblems_reportProblem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReportTextProblems/report-problem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportTextProblems_reportProblem_post_V1(_response);
        });
    };
    Server_ReportTextProblems_Client.prototype.processReportTextProblems_reportProblem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 98.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Server_ReportTextProblems_Client.prototype.admin_ReportTextProblems_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportTextProblems/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportTextProblems_datatable_post_V1(_response);
        });
    };
    Server_ReportTextProblems_Client.prototype.processAdmin_ReportTextProblems_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 98.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Server_ReportTextProblems_Client.prototype.admin_ReportTextProblems_byId_get_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportTextProblems/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ReportTextProblems_byId_get_V1(_response);
        });
    };
    Server_ReportTextProblems_Client.prototype.processAdmin_ReportTextProblems_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ReportTextProblems_Client;
}());
exports.Server_ReportTextProblems_Client = Server_ReportTextProblems_Client;
var Server_Tracking_Client = /** @class */ (function () {
    function Server_Tracking_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Mobile)
     * @param searchId (optional)
     * @param contentEntityId (optional)
     * @param position (optional)
     */
    Server_Tracking_Client.prototype.tracking_searchContentClicked_get_V1 = function (searchId, contentEntityId, position, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-clicked?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (position === null)
            throw new Error("The parameter 'position' cannot be null.");
        else if (position !== undefined)
            url_ += "position=" + encodeURIComponent("" + position) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTracking_searchContentClicked_get_V1(_response);
        });
    };
    Server_Tracking_Client.prototype.processTracking_searchContentClicked_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param searchId (optional)
     * @param contentEntityId (optional)
     */
    Server_Tracking_Client.prototype.tracking_searchContentRated_get_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-rated?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTracking_searchContentRated_get_V1(_response);
        });
    };
    Server_Tracking_Client.prototype.processTracking_searchContentRated_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param searchId (optional)
     * @param contentEntityId (optional)
     */
    Server_Tracking_Client.prototype.tracking_searchContentFollowed_get_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-followed?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTracking_searchContentFollowed_get_V1(_response);
        });
    };
    Server_Tracking_Client.prototype.processTracking_searchContentFollowed_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param searchId (optional)
     * @param contentEntityId (optional)
     */
    Server_Tracking_Client.prototype.tracking_searchContentListened_get_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-listened?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTracking_searchContentListened_get_V1(_response);
        });
    };
    Server_Tracking_Client.prototype.processTracking_searchContentListened_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param searchId (optional)
     * @param contentEntityId (optional)
     */
    Server_Tracking_Client.prototype.tracking_searchContentShared_get_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-shared?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTracking_searchContentShared_get_V1(_response);
        });
    };
    Server_Tracking_Client.prototype.processTracking_searchContentShared_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param searchId (optional)
     * @param contentEntityId (optional)
     */
    Server_Tracking_Client.prototype.tracking_searchContentDownloaded_get_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-downloaded?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTracking_searchContentDownloaded_get_V1(_response);
        });
    };
    Server_Tracking_Client.prototype.processTracking_searchContentDownloaded_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Mobile)
     * @param searchId (optional)
     * @param contentEntityId (optional)
     */
    Server_Tracking_Client.prototype.tracking_searchContentCompleted_get_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-completed?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTracking_searchContentCompleted_get_V1(_response);
        });
    };
    Server_Tracking_Client.prototype.processTracking_searchContentCompleted_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Tracking_Client;
}());
exports.Server_Tracking_Client = Server_Tracking_Client;
var Server_BusinessGroupAnalytics_Client = /** @class */ (function () {
    function Server_BusinessGroupAnalytics_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 97.0) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_percentageOfActiveReaders_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/percentage-of-active-readers?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_percentageOfActiveReaders_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_percentageOfActiveReaders_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.1) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_averageRates_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/average-rates?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_averageRates_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_averageRates_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.2) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_numberOfOpenedContentToday_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/number-of-opened-content-today?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_numberOfOpenedContentToday_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_numberOfOpenedContentToday_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.3) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_topReaders_get_V1 = function (businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/top-readers?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_topReaders_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_topReaders_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.4) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_topTitles_get_V1 = function (x_app_language_id, businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/top-titles?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_topTitles_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_topTitles_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.5) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_topCategories_get_V1 = function (x_app_language_id, businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/top-categories?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_topCategories_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_topCategories_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.6) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_totalContentEntities_get_V1 = function (businessGroupId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/total-content-entities?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_totalContentEntities_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_totalContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.7) (Scope: BusinessGroup)
     * @param timezone (optional) Time Zone ex (+01:00 , -02:30)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_dayVsNight_get_V1 = function (timezone, businessGroupId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/day-vs-night?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "timezone": timezone !== undefined && timezone !== null ? "" + timezone : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_dayVsNight_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_dayVsNight_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.8) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_playingMode_get_V1 = function (businessGroupId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/playing-mode?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_playingMode_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_playingMode_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.9) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_curiousReader_get_V1 = function (businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/curious-reader?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_curiousReader_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_curiousReader_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.10) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_expertReader_get_V1 = function (businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/expert-reader?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_expertReader_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_expertReader_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.11) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_avgMonthlyCompletedContent_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/avg-monthly-completed-content?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_avgMonthlyCompletedContent_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_avgMonthlyCompletedContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.12) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param period (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_progressToGoal_get_V1 = function (businessGroupId, period, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/progress-to-goal?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_progressToGoal_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_progressToGoal_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 97.13) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupAnalytics_Client.prototype.business_BusinessGroupAnalytics_monthlyCompletedContent_get_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/monthly-completed-content?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupAnalytics_monthlyCompletedContent_get_V1(_response);
        });
    };
    Server_BusinessGroupAnalytics_Client.prototype.processBusiness_BusinessGroupAnalytics_monthlyCompletedContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupAnalytics_Client;
}());
exports.Server_BusinessGroupAnalytics_Client = Server_BusinessGroupAnalytics_Client;
var Server_BusinessGroupQueries_Client = /** @class */ (function () {
    function Server_BusinessGroupQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 118.5) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_skillsCount_get_V1 = function (x_app_language_id, businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/skills-count?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_skillsCount_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_skillsCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.6) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param type (optional)
     * @param departmentId (optional)
     * @param searchKey (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_skillsWithProgress_get_V1 = function (x_app_language_id, businessGroupId, type, departmentId, searchKey, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/skills-with-progress?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_skillsWithProgress_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_skillsWithProgress_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.7) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_mostCompletedSkill_get_V1 = function (x_app_language_id, businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/most-completed-skill?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_mostCompletedSkill_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_mostCompletedSkill_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.8) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param departmentId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_usersWithRequiredSkills_get_V1 = function (x_app_language_id, businessGroupId, departmentId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/users-with-required-skills?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_usersWithRequiredSkills_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_usersWithRequiredSkills_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.10) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param departmentId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_countUsersWithOptionalSkills_get_V1 = function (x_app_language_id, businessGroupId, departmentId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/count-users-with-optional-skills?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_countUsersWithOptionalSkills_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_countUsersWithOptionalSkills_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.11) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param skillId (optional)
     * @param departmentId (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_skillProgressBySkillId_get_V1 = function (x_app_language_id, businessGroupId, skillId, departmentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/skill-progress-by-skill-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (skillId === null)
            throw new Error("The parameter 'skillId' cannot be null.");
        else if (skillId !== undefined)
            url_ += "SkillId=" + encodeURIComponent("" + skillId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_skillProgressBySkillId_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_skillProgressBySkillId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.12) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param skillId (optional)
     * @param departmentId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_usersProgressStatusBySkillId_get_V1 = function (x_app_language_id, businessGroupId, skillId, departmentId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/users-progress-status-by-skill-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (skillId === null)
            throw new Error("The parameter 'skillId' cannot be null.");
        else if (skillId !== undefined)
            url_ += "SkillId=" + encodeURIComponent("" + skillId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_usersProgressStatusBySkillId_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_usersProgressStatusBySkillId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 118.13) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param userId (optional)
     * @param type (optional)
     * @param departmentId (optional)
     */
    Server_BusinessGroupQueries_Client.prototype.business_BusinessGroupQueries_userSkillsProgressByUserId_get_V1 = function (x_app_language_id, businessGroupId, userId, type, departmentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/user-skills-progress-by-user-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusiness_BusinessGroupQueries_userSkillsProgressByUserId_get_V1(_response);
        });
    };
    Server_BusinessGroupQueries_Client.prototype.processBusiness_BusinessGroupQueries_userSkillsProgressByUserId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_BusinessGroupQueries_Client;
}());
exports.Server_BusinessGroupQueries_Client = Server_BusinessGroupQueries_Client;
var Server_Analytics_Client = /** @class */ (function () {
    function Server_Analytics_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 111.0) (Scope: Dashboard)
     * @param contentEntityTypeId (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_contentEntitiesCount_get_V1 = function (contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-count?";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_contentEntitiesCount_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_contentEntitiesCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.1) (Scope: Dashboard)
     */
    Server_Analytics_Client.prototype.admin_Analytics_authorsCount_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/authors-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_authorsCount_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_authorsCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.2) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_contentEntitiesStreamCount_get_V1 = function (contentEntityId, contentEntityTypeId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-stream-count?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_contentEntitiesStreamCount_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_contentEntitiesStreamCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.3) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_contentEntitiesUniqueStreamCount_get_V1 = function (contentEntityId, contentEntityTypeId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-unique-stream-count?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_contentEntitiesUniqueStreamCount_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_contentEntitiesUniqueStreamCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.4) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_contentEntitiesStreamPerDay_get_V1 = function (contentEntityId, contentEntityTypeId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-stream-per-day?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_contentEntitiesStreamPerDay_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_contentEntitiesStreamPerDay_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_contentEntityDescendantsStreamCount_get_V1 = function (x_app_language_id, contentEntityId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entity-descendants-stream-count?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_contentEntityDescendantsStreamCount_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_contentEntityDescendantsStreamCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_topStreamingAuthors_get_V1 = function (x_app_language_id, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/top-streaming-authors?";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_topStreamingAuthors_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_topStreamingAuthors_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.7) (Scope: Dashboard)
     * @param authorId (optional)
     * @param contentEntityTypeId (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_contentEntitiesCountForAuthor_get_V1 = function (authorId, contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-count-for-author?";
        if (authorId === null)
            throw new Error("The parameter 'authorId' cannot be null.");
        else if (authorId !== undefined)
            url_ += "AuthorId=" + encodeURIComponent("" + authorId) + "&";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_contentEntitiesCountForAuthor_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_contentEntitiesCountForAuthor_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 111.8) (Scope: Dashboard)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_Analytics_Client.prototype.admin_Analytics_topContentEntitiesByType_get_V1 = function (contentEntityTypeId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/top-content-entities-by-type?";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Analytics_topContentEntitiesByType_get_V1(_response);
        });
    };
    Server_Analytics_Client.prototype.processAdmin_Analytics_topContentEntitiesByType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Analytics_Client;
}());
exports.Server_Analytics_Client = Server_Analytics_Client;
var Server_Anghami_Client = /** @class */ (function () {
    function Server_Anghami_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 126.1) (Scope: ThirdPartyService)
     */
    Server_Anghami_Client.prototype.admin_Anghami_addContentEntitiesToBeSynced_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Anghami/add-content-entities-to-be-synced";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Anghami_addContentEntitiesToBeSynced_put_V1(_response);
        });
    };
    Server_Anghami_Client.prototype.processAdmin_Anghami_addContentEntitiesToBeSynced_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 126.0) (Scope: ThirdPartyService)
     * @param contentEntityIds (optional)
     * @param batchId (optional)
     * @param limit (optional)
     */
    Server_Anghami_Client.prototype.admin_Anghami_sync_put_V1 = function (contentEntityIds, batchId, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Anghami/sync?";
        if (contentEntityIds !== undefined && contentEntityIds !== null)
            contentEntityIds && contentEntityIds.forEach(function (item) { url_ += "ContentEntityIds=" + encodeURIComponent("" + item) + "&"; });
        if (batchId !== undefined && batchId !== null)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Anghami_sync_put_V1(_response);
        });
    };
    Server_Anghami_Client.prototype.processAdmin_Anghami_sync_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Anghami_Client;
}());
exports.Server_Anghami_Client = Server_Anghami_Client;
var Server_Answers_Client = /** @class */ (function () {
    function Server_Answers_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 133.0) (Scope: Dashboard)
     */
    Server_Answers_Client.prototype.admin_Answers_add_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Answers_add_post_V1(_response);
        });
    };
    Server_Answers_Client.prototype.processAdmin_Answers_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 133.1) (Scope: Dashboard)
     */
    Server_Answers_Client.prototype.admin_Answers_edit_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/edit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Answers_edit_put_V1(_response);
        });
    };
    Server_Answers_Client.prototype.processAdmin_Answers_edit_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 133.1) (Scope: Dashboard)
     */
    Server_Answers_Client.prototype.admin_Answers_delete_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Answers_delete_delete_V1(_response);
        });
    };
    Server_Answers_Client.prototype.processAdmin_Answers_delete_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 133.2) (Scope: Dashboard)
     */
    Server_Answers_Client.prototype.admin_Answers_setCorrect_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/set-correct";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Answers_setCorrect_put_V1(_response);
        });
    };
    Server_Answers_Client.prototype.processAdmin_Answers_setCorrect_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 133.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param questionId (optional)
     * @param searchString (optional)
     */
    Server_Answers_Client.prototype.admin_Answers_lookups_byQuestionId_get_V1 = function (x_app_language_id, questionId, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/lookups/by-question-id?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Answers_lookups_byQuestionId_get_V1(_response);
        });
    };
    Server_Answers_Client.prototype.processAdmin_Answers_lookups_byQuestionId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 133.4) (Scope: Dashboard)
     */
    Server_Answers_Client.prototype.admin_Answers_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Answers_datatable_post_V1(_response);
        });
    };
    Server_Answers_Client.prototype.processAdmin_Answers_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Answers_Client;
}());
exports.Server_Answers_Client = Server_Answers_Client;
var Server_ContentEntityLists_Client = /** @class */ (function () {
    function Server_ContentEntityLists_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 145.0) (Scope: Dashboard)
     * @param searchText (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_get_V1 = function (searchText, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_get_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.2) (Scope: Dashboard)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_post_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.1) (Scope: Dashboard)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_put_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.7) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_delete_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.0) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_byId_get_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.0) (Scope: Dashboard)
     * @param searchText (optional)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_lookups_get_V1 = function (searchText, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/lookups?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_lookups_get_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.0) (Scope: Dashboard)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_datatable_post_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityListId (optional)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_items_get_V1 = function (x_app_language_id, contentEntityListId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/items?";
        if (contentEntityListId === null)
            throw new Error("The parameter 'contentEntityListId' cannot be null.");
        else if (contentEntityListId !== undefined)
            url_ += "ContentEntityListId=" + encodeURIComponent("" + contentEntityListId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_items_get_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_items_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.4) (Scope: Dashboard)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_assign_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_assign_put_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_assign_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.5) (Scope: Dashboard)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_unAssign_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/un-assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_unAssign_put_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_unAssign_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.6) (Scope: Dashboard)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_set_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_set_put_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_set_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.8) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_byContentEntity_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/by-content-entity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_byContentEntity_get_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_byContentEntity_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 145.9) (Scope: Dashboard)
     */
    Server_ContentEntityLists_Client.prototype.admin_ContentEntityLists_setContentEntityLists_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityLists/set-content-entity-lists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityLists_setContentEntityLists_put_V1(_response);
        });
    };
    Server_ContentEntityLists_Client.prototype.processAdmin_ContentEntityLists_setContentEntityLists_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentEntityLists_Client;
}());
exports.Server_ContentEntityLists_Client = Server_ContentEntityLists_Client;
var Server_ContentEntityTypeNavigations_Client = /** @class */ (function () {
    function Server_ContentEntityTypeNavigations_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 103.0) (Scope: Dashboard)
     */
    Server_ContentEntityTypeNavigations_Client.prototype.admin_ContentEntityTypeNavigations_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypeNavigations_post_V1(_response);
        });
    };
    Server_ContentEntityTypeNavigations_Client.prototype.processAdmin_ContentEntityTypeNavigations_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 103.1) (Scope: Dashboard)
     */
    Server_ContentEntityTypeNavigations_Client.prototype.admin_ContentEntityTypeNavigations_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypeNavigations_put_V1(_response);
        });
    };
    Server_ContentEntityTypeNavigations_Client.prototype.processAdmin_ContentEntityTypeNavigations_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 103.2) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_ContentEntityTypeNavigations_Client.prototype.admin_ContentEntityTypeNavigations_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypeNavigations_get_V1(_response);
        });
    };
    Server_ContentEntityTypeNavigations_Client.prototype.processAdmin_ContentEntityTypeNavigations_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 103.4) (Scope: Dashboard)
     */
    Server_ContentEntityTypeNavigations_Client.prototype.admin_ContentEntityTypeNavigations_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypeNavigations_datatable_post_V1(_response);
        });
    };
    Server_ContentEntityTypeNavigations_Client.prototype.processAdmin_ContentEntityTypeNavigations_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 103.5) (Scope: Dashboard)
     * @param searchString (optional)
     */
    Server_ContentEntityTypeNavigations_Client.prototype.admin_ContentEntityTypeNavigations_lookups_get_V1 = function (searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypeNavigations_lookups_get_V1(_response);
        });
    };
    Server_ContentEntityTypeNavigations_Client.prototype.processAdmin_ContentEntityTypeNavigations_lookups_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 103.3) (Scope: Dashboard)
     * @param contentEntityTypeNavigationId (optional)
     */
    Server_ContentEntityTypeNavigations_Client.prototype.admin_ContentEntityTypeNavigations_byId_get_V1 = function (contentEntityTypeNavigationId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations/by-id?";
        if (contentEntityTypeNavigationId === null)
            throw new Error("The parameter 'contentEntityTypeNavigationId' cannot be null.");
        else if (contentEntityTypeNavigationId !== undefined)
            url_ += "ContentEntityTypeNavigationId=" + encodeURIComponent("" + contentEntityTypeNavigationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentEntityTypeNavigations_byId_get_V1(_response);
        });
    };
    Server_ContentEntityTypeNavigations_Client.prototype.processAdmin_ContentEntityTypeNavigations_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentEntityTypeNavigations_Client;
}());
exports.Server_ContentEntityTypeNavigations_Client = Server_ContentEntityTypeNavigations_Client;
var Server_FlowSelections_Client = /** @class */ (function () {
    function Server_FlowSelections_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 102.0) (Scope: Dashboard)
     */
    Server_FlowSelections_Client.prototype.admin_FlowSelections_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_FlowSelections_post_V1(_response);
        });
    };
    Server_FlowSelections_Client.prototype.processAdmin_FlowSelections_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 102.1) (Scope: Dashboard)
     */
    Server_FlowSelections_Client.prototype.admin_FlowSelections_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_FlowSelections_put_V1(_response);
        });
    };
    Server_FlowSelections_Client.prototype.processAdmin_FlowSelections_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 102.2) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_FlowSelections_Client.prototype.admin_FlowSelections_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_FlowSelections_get_V1(_response);
        });
    };
    Server_FlowSelections_Client.prototype.processAdmin_FlowSelections_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 102.4) (Scope: Dashboard)
     */
    Server_FlowSelections_Client.prototype.admin_FlowSelections_publishState_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections/publish-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_FlowSelections_publishState_put_V1(_response);
        });
    };
    Server_FlowSelections_Client.prototype.processAdmin_FlowSelections_publishState_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 102.2) (Scope: Dashboard)
     */
    Server_FlowSelections_Client.prototype.admin_FlowSelections_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_FlowSelections_datatable_post_V1(_response);
        });
    };
    Server_FlowSelections_Client.prototype.processAdmin_FlowSelections_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 102.3) (Scope: Dashboard)
     * @param flowSelectionId (optional)
     */
    Server_FlowSelections_Client.prototype.admin_FlowSelections_byId_get_V1 = function (flowSelectionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections/by-id?";
        if (flowSelectionId === null)
            throw new Error("The parameter 'flowSelectionId' cannot be null.");
        else if (flowSelectionId !== undefined)
            url_ += "FlowSelectionId=" + encodeURIComponent("" + flowSelectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_FlowSelections_byId_get_V1(_response);
        });
    };
    Server_FlowSelections_Client.prototype.processAdmin_FlowSelections_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_FlowSelections_Client;
}());
exports.Server_FlowSelections_Client = Server_FlowSelections_Client;
var Server_Publishers_Client = /** @class */ (function () {
    function Server_Publishers_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Scope: Dashboard)
     */
    Server_Publishers_Client.prototype.admin_Publishers_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Publishers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Publishers_post_V1(_response);
        });
    };
    Server_Publishers_Client.prototype.processAdmin_Publishers_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     */
    Server_Publishers_Client.prototype.admin_Publishers_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Publishers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Publishers_put_V1(_response);
        });
    };
    Server_Publishers_Client.prototype.processAdmin_Publishers_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Publishers_Client.prototype.admin_Publishers_byId_get_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Publishers/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Publishers_byId_get_V1(_response);
        });
    };
    Server_Publishers_Client.prototype.processAdmin_Publishers_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param searchText (optional)
     */
    Server_Publishers_Client.prototype.admin_Publishers_lookup_get_V1 = function (searchText, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Publishers/lookup?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Publishers_lookup_get_V1(_response);
        });
    };
    Server_Publishers_Client.prototype.processAdmin_Publishers_lookup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     */
    Server_Publishers_Client.prototype.admin_Publishers_datatable_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Publishers/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Publishers_datatable_post_V1(_response);
        });
    };
    Server_Publishers_Client.prototype.processAdmin_Publishers_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     */
    Server_Publishers_Client.prototype.admin_Publishers_setContentEntityPublisher_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Publishers/set-content-entity-publisher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Publishers_setContentEntityPublisher_put_V1(_response);
        });
    };
    Server_Publishers_Client.prototype.processAdmin_Publishers_setContentEntityPublisher_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Publishers_Client;
}());
exports.Server_Publishers_Client = Server_Publishers_Client;
var Server_Questions_Client = /** @class */ (function () {
    function Server_Questions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 132.5) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param searchString (optional)
     * @param languageId (optional)
     */
    Server_Questions_Client.prototype.admin_Questions_lookups_byContentEntityId_get_V1 = function (contentEntityId, searchString, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/lookups/by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_lookups_byContentEntityId_get_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_lookups_byContentEntityId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.5) (Scope: Dashboard)
     * @param questionId (optional)
     */
    Server_Questions_Client.prototype.admin_Questions_byId_get_V1 = function (questionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/by-id?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_byId_get_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_byId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.0) (Scope: Dashboard)
     * @deprecated
     */
    Server_Questions_Client.prototype.admin_Questions_add_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_add_post_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_add_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.1) (Scope: Dashboard)
     */
    Server_Questions_Client.prototype.admin_Questions_edit_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/edit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_edit_put_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_edit_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.2) (Scope: Dashboard)
     */
    Server_Questions_Client.prototype.admin_Questions_publish_state_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/publish/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_publish_state_put_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_publish_state_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.6) (Scope: Dashboard)
     * @deprecated
     */
    Server_Questions_Client.prototype.admin_Questions_edit_order_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/edit/order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_edit_order_put_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_edit_order_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.3) (Scope: Dashboard)
     * @param questionId (optional)
     */
    Server_Questions_Client.prototype.admin_Questions_delete_delete_V1 = function (questionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/delete?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_delete_delete_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_delete_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.5) (Scope: Dashboard)
     * @param quizId (optional)
     * @param searchString (optional)
     * @deprecated
     */
    Server_Questions_Client.prototype.admin_Questions_lookups_byQuizId_get_V1 = function (quizId, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/lookups/by-quiz-id?";
        if (quizId === null)
            throw new Error("The parameter 'quizId' cannot be null.");
        else if (quizId !== undefined)
            url_ += "QuizId=" + encodeURIComponent("" + quizId) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_lookups_byQuizId_get_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_lookups_byQuizId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.4) (Scope: Dashboard)
     */
    Server_Questions_Client.prototype.admin_Questions_datatable_byContentEntityId_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/datatable/by-content-entity-id";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_datatable_byContentEntityId_post_V1(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_datatable_byContentEntityId_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 132.0) (Scope: Dashboard)
     */
    Server_Questions_Client.prototype.admin_Questions_add_post_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/admin/Questions/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Questions_add_post_V2(_response);
        });
    };
    Server_Questions_Client.prototype.processAdmin_Questions_add_post_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Questions_Client;
}());
exports.Server_Questions_Client = Server_Questions_Client;
var Server_Quizzes_Client = /** @class */ (function () {
    function Server_Quizzes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 131.0) (Scope: Dashboard)
     * @deprecated
     */
    Server_Quizzes_Client.prototype.admin_Quizzes_create_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Quizzes/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Quizzes_create_post_V1(_response);
        });
    };
    Server_Quizzes_Client.prototype.processAdmin_Quizzes_create_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 131.1) (Scope: Dashboard)
     * @deprecated
     */
    Server_Quizzes_Client.prototype.admin_Quizzes_edit_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Quizzes/edit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Quizzes_edit_put_V1(_response);
        });
    };
    Server_Quizzes_Client.prototype.processAdmin_Quizzes_edit_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 131.4) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param searchString (optional)
     * @deprecated
     */
    Server_Quizzes_Client.prototype.admin_Quizzes_lookups_byContentEntityId_get_V1 = function (contentEntityId, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Quizzes/lookups/by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Quizzes_lookups_byContentEntityId_get_V1(_response);
        });
    };
    Server_Quizzes_Client.prototype.processAdmin_Quizzes_lookups_byContentEntityId_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 131.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Server_Quizzes_Client.prototype.admin_Quizzes_datatable_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Quizzes/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Quizzes_datatable_post_V1(_response);
        });
    };
    Server_Quizzes_Client.prototype.processAdmin_Quizzes_datatable_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Quizzes_Client;
}());
exports.Server_Quizzes_Client = Server_Quizzes_Client;
var Server_Tags_Client = /** @class */ (function () {
    function Server_Tags_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 29.1) (Scope: Dashboard)
     */
    Server_Tags_Client.prototype.admin_Tags_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Tags";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Tags_post_V1(_response);
        });
    };
    Server_Tags_Client.prototype.processAdmin_Tags_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 29.0) (Scope: Dashboard)
     */
    Server_Tags_Client.prototype.admin_Tags_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Tags";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Tags_get_V1(_response);
        });
    };
    Server_Tags_Client.prototype.processAdmin_Tags_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 29.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Server_Tags_Client.prototype.admin_Tags_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Tags?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_Tags_delete_V1(_response);
        });
    };
    Server_Tags_Client.prototype.processAdmin_Tags_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_Tags_Client;
}());
exports.Server_Tags_Client = Server_Tags_Client;
var Server_DataWorkflow_Client = /** @class */ (function () {
    function Server_DataWorkflow_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    Server_DataWorkflow_Client.prototype.dataWorkflow_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/DataWorkflow";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDataWorkflow_get_V1(_response);
        });
    };
    Server_DataWorkflow_Client.prototype.processDataWorkflow_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_DataWorkflow_Client;
}());
exports.Server_DataWorkflow_Client = Server_DataWorkflow_Client;
var Server_AppleReports_Client = /** @class */ (function () {
    function Server_AppleReports_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 100.0) (Scope: Mobile)
     * @param startDate (optional)
     * @param endDate (optional)
     */
    Server_AppleReports_Client.prototype.appleReports_fetchAppleReports_get_V1 = function (startDate, endDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/AppleReports/fetchAppleReports?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAppleReports_fetchAppleReports_get_V1(_response);
        });
    };
    Server_AppleReports_Client.prototype.processAppleReports_fetchAppleReports_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_AppleReports_Client;
}());
exports.Server_AppleReports_Client = Server_AppleReports_Client;
var Server_ContentQueries_Client = /** @class */ (function () {
    function Server_ContentQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 120.0)
     * @param contentEntityTypeId (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_contentTypeCount_get_V1 = function (contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/content-type-count?";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "contentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_contentTypeCount_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_contentTypeCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.1)
     * @param userId (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_userConsumedContent_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/user-consumed-content?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_userConsumedContent_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_userConsumedContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.2)
     * @param userId (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_dailyUserSessionBreakdown_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/daily-user-session-breakdown?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_dailyUserSessionBreakdown_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_dailyUserSessionBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.3)
     * @param userId (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_monthlyUserSessionBreakdown_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/monthly-user-session-breakdown?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_monthlyUserSessionBreakdown_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_monthlyUserSessionBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.4)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param contentType (optional)
     * @param planType (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_topContent_get_V1 = function (fromDate, toDate, contentType, planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/top-content?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_topContent_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_topContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.5)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param contentType (optional)
     * @param planType (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_mostRatedContent_get_V1 = function (fromDate, toDate, contentType, planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/most-rated-content?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_mostRatedContent_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_mostRatedContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.6)
     * @param planType (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_minutesListenedToday_get_V1 = function (planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/minutes-listened-today?";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_minutesListenedToday_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_minutesListenedToday_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.7)
     * @param planType (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_activeUsersCount_get_V1 = function (planType, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-users-count?";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_activeUsersCount_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_activeUsersCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.8)
     * @param plan (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_dailyActiveUsersCount_get_V1 = function (plan, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/daily-active-users-count?";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_dailyActiveUsersCount_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_dailyActiveUsersCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.8)
     * @param plan (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_activeReadersDailyBreakdown_get_V1 = function (plan, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-readers-daily-breakdown?";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_activeReadersDailyBreakdown_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_activeReadersDailyBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.9)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_activeUsersHourlyBreakdown_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-users-hourly-breakdown?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_activeUsersHourlyBreakdown_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_activeUsersHourlyBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.10)
     * @param plan (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_activeReadersMonthlyBreakdown_get_V1 = function (plan, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-readers-monthly-breakdown?";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_activeReadersMonthlyBreakdown_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_activeReadersMonthlyBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.11)
     * @param plan (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_activeReadersWeeklyBreakdown_get_V1 = function (plan, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-readers-weekly-breakdown?";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_activeReadersWeeklyBreakdown_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_activeReadersWeeklyBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.12)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param planType (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_userActiveRetentionAfterFirstSession_get_V1 = function (fromDate, toDate, planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/user-active-retention-after-first-session?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "PlanType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_userActiveRetentionAfterFirstSession_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_userActiveRetentionAfterFirstSession_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.13)
     * @param userId (optional)
     * @param retentionPeriod (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_userDetailedRetentionAfterRegistration_get_V1 = function (userId, retentionPeriod, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/user-detailed-retention-after-registration?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (retentionPeriod === null)
            throw new Error("The parameter 'retentionPeriod' cannot be null.");
        else if (retentionPeriod !== undefined)
            url_ += "RetentionPeriod=" + encodeURIComponent("" + retentionPeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_userDetailedRetentionAfterRegistration_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_userDetailedRetentionAfterRegistration_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.14)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_avgWeeklyUniqueReaders_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/avg-weekly-unique-readers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_avgWeeklyUniqueReaders_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_avgWeeklyUniqueReaders_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.15)
     * @param contentType (optional)
     * @param limit (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_mostPopularContentEntities_get_V1 = function (contentType, limit, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/most-popular-content-entities?";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_mostPopularContentEntities_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_mostPopularContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.16)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_monthlyActiveReader_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/monthly-active-reader?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_monthlyActiveReader_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_monthlyActiveReader_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.17)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_ContentQueries_Client.prototype.admin_ContentQueries_fullBookStats_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/full-book-stats?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_ContentQueries_fullBookStats_get_V1(_response);
        });
    };
    Server_ContentQueries_Client.prototype.processAdmin_ContentQueries_fullBookStats_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_ContentQueries_Client;
}());
exports.Server_ContentQueries_Client = Server_ContentQueries_Client;
var Server_IdentityQueries_Client = /** @class */ (function () {
    function Server_IdentityQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 122.0)
     * @param afterDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_registeredUsersCount_get_V1 = function (afterDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/registered-users-count?";
        if (afterDate === null)
            throw new Error("The parameter 'afterDate' cannot be null.");
        else if (afterDate !== undefined)
            url_ += "afterDate=" + encodeURIComponent("" + afterDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_registeredUsersCount_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_registeredUsersCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.1)
     * @param userId (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_userDevices_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/user-devices?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_userDevices_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_userDevices_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.2)
     * @param afterDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_operationSystemBreakdown_get_V1 = function (afterDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/operation-system-breakdown?";
        if (afterDate === null)
            throw new Error("The parameter 'afterDate' cannot be null.");
        else if (afterDate !== undefined)
            url_ += "afterDate=" + encodeURIComponent("" + afterDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_operationSystemBreakdown_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_operationSystemBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.3)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_weeklyRegisteredUsersBreakdown_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/weekly-registered-users-breakdown";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_weeklyRegisteredUsersBreakdown_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_weeklyRegisteredUsersBreakdown_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.4)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_installsCount_get_V1 = function (countries, operatingSystems, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/installs-count?";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_installsCount_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_installsCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.9)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_dailyInstallationCount_get_V1 = function (countries, operatingSystems, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/daily-installation-count?";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_dailyInstallationCount_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_dailyInstallationCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.5)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_registrationsCount_get_V1 = function (countries, operatingSystems, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/registrations-count?";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_registrationsCount_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_registrationsCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.6)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_registrationsInstalledAtCount_get_V1 = function (countries, operatingSystems, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/registrations-installed-at-count?";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_registrationsInstalledAtCount_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_registrationsInstalledAtCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.7)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_subscriptionsInstalledAtCount_get_V1 = function (countries, operatingSystems, subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/subscriptions-installed-at-count?";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_subscriptionsInstalledAtCount_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_subscriptionsInstalledAtCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.8)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_subscriptionsRegisteredAtCount_get_V1 = function (countries, operatingSystems, subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/subscriptions-registered-at-count?";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_subscriptionsRegisteredAtCount_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_subscriptionsRegisteredAtCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.10)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_newlySubscribedUsers_get_V1 = function (pageNumber, pageSize, countries, operatingSystems, subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/newly-subscribed-users?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_newlySubscribedUsers_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_newlySubscribedUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.11)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param countries (optional)
     * @param operatingSystems (optional)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_IdentityQueries_Client.prototype.admin_IdentityQueries_churnedSubscribedUsers_get_V1 = function (pageNumber, pageSize, countries, operatingSystems, subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/churned-subscribed-users?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(function (item) { url_ += "Countries=" + encodeURIComponent("" + item) + "&"; });
        if (operatingSystems !== undefined && operatingSystems !== null)
            operatingSystems && operatingSystems.forEach(function (item) { url_ += "OperatingSystems=" + encodeURIComponent("" + item) + "&"; });
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_IdentityQueries_churnedSubscribedUsers_get_V1(_response);
        });
    };
    Server_IdentityQueries_Client.prototype.processAdmin_IdentityQueries_churnedSubscribedUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_IdentityQueries_Client;
}());
exports.Server_IdentityQueries_Client = Server_IdentityQueries_Client;
var Server_PaymentQueries_Client = /** @class */ (function () {
    function Server_PaymentQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 121.1)
     * @param userId (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_userSubscriptionHistory_get_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/user-subscription-history?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_userSubscriptionHistory_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_userSubscriptionHistory_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.1)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_usersSubscriptions_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/users-subscriptions?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_usersSubscriptions_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_usersSubscriptions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.2)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_firstTimeSubscriptionCount_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/first-time-subscription-count?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_firstTimeSubscriptionCount_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_firstTimeSubscriptionCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.19)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyFirstTimeSubscription_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-first-time-subscription?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyFirstTimeSubscription_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyFirstTimeSubscription_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.20)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyUpgradedSubscription_get_V1 = function (purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-upgraded-subscription?";
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyUpgradedSubscription_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyUpgradedSubscription_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.21)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyDowngradedSubscription_get_V1 = function (purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-downgraded-subscription?";
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyDowngradedSubscription_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyDowngradedSubscription_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.5)
     * @param fromDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_userRetentionForSinglePoint_get_V1 = function (fromDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/user-retention-for-single-point?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_userRetentionForSinglePoint_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_userRetentionForSinglePoint_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.4)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_subscriptionOverview_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/subscription-overview?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_subscriptionOverview_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_subscriptionOverview_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.6)
     * @param fromDatePoint (optional)
     * @param toDatePoint (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_userRetentionForMultiplePoints_get_V1 = function (fromDatePoint, toDatePoint, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/user-retention-for-multiple-points?";
        if (fromDatePoint === null)
            throw new Error("The parameter 'fromDatePoint' cannot be null.");
        else if (fromDatePoint !== undefined)
            url_ += "fromDatePoint=" + encodeURIComponent("" + fromDatePoint) + "&";
        if (toDatePoint === null)
            throw new Error("The parameter 'toDatePoint' cannot be null.");
        else if (toDatePoint !== undefined)
            url_ += "toDatePoint=" + encodeURIComponent("" + toDatePoint) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_userRetentionForMultiplePoints_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_userRetentionForMultiplePoints_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.7)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_currentPremiumCount_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/current-premium-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_currentPremiumCount_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_currentPremiumCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.30)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_totalCurrentPremiumCount_get_V1 = function (subscriptionPeriods, purchaseSources, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/total-current-premium-count?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_totalCurrentPremiumCount_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_totalCurrentPremiumCount_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.8)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_breakdownOfPremiumsByPurchaseSource_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/breakdown-of-premiums-by-purchase-source?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_breakdownOfPremiumsByPurchaseSource_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_breakdownOfPremiumsByPurchaseSource_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.10)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @deprecated
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyBreakdownByPurchaseSource_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-breakdown-by-purchase-source?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyBreakdownByPurchaseSource_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyBreakdownByPurchaseSource_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.15)
     * @param purchaseSourceType (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @deprecated
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyBreakdownByPurchaseSourceFilteredByPurchaseSourceType_get_V1 = function (purchaseSourceType, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-breakdown-by-purchase-source-filtered-by-purchase-source-type?";
        if (purchaseSourceType === null)
            throw new Error("The parameter 'purchaseSourceType' cannot be null.");
        else if (purchaseSourceType !== undefined)
            url_ += "PurchaseSourceType=" + encodeURIComponent("" + purchaseSourceType) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyBreakdownByPurchaseSourceFilteredByPurchaseSourceType_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyBreakdownByPurchaseSourceFilteredByPurchaseSourceType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.17)
     * @param subscriptionDuration (optional)
     * @param subscriptionType (optional)
     * @param purchaseSourceType (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyAcquiredPremiumsByPurchaseSource_get_V1 = function (subscriptionDuration, subscriptionType, purchaseSourceType, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-acquired-premiums-by-purchase-source?";
        if (subscriptionDuration !== undefined && subscriptionDuration !== null)
            url_ += "SubscriptionDuration=" + encodeURIComponent("" + subscriptionDuration) + "&";
        if (subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' cannot be null.");
        else if (subscriptionType !== undefined)
            url_ += "SubscriptionType=" + encodeURIComponent("" + subscriptionType) + "&";
        if (purchaseSourceType === null)
            throw new Error("The parameter 'purchaseSourceType' cannot be null.");
        else if (purchaseSourceType !== undefined)
            url_ += "PurchaseSourceType=" + encodeURIComponent("" + purchaseSourceType) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyAcquiredPremiumsByPurchaseSource_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyAcquiredPremiumsByPurchaseSource_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.9)
     * @param startYear (optional)
     * @param startWeek (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_firstTimeSubscriptionBreakdownByWeeks_get_V1 = function (startYear, startWeek, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/first-time-subscription-breakdown-by-weeks?";
        if (startYear === null)
            throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined)
            url_ += "startYear=" + encodeURIComponent("" + startYear) + "&";
        if (startWeek === null)
            throw new Error("The parameter 'startWeek' cannot be null.");
        else if (startWeek !== undefined)
            url_ += "startWeek=" + encodeURIComponent("" + startWeek) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_firstTimeSubscriptionBreakdownByWeeks_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_firstTimeSubscriptionBreakdownByWeeks_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.11)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_promoCodeAliasBreakdownBySource_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/promo-code-alias-breakdown-by-source?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_promoCodeAliasBreakdownBySource_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_promoCodeAliasBreakdownBySource_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.12)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param stripeCustomerEmail (optional)
     * @param stripeCustomerId (optional)
     * @param userId (optional)
     * @param stripeSubscriptionId (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_stripeSessions_get_V1 = function (fromDate, toDate, stripeCustomerEmail, stripeCustomerId, userId, stripeSubscriptionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/stripe-sessions?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (stripeCustomerEmail !== undefined && stripeCustomerEmail !== null)
            url_ += "StripeCustomerEmail=" + encodeURIComponent("" + stripeCustomerEmail) + "&";
        if (stripeCustomerId !== undefined && stripeCustomerId !== null)
            url_ += "StripeCustomerId=" + encodeURIComponent("" + stripeCustomerId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (stripeSubscriptionId !== undefined && stripeSubscriptionId !== null)
            url_ += "StripeSubscriptionId=" + encodeURIComponent("" + stripeSubscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_stripeSessions_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_stripeSessions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.13)
     * @param subscriptionDuration (optional)
     * @param subscriptionType (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyAquiredPremiumUsers_get_V1 = function (subscriptionDuration, subscriptionType, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-aquired-premium-users?";
        if (subscriptionDuration !== undefined && subscriptionDuration !== null)
            url_ += "SubscriptionDuration=" + encodeURIComponent("" + subscriptionDuration) + "&";
        if (subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' cannot be null.");
        else if (subscriptionType !== undefined)
            url_ += "SubscriptionType=" + encodeURIComponent("" + subscriptionType) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyAquiredPremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyAquiredPremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.17)
     * @param subscriptionPeriod (optional)
     * @param purchaseSourceType (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyAcquiredPremiumUsers_get_V1 = function (subscriptionPeriod, purchaseSourceType, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-acquired-premium-users?";
        if (subscriptionPeriod !== undefined && subscriptionPeriod !== null)
            url_ += "SubscriptionPeriod=" + encodeURIComponent("" + subscriptionPeriod) + "&";
        if (purchaseSourceType !== undefined && purchaseSourceType !== null)
            url_ += "PurchaseSourceType=" + encodeURIComponent("" + purchaseSourceType) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyAcquiredPremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyAcquiredPremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.28)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyRenewedPremiumUsers_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-renewed-premium-users?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyRenewedPremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyRenewedPremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.14)
     * @param subscriptionDuration (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyLostPremiumUsers_get_V1 = function (subscriptionDuration, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-lost-premium-users?";
        if (subscriptionDuration !== undefined && subscriptionDuration !== null)
            url_ += "SubscriptionDuration=" + encodeURIComponent("" + subscriptionDuration) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyLostPremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyLostPremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.23)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyChurnedPremiumUsers_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-churned-premium-users?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyChurnedPremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyChurnedPremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.24)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyReactivatedPremiumUsers_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-reactivated-premium-users?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyReactivatedPremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyReactivatedPremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.25)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyFailedToRenewPremiumUsers_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-failed-to-renew-premium-users?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyFailedToRenewPremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyFailedToRenewPremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.27)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyActivePremiumUsers_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-active-premium-users?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyActivePremiumUsers_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyActivePremiumUsers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.29)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyActiveDcpSubscriptions_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-active-dcp-subscriptions?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyActiveDcpSubscriptions_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyActiveDcpSubscriptions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.16)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_expectedToBeLostPremiums_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/expected-to-be-lost-premiums";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_expectedToBeLostPremiums_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_expectedToBeLostPremiums_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.18)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dcpConversionPurchases_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/dcp-conversion-purchases?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dcpConversionPurchases_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dcpConversionPurchases_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.22)
     * @param subscriptionPeriods (optional)
     * @param purchaseSources (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyRefunds_get_V1 = function (subscriptionPeriods, purchaseSources, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-refunds?";
        if (subscriptionPeriods !== undefined && subscriptionPeriods !== null)
            subscriptionPeriods && subscriptionPeriods.forEach(function (item) { url_ += "SubscriptionPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (purchaseSources !== undefined && purchaseSources !== null)
            purchaseSources && purchaseSources.forEach(function (item) { url_ += "PurchaseSources=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyRefunds_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyRefunds_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.26)
     * @param purchaseSourceType (optional)
     * @param subscriptionPeriod (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_PaymentQueries_Client.prototype.admin_PaymentQueries_dailyPromoCodeAlias_get_V1 = function (purchaseSourceType, subscriptionPeriod, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-promo-code-alias?";
        if (purchaseSourceType !== undefined && purchaseSourceType !== null)
            url_ += "PurchaseSourceType=" + encodeURIComponent("" + purchaseSourceType) + "&";
        if (subscriptionPeriod !== undefined && subscriptionPeriod !== null)
            url_ += "SubscriptionPeriod=" + encodeURIComponent("" + subscriptionPeriod) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_PaymentQueries_dailyPromoCodeAlias_get_V1(_response);
        });
    };
    Server_PaymentQueries_Client.prototype.processAdmin_PaymentQueries_dailyPromoCodeAlias_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_PaymentQueries_Client;
}());
exports.Server_PaymentQueries_Client = Server_PaymentQueries_Client;
var Server_WajeezQueries_Client = /** @class */ (function () {
    function Server_WajeezQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * (Auth policies: 123.0) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Server_WajeezQueries_Client.prototype.admin_WajeezQueries_premiumCustomers_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/WajeezQueries/premium-customers?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_WajeezQueries_premiumCustomers_get_V1(_response);
        });
    };
    Server_WajeezQueries_Client.prototype.processAdmin_WajeezQueries_premiumCustomers_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 123.1) (Scope: Dashboard)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    Server_WajeezQueries_Client.prototype.admin_WajeezQueries_userSubscriptionConversionRate_get_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/WajeezQueries/user-subscription-conversion-rate?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdmin_WajeezQueries_userSubscriptionConversionRate_get_V1(_response);
        });
    };
    Server_WajeezQueries_Client.prototype.processAdmin_WajeezQueries_userSubscriptionConversionRate_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Server_WajeezQueries_Client;
}());
exports.Server_WajeezQueries_Client = Server_WajeezQueries_Client;
/** 0 = Success 400 = BadRequest 403 = Forbidden 404 = NotFound 404 = UserNotFound 404 = RoleNotFound 404 = RoleClaimNotFound 405 = Unauthorized 406 = NotAcceptable 407 = MaxNumberOfSimultaneousLogins 410 = DeletionNotAllowed 411 = AlreadyExist 412 = InvalidEmail 413 = InvalidCode 414 = EmailTaken 415 = UserBlocked 416 = InvalidCredentials 417 = InvalidPassword 500 = InternalServerError */
var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    ResponseCode[ResponseCode["BadRequest"] = 400] = "BadRequest";
    ResponseCode[ResponseCode["Forbidden"] = 403] = "Forbidden";
    ResponseCode[ResponseCode["NotFound"] = 404] = "NotFound";
    ResponseCode[ResponseCode["UserNotFound"] = 404] = "UserNotFound";
    ResponseCode[ResponseCode["RoleNotFound"] = 404] = "RoleNotFound";
    ResponseCode[ResponseCode["RoleClaimNotFound"] = 404] = "RoleClaimNotFound";
    ResponseCode[ResponseCode["Unauthorized"] = 405] = "Unauthorized";
    ResponseCode[ResponseCode["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseCode[ResponseCode["MaxNumberOfSimultaneousLogins"] = 407] = "MaxNumberOfSimultaneousLogins";
    ResponseCode[ResponseCode["DeletionNotAllowed"] = 410] = "DeletionNotAllowed";
    ResponseCode[ResponseCode["AlreadyExist"] = 411] = "AlreadyExist";
    ResponseCode[ResponseCode["InvalidEmail"] = 412] = "InvalidEmail";
    ResponseCode[ResponseCode["InvalidCode"] = 413] = "InvalidCode";
    ResponseCode[ResponseCode["EmailTaken"] = 414] = "EmailTaken";
    ResponseCode[ResponseCode["UserBlocked"] = 415] = "UserBlocked";
    ResponseCode[ResponseCode["InvalidCredentials"] = 416] = "InvalidCredentials";
    ResponseCode[ResponseCode["InvalidPassword"] = 417] = "InvalidPassword";
    ResponseCode[ResponseCode["InternalServerError"] = 500] = "InternalServerError";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
/** 0 = None 1 = Download 2 = Next 4 = Back 8 = FastForward 16 = FastBackward 32 = Seek 64 = Read 128 = Highlight 256 = Bookmark 512 = Playlists 1024 = ChapterList 2048 = Gifts */
var PlanPermission;
(function (PlanPermission) {
    PlanPermission[PlanPermission["None"] = 0] = "None";
    PlanPermission[PlanPermission["Download"] = 1] = "Download";
    PlanPermission[PlanPermission["Next"] = 2] = "Next";
    PlanPermission[PlanPermission["Back"] = 4] = "Back";
    PlanPermission[PlanPermission["FastForward"] = 8] = "FastForward";
    PlanPermission[PlanPermission["FastBackward"] = 16] = "FastBackward";
    PlanPermission[PlanPermission["Seek"] = 32] = "Seek";
    PlanPermission[PlanPermission["Read"] = 64] = "Read";
    PlanPermission[PlanPermission["Highlight"] = 128] = "Highlight";
    PlanPermission[PlanPermission["Bookmark"] = 256] = "Bookmark";
    PlanPermission[PlanPermission["Playlists"] = 512] = "Playlists";
    PlanPermission[PlanPermission["ChapterList"] = 1024] = "ChapterList";
    PlanPermission[PlanPermission["Gifts"] = 2048] = "Gifts";
})(PlanPermission = exports.PlanPermission || (exports.PlanPermission = {}));
/** 0 = Subscription 1 = Gift 10 = None */
var ReferralRewardType;
(function (ReferralRewardType) {
    ReferralRewardType[ReferralRewardType["Subscription"] = 0] = "Subscription";
    ReferralRewardType[ReferralRewardType["Gift"] = 1] = "Gift";
    ReferralRewardType[ReferralRewardType["None"] = 10] = "None";
})(ReferralRewardType = exports.ReferralRewardType || (exports.ReferralRewardType = {}));
/** 0 = SUBSCRIPTION_RENEWABLE 1 = SUBSCRIPTION_NON_RENEWABLE 2 = ONETIME_CONSUMABLE 3 = ONETIME_NONCONSUMABLE 4 = FREE */
var PurchaseType;
(function (PurchaseType) {
    PurchaseType[PurchaseType["SUBSCRIPTION_RENEWABLE"] = 0] = "SUBSCRIPTION_RENEWABLE";
    PurchaseType[PurchaseType["SUBSCRIPTION_NON_RENEWABLE"] = 1] = "SUBSCRIPTION_NON_RENEWABLE";
    PurchaseType[PurchaseType["ONETIME_CONSUMABLE"] = 2] = "ONETIME_CONSUMABLE";
    PurchaseType[PurchaseType["ONETIME_NONCONSUMABLE"] = 3] = "ONETIME_NONCONSUMABLE";
    PurchaseType[PurchaseType["FREE"] = 4] = "FREE";
})(PurchaseType = exports.PurchaseType || (exports.PurchaseType = {}));
/** 0 = APPLE 1 = HUAWEI 2 = GOOGLE 3 = OFFLINE 4 = INTERNAL 5 = FREE 6 = VOUCHER 7 = STRIPE 8 = TPAY 10 = MONDIAPAY_VODAFONE 11 = MONDIAPAY_ETISALAT 12 = MONDIAPAY_ORANGE 13 = MONDIAPAY_WE 14 = STCPay 16 = MOBIMIND_KSA_STC 17 = MOBIMIND_KSA_MOBILY 18 = MOBIMIND_KSA_ZAIN 19 = MOYASAR_APPLE_PAY 20 = MOYASAR_STCPAY 21 = MOYASAR_CREDITCARD 22 = MEDIAWORLD_ZAIN 23 = MEDIAWORLD_JAWWAL 24 = TAMARA 25 = REWARD 26 = MOBIMIND_KWT_ZAIN 27 = MOBIMIND_KWT_OOREDOO 28 = MOBIMIND_KWT_STC 29 = MOBIMIND_QAT_VODAFONE 30 = MOBIMIND_QAT_OOREDOO 31 = MOBIMIND_OMN_OMANTEL 32 = SALES 33 = MOBIMIND_OMN_OOREDOO 34 = MOBIMIND_UAE_ETISALAT 35 = VasHouse_PSE_Ooredoo 36 = Affiliate 37 = TAMATEM_PLUS */
var PurchaseSource;
(function (PurchaseSource) {
    PurchaseSource[PurchaseSource["APPLE"] = 0] = "APPLE";
    PurchaseSource[PurchaseSource["HUAWEI"] = 1] = "HUAWEI";
    PurchaseSource[PurchaseSource["GOOGLE"] = 2] = "GOOGLE";
    PurchaseSource[PurchaseSource["OFFLINE"] = 3] = "OFFLINE";
    PurchaseSource[PurchaseSource["INTERNAL"] = 4] = "INTERNAL";
    PurchaseSource[PurchaseSource["FREE"] = 5] = "FREE";
    PurchaseSource[PurchaseSource["VOUCHER"] = 6] = "VOUCHER";
    PurchaseSource[PurchaseSource["STRIPE"] = 7] = "STRIPE";
    PurchaseSource[PurchaseSource["TPAY"] = 8] = "TPAY";
    PurchaseSource[PurchaseSource["MONDIAPAY_VODAFONE"] = 10] = "MONDIAPAY_VODAFONE";
    PurchaseSource[PurchaseSource["MONDIAPAY_ETISALAT"] = 11] = "MONDIAPAY_ETISALAT";
    PurchaseSource[PurchaseSource["MONDIAPAY_ORANGE"] = 12] = "MONDIAPAY_ORANGE";
    PurchaseSource[PurchaseSource["MONDIAPAY_WE"] = 13] = "MONDIAPAY_WE";
    PurchaseSource[PurchaseSource["STCPay"] = 14] = "STCPay";
    PurchaseSource[PurchaseSource["MOBIMIND_KSA_STC"] = 16] = "MOBIMIND_KSA_STC";
    PurchaseSource[PurchaseSource["MOBIMIND_KSA_MOBILY"] = 17] = "MOBIMIND_KSA_MOBILY";
    PurchaseSource[PurchaseSource["MOBIMIND_KSA_ZAIN"] = 18] = "MOBIMIND_KSA_ZAIN";
    PurchaseSource[PurchaseSource["MOYASAR_APPLE_PAY"] = 19] = "MOYASAR_APPLE_PAY";
    PurchaseSource[PurchaseSource["MOYASAR_STCPAY"] = 20] = "MOYASAR_STCPAY";
    PurchaseSource[PurchaseSource["MOYASAR_CREDITCARD"] = 21] = "MOYASAR_CREDITCARD";
    PurchaseSource[PurchaseSource["MEDIAWORLD_ZAIN"] = 22] = "MEDIAWORLD_ZAIN";
    PurchaseSource[PurchaseSource["MEDIAWORLD_JAWWAL"] = 23] = "MEDIAWORLD_JAWWAL";
    PurchaseSource[PurchaseSource["TAMARA"] = 24] = "TAMARA";
    PurchaseSource[PurchaseSource["REWARD"] = 25] = "REWARD";
    PurchaseSource[PurchaseSource["MOBIMIND_KWT_ZAIN"] = 26] = "MOBIMIND_KWT_ZAIN";
    PurchaseSource[PurchaseSource["MOBIMIND_KWT_OOREDOO"] = 27] = "MOBIMIND_KWT_OOREDOO";
    PurchaseSource[PurchaseSource["MOBIMIND_KWT_STC"] = 28] = "MOBIMIND_KWT_STC";
    PurchaseSource[PurchaseSource["MOBIMIND_QAT_VODAFONE"] = 29] = "MOBIMIND_QAT_VODAFONE";
    PurchaseSource[PurchaseSource["MOBIMIND_QAT_OOREDOO"] = 30] = "MOBIMIND_QAT_OOREDOO";
    PurchaseSource[PurchaseSource["MOBIMIND_OMN_OMANTEL"] = 31] = "MOBIMIND_OMN_OMANTEL";
    PurchaseSource[PurchaseSource["SALES"] = 32] = "SALES";
    PurchaseSource[PurchaseSource["MOBIMIND_OMN_OOREDOO"] = 33] = "MOBIMIND_OMN_OOREDOO";
    PurchaseSource[PurchaseSource["MOBIMIND_UAE_ETISALAT"] = 34] = "MOBIMIND_UAE_ETISALAT";
    PurchaseSource[PurchaseSource["VasHouse_PSE_Ooredoo"] = 35] = "VasHouse_PSE_Ooredoo";
    PurchaseSource[PurchaseSource["Affiliate"] = 36] = "Affiliate";
    PurchaseSource[PurchaseSource["TAMATEM_PLUS"] = 37] = "TAMATEM_PLUS";
})(PurchaseSource = exports.PurchaseSource || (exports.PurchaseSource = {}));
/** 0 = SubscriptionProduct 1 = GiftProduct 2 = ContentProduct */
var ProductType;
(function (ProductType) {
    ProductType[ProductType["SubscriptionProduct"] = 0] = "SubscriptionProduct";
    ProductType[ProductType["GiftProduct"] = 1] = "GiftProduct";
    ProductType[ProductType["ContentProduct"] = 2] = "ContentProduct";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
/** 0 = IOS 1 = Android 2 = Web_STCPay 3 = Web_Moyasar 4 = Stripe 5 = Tamara 6 = Web 7 = Android_HMS */
var Platform;
(function (Platform) {
    Platform[Platform["IOS"] = 0] = "IOS";
    Platform[Platform["Android"] = 1] = "Android";
    Platform[Platform["Web_STCPay"] = 2] = "Web_STCPay";
    Platform[Platform["Web_Moyasar"] = 3] = "Web_Moyasar";
    Platform[Platform["Stripe"] = 4] = "Stripe";
    Platform[Platform["Tamara"] = 5] = "Tamara";
    Platform[Platform["Web"] = 6] = "Web";
    Platform[Platform["Android_HMS"] = 7] = "Android_HMS";
})(Platform = exports.Platform || (exports.Platform = {}));
/** 0 = Default 1 = Id 2 = GroupName 4 = Country 8 = IsDefault 16 = IsGifts 32 = IsFree 64 = DomainName 128 = DomainWeight 256 = StartsFrom 512 = EndsAt 1024 = CreatedDate */
var ProductGroupColumns;
(function (ProductGroupColumns) {
    ProductGroupColumns[ProductGroupColumns["Default"] = 0] = "Default";
    ProductGroupColumns[ProductGroupColumns["Id"] = 1] = "Id";
    ProductGroupColumns[ProductGroupColumns["GroupName"] = 2] = "GroupName";
    ProductGroupColumns[ProductGroupColumns["Country"] = 4] = "Country";
    ProductGroupColumns[ProductGroupColumns["IsDefault"] = 8] = "IsDefault";
    ProductGroupColumns[ProductGroupColumns["IsGifts"] = 16] = "IsGifts";
    ProductGroupColumns[ProductGroupColumns["IsFree"] = 32] = "IsFree";
    ProductGroupColumns[ProductGroupColumns["DomainName"] = 64] = "DomainName";
    ProductGroupColumns[ProductGroupColumns["DomainWeight"] = 128] = "DomainWeight";
    ProductGroupColumns[ProductGroupColumns["StartsFrom"] = 256] = "StartsFrom";
    ProductGroupColumns[ProductGroupColumns["EndsAt"] = 512] = "EndsAt";
    ProductGroupColumns[ProductGroupColumns["CreatedDate"] = 1024] = "CreatedDate";
})(ProductGroupColumns = exports.ProductGroupColumns || (exports.ProductGroupColumns = {}));
/** Types of the data inside columns 0 = String 1 = Guid 2 = Number 3 = Image 4 = Boolean 5 = DateTime 6 = NumberMS 7 = NumberCurrency 8 = Date 9 = Trimmable 10 = Link */
var DataType;
(function (DataType) {
    DataType[DataType["String"] = 0] = "String";
    DataType[DataType["Guid"] = 1] = "Guid";
    DataType[DataType["Number"] = 2] = "Number";
    DataType[DataType["Image"] = 3] = "Image";
    DataType[DataType["Boolean"] = 4] = "Boolean";
    DataType[DataType["DateTime"] = 5] = "DateTime";
    DataType[DataType["NumberMS"] = 6] = "NumberMS";
    DataType[DataType["NumberCurrency"] = 7] = "NumberCurrency";
    DataType[DataType["Date"] = 8] = "Date";
    DataType[DataType["Trimmable"] = 9] = "Trimmable";
    DataType[DataType["Link"] = 10] = "Link";
})(DataType = exports.DataType || (exports.DataType = {}));
/** The Comparison type that will be done between the selected column and the criteria 0 = Equal 1 = NotEqual 2 = Contain 3 = Greater 4 = GreaterOrEqual 5 = Less 6 = LessOrEqual 7 = Between */
var ComparisonType;
(function (ComparisonType) {
    ComparisonType[ComparisonType["Equal"] = 0] = "Equal";
    ComparisonType[ComparisonType["NotEqual"] = 1] = "NotEqual";
    ComparisonType[ComparisonType["Contain"] = 2] = "Contain";
    ComparisonType[ComparisonType["Greater"] = 3] = "Greater";
    ComparisonType[ComparisonType["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    ComparisonType[ComparisonType["Less"] = 5] = "Less";
    ComparisonType[ComparisonType["LessOrEqual"] = 6] = "LessOrEqual";
    ComparisonType[ComparisonType["Between"] = 7] = "Between";
})(ComparisonType = exports.ComparisonType || (exports.ComparisonType = {}));
/** The direction of the sorting operation 0 = Ascending 1 = Descending */
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection[OrderByDirection["Ascending"] = 0] = "Ascending";
    OrderByDirection[OrderByDirection["Descending"] = 1] = "Descending";
})(OrderByDirection = exports.OrderByDirection || (exports.OrderByDirection = {}));
/** 0 = MOBILE_STORE 1 = CARD_DIRECT 2 = INSTALLMENT_PLAN 3 = DCP_WALLET 4 = VOUCHER 5 = FREE 6 = INTERNAL 7 = OFFLINE 8 = REWARD 10 = Other */
var PurchaseSourceType;
(function (PurchaseSourceType) {
    PurchaseSourceType[PurchaseSourceType["MOBILE_STORE"] = 0] = "MOBILE_STORE";
    PurchaseSourceType[PurchaseSourceType["CARD_DIRECT"] = 1] = "CARD_DIRECT";
    PurchaseSourceType[PurchaseSourceType["INSTALLMENT_PLAN"] = 2] = "INSTALLMENT_PLAN";
    PurchaseSourceType[PurchaseSourceType["DCP_WALLET"] = 3] = "DCP_WALLET";
    PurchaseSourceType[PurchaseSourceType["VOUCHER"] = 4] = "VOUCHER";
    PurchaseSourceType[PurchaseSourceType["FREE"] = 5] = "FREE";
    PurchaseSourceType[PurchaseSourceType["INTERNAL"] = 6] = "INTERNAL";
    PurchaseSourceType[PurchaseSourceType["OFFLINE"] = 7] = "OFFLINE";
    PurchaseSourceType[PurchaseSourceType["REWARD"] = 8] = "REWARD";
    PurchaseSourceType[PurchaseSourceType["Other"] = 10] = "Other";
})(PurchaseSourceType = exports.PurchaseSourceType || (exports.PurchaseSourceType = {}));
/** 0 = UNKNOWN_REPLACEMENT_MODE 1 = WITH_TIME_PRORATION 2 = CHARGE_PRORATED_PRICE 3 = WITHOUT_PRORATION 5 = CHARGE_FULL_PRICE 6 = DEFERRED */
var UpgradeType;
(function (UpgradeType) {
    UpgradeType[UpgradeType["UNKNOWN_REPLACEMENT_MODE"] = 0] = "UNKNOWN_REPLACEMENT_MODE";
    UpgradeType[UpgradeType["WITH_TIME_PRORATION"] = 1] = "WITH_TIME_PRORATION";
    UpgradeType[UpgradeType["CHARGE_PRORATED_PRICE"] = 2] = "CHARGE_PRORATED_PRICE";
    UpgradeType[UpgradeType["WITHOUT_PRORATION"] = 3] = "WITHOUT_PRORATION";
    UpgradeType[UpgradeType["CHARGE_FULL_PRICE"] = 5] = "CHARGE_FULL_PRICE";
    UpgradeType[UpgradeType["DEFERRED"] = 6] = "DEFERRED";
})(UpgradeType = exports.UpgradeType || (exports.UpgradeType = {}));
/** 1 = New 2 = ReNew */
var SubscriptionCustomerProductType;
(function (SubscriptionCustomerProductType) {
    SubscriptionCustomerProductType[SubscriptionCustomerProductType["New"] = 1] = "New";
    SubscriptionCustomerProductType[SubscriptionCustomerProductType["ReNew"] = 2] = "ReNew";
})(SubscriptionCustomerProductType = exports.SubscriptionCustomerProductType || (exports.SubscriptionCustomerProductType = {}));
/** 0 = Default 1 = Id 2 = Name 4 = ExpiresOn 8 = ProductGroupId 16 = CreatedDate */
var PromoCodeColumns;
(function (PromoCodeColumns) {
    PromoCodeColumns[PromoCodeColumns["Default"] = 0] = "Default";
    PromoCodeColumns[PromoCodeColumns["Id"] = 1] = "Id";
    PromoCodeColumns[PromoCodeColumns["Name"] = 2] = "Name";
    PromoCodeColumns[PromoCodeColumns["ExpiresOn"] = 4] = "ExpiresOn";
    PromoCodeColumns[PromoCodeColumns["ProductGroupId"] = 8] = "ProductGroupId";
    PromoCodeColumns[PromoCodeColumns["CreatedDate"] = 16] = "CreatedDate";
})(PromoCodeColumns = exports.PromoCodeColumns || (exports.PromoCodeColumns = {}));
/** 1 = Active 2 = Store 3 = Cancelled 4 = Disabled */
var SubscriptionContractCancellationState;
(function (SubscriptionContractCancellationState) {
    SubscriptionContractCancellationState[SubscriptionContractCancellationState["Active"] = 1] = "Active";
    SubscriptionContractCancellationState[SubscriptionContractCancellationState["Store"] = 2] = "Store";
    SubscriptionContractCancellationState[SubscriptionContractCancellationState["Cancelled"] = 3] = "Cancelled";
    SubscriptionContractCancellationState[SubscriptionContractCancellationState["Disabled"] = 4] = "Disabled";
})(SubscriptionContractCancellationState = exports.SubscriptionContractCancellationState || (exports.SubscriptionContractCancellationState = {}));
/** 0 = Pending 1 = Auto */
var RedeemVoucherState;
(function (RedeemVoucherState) {
    RedeemVoucherState[RedeemVoucherState["Pending"] = 0] = "Pending";
    RedeemVoucherState[RedeemVoucherState["Auto"] = 1] = "Auto";
})(RedeemVoucherState = exports.RedeemVoucherState || (exports.RedeemVoucherState = {}));
/** 0 = Default 1 = Id 2 = PurchaseType 4 = PurchaseProviderKey 8 = PurchaseSource 16 = GroupId 32 = ProductType 64 = Duration 128 = ProductDuration 256 = SubscriptionPeriod 512 = Name 1024 = InitialAmount 2048 = Amount 4096 = Currency 8192 = CurrencyCode 16384 = PurchaseSourceType 32768 = PurchaseSourceIconLightReference 65536 = PurchaseSourceIconDarkReference 131072 = PurchaseSourceIconLightURL 262144 = PurchaseSourceIconDarkURL */
var ProductsColumns;
(function (ProductsColumns) {
    ProductsColumns[ProductsColumns["Default"] = 0] = "Default";
    ProductsColumns[ProductsColumns["Id"] = 1] = "Id";
    ProductsColumns[ProductsColumns["PurchaseType"] = 2] = "PurchaseType";
    ProductsColumns[ProductsColumns["PurchaseProviderKey"] = 4] = "PurchaseProviderKey";
    ProductsColumns[ProductsColumns["PurchaseSource"] = 8] = "PurchaseSource";
    ProductsColumns[ProductsColumns["GroupId"] = 16] = "GroupId";
    ProductsColumns[ProductsColumns["ProductType"] = 32] = "ProductType";
    ProductsColumns[ProductsColumns["Duration"] = 64] = "Duration";
    ProductsColumns[ProductsColumns["ProductDuration"] = 128] = "ProductDuration";
    ProductsColumns[ProductsColumns["SubscriptionPeriod"] = 256] = "SubscriptionPeriod";
    ProductsColumns[ProductsColumns["Name"] = 512] = "Name";
    ProductsColumns[ProductsColumns["InitialAmount"] = 1024] = "InitialAmount";
    ProductsColumns[ProductsColumns["Amount"] = 2048] = "Amount";
    ProductsColumns[ProductsColumns["Currency"] = 4096] = "Currency";
    ProductsColumns[ProductsColumns["CurrencyCode"] = 8192] = "CurrencyCode";
    ProductsColumns[ProductsColumns["PurchaseSourceType"] = 16384] = "PurchaseSourceType";
    ProductsColumns[ProductsColumns["PurchaseSourceIconLightReference"] = 32768] = "PurchaseSourceIconLightReference";
    ProductsColumns[ProductsColumns["PurchaseSourceIconDarkReference"] = 65536] = "PurchaseSourceIconDarkReference";
    ProductsColumns[ProductsColumns["PurchaseSourceIconLightURL"] = 131072] = "PurchaseSourceIconLightURL";
    ProductsColumns[ProductsColumns["PurchaseSourceIconDarkURL"] = 262144] = "PurchaseSourceIconDarkURL";
})(ProductsColumns = exports.ProductsColumns || (exports.ProductsColumns = {}));
/** 0 = Default 1 = Id 2 = Code 4 = Published 8 = Notes 16 = PromoCode 32 = ExpiresOn 64 = PromoCodeId */
var PromoCodeAliasColumns;
(function (PromoCodeAliasColumns) {
    PromoCodeAliasColumns[PromoCodeAliasColumns["Default"] = 0] = "Default";
    PromoCodeAliasColumns[PromoCodeAliasColumns["Id"] = 1] = "Id";
    PromoCodeAliasColumns[PromoCodeAliasColumns["Code"] = 2] = "Code";
    PromoCodeAliasColumns[PromoCodeAliasColumns["Published"] = 4] = "Published";
    PromoCodeAliasColumns[PromoCodeAliasColumns["Notes"] = 8] = "Notes";
    PromoCodeAliasColumns[PromoCodeAliasColumns["PromoCode"] = 16] = "PromoCode";
    PromoCodeAliasColumns[PromoCodeAliasColumns["ExpiresOn"] = 32] = "ExpiresOn";
    PromoCodeAliasColumns[PromoCodeAliasColumns["PromoCodeId"] = 64] = "PromoCodeId";
})(PromoCodeAliasColumns = exports.PromoCodeAliasColumns || (exports.PromoCodeAliasColumns = {}));
/** 0 = AlphaNumeric 1 = Numeric 2 = Alphabetic 3 = CapitalAlphaNumeric 4 = SmallAlphaNumeric 5 = CapitalAlphabetic 6 = SmallAlphabetic */
var RandomStringType;
(function (RandomStringType) {
    RandomStringType[RandomStringType["AlphaNumeric"] = 0] = "AlphaNumeric";
    RandomStringType[RandomStringType["Numeric"] = 1] = "Numeric";
    RandomStringType[RandomStringType["Alphabetic"] = 2] = "Alphabetic";
    RandomStringType[RandomStringType["CapitalAlphaNumeric"] = 3] = "CapitalAlphaNumeric";
    RandomStringType[RandomStringType["SmallAlphaNumeric"] = 4] = "SmallAlphaNumeric";
    RandomStringType[RandomStringType["CapitalAlphabetic"] = 5] = "CapitalAlphabetic";
    RandomStringType[RandomStringType["SmallAlphabetic"] = 6] = "SmallAlphabetic";
})(RandomStringType = exports.RandomStringType || (exports.RandomStringType = {}));
/** 0 = Default 1 = Id 2 = ProductId 4 = Code 8 = UsageLimit 16 = RedeemableBySameUserMoreThanOnce 32 = ExpirationDate 64 = Published 128 = CreatedDate 256 = UpdatedDate */
var VoucherColumns;
(function (VoucherColumns) {
    VoucherColumns[VoucherColumns["Default"] = 0] = "Default";
    VoucherColumns[VoucherColumns["Id"] = 1] = "Id";
    VoucherColumns[VoucherColumns["ProductId"] = 2] = "ProductId";
    VoucherColumns[VoucherColumns["Code"] = 4] = "Code";
    VoucherColumns[VoucherColumns["UsageLimit"] = 8] = "UsageLimit";
    VoucherColumns[VoucherColumns["RedeemableBySameUserMoreThanOnce"] = 16] = "RedeemableBySameUserMoreThanOnce";
    VoucherColumns[VoucherColumns["ExpirationDate"] = 32] = "ExpirationDate";
    VoucherColumns[VoucherColumns["Published"] = 64] = "Published";
    VoucherColumns[VoucherColumns["CreatedDate"] = 128] = "CreatedDate";
    VoucherColumns[VoucherColumns["UpdatedDate"] = 256] = "UpdatedDate";
})(VoucherColumns = exports.VoucherColumns || (exports.VoucherColumns = {}));
/** 0 = WEBP */
var ImageFormats;
(function (ImageFormats) {
    ImageFormats[ImageFormats["WEBP"] = 0] = "WEBP";
})(ImageFormats = exports.ImageFormats || (exports.ImageFormats = {}));
/** 0 = Male 1 = Female */
var Gender;
(function (Gender) {
    Gender[Gender["Male"] = 0] = "Male";
    Gender[Gender["Female"] = 1] = "Female";
})(Gender = exports.Gender || (exports.Gender = {}));
/** 0 = Listining 1 = Reading */
var PlayerMode;
(function (PlayerMode) {
    PlayerMode[PlayerMode["Listining"] = 0] = "Listining";
    PlayerMode[PlayerMode["Reading"] = 1] = "Reading";
})(PlayerMode = exports.PlayerMode || (exports.PlayerMode = {}));
/** 0 = Apple 1 = Google 2 = Huawei 3 = Others 4 = Web */
var OperatingSystems;
(function (OperatingSystems) {
    OperatingSystems[OperatingSystems["Apple"] = 0] = "Apple";
    OperatingSystems[OperatingSystems["Google"] = 1] = "Google";
    OperatingSystems[OperatingSystems["Huawei"] = 2] = "Huawei";
    OperatingSystems[OperatingSystems["Others"] = 3] = "Others";
    OperatingSystems[OperatingSystems["Web"] = 4] = "Web";
})(OperatingSystems = exports.OperatingSystems || (exports.OperatingSystems = {}));
/** 0 = EmailPassword 1 = CreatePassword 2 = ExternalProvider */
var LoginOption;
(function (LoginOption) {
    LoginOption[LoginOption["EmailPassword"] = 0] = "EmailPassword";
    LoginOption[LoginOption["CreatePassword"] = 1] = "CreatePassword";
    LoginOption[LoginOption["ExternalProvider"] = 2] = "ExternalProvider";
})(LoginOption = exports.LoginOption || (exports.LoginOption = {}));
/** 0 = All 9 = OnlyAccountSpicific 10 = None */
var EmailSubscriptionLevel;
(function (EmailSubscriptionLevel) {
    EmailSubscriptionLevel[EmailSubscriptionLevel["All"] = 0] = "All";
    EmailSubscriptionLevel[EmailSubscriptionLevel["OnlyAccountSpicific"] = 9] = "OnlyAccountSpicific";
    EmailSubscriptionLevel[EmailSubscriptionLevel["None"] = 10] = "None";
})(EmailSubscriptionLevel = exports.EmailSubscriptionLevel || (exports.EmailSubscriptionLevel = {}));
/** 0 = Default 1 = Id 2 = Name 4 = Email 8 = CreatedDate 16 = IsBlocked 32 = UpdatedDate 64 = PhoneNumber 128 = Gender 256 = ProfilePictureUrl 512 = IsVerified 1024 = Plans */
var UserColumns;
(function (UserColumns) {
    UserColumns[UserColumns["Default"] = 0] = "Default";
    UserColumns[UserColumns["Id"] = 1] = "Id";
    UserColumns[UserColumns["Name"] = 2] = "Name";
    UserColumns[UserColumns["Email"] = 4] = "Email";
    UserColumns[UserColumns["CreatedDate"] = 8] = "CreatedDate";
    UserColumns[UserColumns["IsBlocked"] = 16] = "IsBlocked";
    UserColumns[UserColumns["UpdatedDate"] = 32] = "UpdatedDate";
    UserColumns[UserColumns["PhoneNumber"] = 64] = "PhoneNumber";
    UserColumns[UserColumns["Gender"] = 128] = "Gender";
    UserColumns[UserColumns["ProfilePictureUrl"] = 256] = "ProfilePictureUrl";
    UserColumns[UserColumns["IsVerified"] = 512] = "IsVerified";
    UserColumns[UserColumns["Plans"] = 1024] = "Plans";
})(UserColumns = exports.UserColumns || (exports.UserColumns = {}));
/** 0 = Default 1 = Id 2 = Question 4 = Answer */
var FaqColumns;
(function (FaqColumns) {
    FaqColumns[FaqColumns["Default"] = 0] = "Default";
    FaqColumns[FaqColumns["Id"] = 1] = "Id";
    FaqColumns[FaqColumns["Question"] = 2] = "Question";
    FaqColumns[FaqColumns["Answer"] = 4] = "Answer";
})(FaqColumns = exports.FaqColumns || (exports.FaqColumns = {}));
/** 0 = PrivacyPolicy 1 = TermsOfService 2 = About 3 = PrivacyWeb 4 = TOCWeb */
var PolicyType;
(function (PolicyType) {
    PolicyType[PolicyType["PrivacyPolicy"] = 0] = "PrivacyPolicy";
    PolicyType[PolicyType["TermsOfService"] = 1] = "TermsOfService";
    PolicyType[PolicyType["About"] = 2] = "About";
    PolicyType[PolicyType["PrivacyWeb"] = 3] = "PrivacyWeb";
    PolicyType[PolicyType["TOCWeb"] = 4] = "TOCWeb";
})(PolicyType = exports.PolicyType || (exports.PolicyType = {}));
/** 0 = Default 1 = Id 2 = ReaderId 4 = ContentEntityId 8 = ContentEntityTitle 16 = Email 32 = ProblemOptionType 64 = Text 128 = State 256 = CreatedDate */
var ReportProblemColumns;
(function (ReportProblemColumns) {
    ReportProblemColumns[ReportProblemColumns["Default"] = 0] = "Default";
    ReportProblemColumns[ReportProblemColumns["Id"] = 1] = "Id";
    ReportProblemColumns[ReportProblemColumns["ReaderId"] = 2] = "ReaderId";
    ReportProblemColumns[ReportProblemColumns["ContentEntityId"] = 4] = "ContentEntityId";
    ReportProblemColumns[ReportProblemColumns["ContentEntityTitle"] = 8] = "ContentEntityTitle";
    ReportProblemColumns[ReportProblemColumns["Email"] = 16] = "Email";
    ReportProblemColumns[ReportProblemColumns["ProblemOptionType"] = 32] = "ProblemOptionType";
    ReportProblemColumns[ReportProblemColumns["Text"] = 64] = "Text";
    ReportProblemColumns[ReportProblemColumns["State"] = 128] = "State";
    ReportProblemColumns[ReportProblemColumns["CreatedDate"] = 256] = "CreatedDate";
})(ReportProblemColumns = exports.ReportProblemColumns || (exports.ReportProblemColumns = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Title 8 = CreateDate */
var SuggestContentColumns;
(function (SuggestContentColumns) {
    SuggestContentColumns[SuggestContentColumns["Default"] = 0] = "Default";
    SuggestContentColumns[SuggestContentColumns["Id"] = 1] = "Id";
    SuggestContentColumns[SuggestContentColumns["UserId"] = 2] = "UserId";
    SuggestContentColumns[SuggestContentColumns["Title"] = 4] = "Title";
    SuggestContentColumns[SuggestContentColumns["CreateDate"] = 8] = "CreateDate";
})(SuggestContentColumns = exports.SuggestContentColumns || (exports.SuggestContentColumns = {}));
/** 0 = Default 1 = UserId 2 = Email 4 = PhoneNumber 8 = SummaryReference 16 = CreatedDate */
var UserSummaryColumns;
(function (UserSummaryColumns) {
    UserSummaryColumns[UserSummaryColumns["Default"] = 0] = "Default";
    UserSummaryColumns[UserSummaryColumns["UserId"] = 1] = "UserId";
    UserSummaryColumns[UserSummaryColumns["Email"] = 2] = "Email";
    UserSummaryColumns[UserSummaryColumns["PhoneNumber"] = 4] = "PhoneNumber";
    UserSummaryColumns[UserSummaryColumns["SummaryReference"] = 8] = "SummaryReference";
    UserSummaryColumns[UserSummaryColumns["CreatedDate"] = 16] = "CreatedDate";
})(UserSummaryColumns = exports.UserSummaryColumns || (exports.UserSummaryColumns = {}));
/** 0 = Moderator 1 = SalesMan 2 = SalesManager 3 = Influencer 4 = PublisherUser */
var UtilityUserRole;
(function (UtilityUserRole) {
    UtilityUserRole[UtilityUserRole["Moderator"] = 0] = "Moderator";
    UtilityUserRole[UtilityUserRole["SalesMan"] = 1] = "SalesMan";
    UtilityUserRole[UtilityUserRole["SalesManager"] = 2] = "SalesManager";
    UtilityUserRole[UtilityUserRole["Influencer"] = 3] = "Influencer";
    UtilityUserRole[UtilityUserRole["PublisherUser"] = 4] = "PublisherUser";
})(UtilityUserRole = exports.UtilityUserRole || (exports.UtilityUserRole = {}));
/** 0 = Activated 1 = Disabled */
var UtilityUserState;
(function (UtilityUserState) {
    UtilityUserState[UtilityUserState["Activated"] = 0] = "Activated";
    UtilityUserState[UtilityUserState["Disabled"] = 1] = "Disabled";
})(UtilityUserState = exports.UtilityUserState || (exports.UtilityUserState = {}));
/** 0 = Default 1 = Id 2 = EmployeeName 4 = Email 8 = EmployeeStatus 16 = Publisher */
var UtilityUsersColumns;
(function (UtilityUsersColumns) {
    UtilityUsersColumns[UtilityUsersColumns["Default"] = 0] = "Default";
    UtilityUsersColumns[UtilityUsersColumns["Id"] = 1] = "Id";
    UtilityUsersColumns[UtilityUsersColumns["EmployeeName"] = 2] = "EmployeeName";
    UtilityUsersColumns[UtilityUsersColumns["Email"] = 4] = "Email";
    UtilityUsersColumns[UtilityUsersColumns["EmployeeStatus"] = 8] = "EmployeeStatus";
    UtilityUsersColumns[UtilityUsersColumns["Publisher"] = 16] = "Publisher";
})(UtilityUsersColumns = exports.UtilityUsersColumns || (exports.UtilityUsersColumns = {}));
/** 1 = Cash 2 = Visa 3 = CliQ */
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["Cash"] = 1] = "Cash";
    PaymentMethod[PaymentMethod["Visa"] = 2] = "Visa";
    PaymentMethod[PaymentMethod["CliQ"] = 3] = "CliQ";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
/** 0 = Default 1 = VoucherId 2 = ConsumerEmail 8 = SalesUserEmail 16 = Redeemed 32 = Refunded 64 = PaymentMethod */
var UtilityVouchersAnalysisColumns;
(function (UtilityVouchersAnalysisColumns) {
    UtilityVouchersAnalysisColumns[UtilityVouchersAnalysisColumns["Default"] = 0] = "Default";
    UtilityVouchersAnalysisColumns[UtilityVouchersAnalysisColumns["VoucherId"] = 1] = "VoucherId";
    UtilityVouchersAnalysisColumns[UtilityVouchersAnalysisColumns["ConsumerEmail"] = 2] = "ConsumerEmail";
    UtilityVouchersAnalysisColumns[UtilityVouchersAnalysisColumns["SalesUserEmail"] = 8] = "SalesUserEmail";
    UtilityVouchersAnalysisColumns[UtilityVouchersAnalysisColumns["Redeemed"] = 16] = "Redeemed";
    UtilityVouchersAnalysisColumns[UtilityVouchersAnalysisColumns["Refunded"] = 32] = "Refunded";
    UtilityVouchersAnalysisColumns[UtilityVouchersAnalysisColumns["PaymentMethod"] = 64] = "PaymentMethod";
})(UtilityVouchersAnalysisColumns = exports.UtilityVouchersAnalysisColumns || (exports.UtilityVouchersAnalysisColumns = {}));
/** 1 = VeryBad 2 = Bad 3 = Neutral 4 = Good 5 = VeryGood */
var AppRateOptionType;
(function (AppRateOptionType) {
    AppRateOptionType[AppRateOptionType["VeryBad"] = 1] = "VeryBad";
    AppRateOptionType[AppRateOptionType["Bad"] = 2] = "Bad";
    AppRateOptionType[AppRateOptionType["Neutral"] = 3] = "Neutral";
    AppRateOptionType[AppRateOptionType["Good"] = 4] = "Good";
    AppRateOptionType[AppRateOptionType["VeryGood"] = 5] = "VeryGood";
})(AppRateOptionType = exports.AppRateOptionType || (exports.AppRateOptionType = {}));
/** 0 = MixPanel 2 = Firebase */
var EventProvider;
(function (EventProvider) {
    EventProvider[EventProvider["MixPanel"] = 0] = "MixPanel";
    EventProvider[EventProvider["Firebase"] = 2] = "Firebase";
})(EventProvider = exports.EventProvider || (exports.EventProvider = {}));
/** 1 = SubscriptionCancellation 2 = WhatBroughtYouToWajeez */
var FeedbackType;
(function (FeedbackType) {
    FeedbackType[FeedbackType["SubscriptionCancellation"] = 1] = "SubscriptionCancellation";
    FeedbackType[FeedbackType["WhatBroughtYouToWajeez"] = 2] = "WhatBroughtYouToWajeez";
})(FeedbackType = exports.FeedbackType || (exports.FeedbackType = {}));
/** 0 = Pending 1 = Accepted 2 = Rejected */
var RequestState;
(function (RequestState) {
    RequestState[RequestState["Pending"] = 0] = "Pending";
    RequestState[RequestState["Accepted"] = 1] = "Accepted";
    RequestState[RequestState["Rejected"] = 2] = "Rejected";
})(RequestState = exports.RequestState || (exports.RequestState = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Name 8 = Email 16 = Voucher 32 = RequestState 64 = RequestDate */
var BusinessGroupRequestColumns;
(function (BusinessGroupRequestColumns) {
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Default"] = 0] = "Default";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Id"] = 1] = "Id";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["UserId"] = 2] = "UserId";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Name"] = 4] = "Name";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Email"] = 8] = "Email";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Voucher"] = 16] = "Voucher";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["RequestState"] = 32] = "RequestState";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["RequestDate"] = 64] = "RequestDate";
})(BusinessGroupRequestColumns = exports.BusinessGroupRequestColumns || (exports.BusinessGroupRequestColumns = {}));
/** 0 = User 1 = Moderator 2 = Admin */
var BusinessGroupUserRole;
(function (BusinessGroupUserRole) {
    BusinessGroupUserRole[BusinessGroupUserRole["User"] = 0] = "User";
    BusinessGroupUserRole[BusinessGroupUserRole["Moderator"] = 1] = "Moderator";
    BusinessGroupUserRole[BusinessGroupUserRole["Admin"] = 2] = "Admin";
})(BusinessGroupUserRole = exports.BusinessGroupUserRole || (exports.BusinessGroupUserRole = {}));
/** 0 = Activated 1 = DeActivated */
var UserState;
(function (UserState) {
    UserState[UserState["Activated"] = 0] = "Activated";
    UserState[UserState["DeActivated"] = 1] = "DeActivated";
})(UserState = exports.UserState || (exports.UserState = {}));
/** 0 = Manually 1 = Document 2 = Voucher 3 = WajeezAdmin 4 = Domain */
var RegisterationMethod;
(function (RegisterationMethod) {
    RegisterationMethod[RegisterationMethod["Manually"] = 0] = "Manually";
    RegisterationMethod[RegisterationMethod["Document"] = 1] = "Document";
    RegisterationMethod[RegisterationMethod["Voucher"] = 2] = "Voucher";
    RegisterationMethod[RegisterationMethod["WajeezAdmin"] = 3] = "WajeezAdmin";
    RegisterationMethod[RegisterationMethod["Domain"] = 4] = "Domain";
})(RegisterationMethod = exports.RegisterationMethod || (exports.RegisterationMethod = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Name 8 = Email 16 = IsUsed 32 = UserState 64 = DepartmentName 128 = UserUserRoleRole 256 = RegisterationMethod 512 = IsDepartmentModerator 1024 = CreatedDate */
var BusinessGroupUserColumns;
(function (BusinessGroupUserColumns) {
    BusinessGroupUserColumns[BusinessGroupUserColumns["Default"] = 0] = "Default";
    BusinessGroupUserColumns[BusinessGroupUserColumns["Id"] = 1] = "Id";
    BusinessGroupUserColumns[BusinessGroupUserColumns["UserId"] = 2] = "UserId";
    BusinessGroupUserColumns[BusinessGroupUserColumns["Name"] = 4] = "Name";
    BusinessGroupUserColumns[BusinessGroupUserColumns["Email"] = 8] = "Email";
    BusinessGroupUserColumns[BusinessGroupUserColumns["IsUsed"] = 16] = "IsUsed";
    BusinessGroupUserColumns[BusinessGroupUserColumns["UserState"] = 32] = "UserState";
    BusinessGroupUserColumns[BusinessGroupUserColumns["DepartmentName"] = 64] = "DepartmentName";
    BusinessGroupUserColumns[BusinessGroupUserColumns["UserUserRoleRole"] = 128] = "UserUserRoleRole";
    BusinessGroupUserColumns[BusinessGroupUserColumns["RegisterationMethod"] = 256] = "RegisterationMethod";
    BusinessGroupUserColumns[BusinessGroupUserColumns["IsDepartmentModerator"] = 512] = "IsDepartmentModerator";
    BusinessGroupUserColumns[BusinessGroupUserColumns["CreatedDate"] = 1024] = "CreatedDate";
})(BusinessGroupUserColumns = exports.BusinessGroupUserColumns || (exports.BusinessGroupUserColumns = {}));
/** 0 = Default 1 = Id 2 = Code 4 = Accepted 8 = Rejected 16 = Pending 32 = UsageLimit 64 = StartDate 128 = ExpirationDate 256 = AutoApprove 512 = Published 1024 = DepartmentName */
var BusinessGroupVoucherColumns;
(function (BusinessGroupVoucherColumns) {
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Default"] = 0] = "Default";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Id"] = 1] = "Id";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Code"] = 2] = "Code";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Accepted"] = 4] = "Accepted";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Rejected"] = 8] = "Rejected";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Pending"] = 16] = "Pending";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["UsageLimit"] = 32] = "UsageLimit";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["StartDate"] = 64] = "StartDate";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["ExpirationDate"] = 128] = "ExpirationDate";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["AutoApprove"] = 256] = "AutoApprove";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Published"] = 512] = "Published";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["DepartmentName"] = 1024] = "DepartmentName";
})(BusinessGroupVoucherColumns = exports.BusinessGroupVoucherColumns || (exports.BusinessGroupVoucherColumns = {}));
/** 0 = Default 1 = UserId 2 = Rate 4 = Notes 8 = CreatedDate 16 = Options */
var AppRateColumns;
(function (AppRateColumns) {
    AppRateColumns[AppRateColumns["Default"] = 0] = "Default";
    AppRateColumns[AppRateColumns["UserId"] = 1] = "UserId";
    AppRateColumns[AppRateColumns["Rate"] = 2] = "Rate";
    AppRateColumns[AppRateColumns["Notes"] = 4] = "Notes";
    AppRateColumns[AppRateColumns["CreatedDate"] = 8] = "CreatedDate";
    AppRateColumns[AppRateColumns["Options"] = 16] = "Options";
})(AppRateColumns = exports.AppRateColumns || (exports.AppRateColumns = {}));
/** 0 = Default 1 = Id 2 = Name 4 = Prefix 8 = PhoneNumber 16 = Address 32 = Email 64 = LogoReference 128 = ThemeColor 256 = AnnualGoal 512 = UsersLimit 1024 = CurrentUsage 2048 = IsActive 4096 = ExpiresOn */
var BusinessGroupColumns;
(function (BusinessGroupColumns) {
    BusinessGroupColumns[BusinessGroupColumns["Default"] = 0] = "Default";
    BusinessGroupColumns[BusinessGroupColumns["Id"] = 1] = "Id";
    BusinessGroupColumns[BusinessGroupColumns["Name"] = 2] = "Name";
    BusinessGroupColumns[BusinessGroupColumns["Prefix"] = 4] = "Prefix";
    BusinessGroupColumns[BusinessGroupColumns["PhoneNumber"] = 8] = "PhoneNumber";
    BusinessGroupColumns[BusinessGroupColumns["Address"] = 16] = "Address";
    BusinessGroupColumns[BusinessGroupColumns["Email"] = 32] = "Email";
    BusinessGroupColumns[BusinessGroupColumns["LogoReference"] = 64] = "LogoReference";
    BusinessGroupColumns[BusinessGroupColumns["ThemeColor"] = 128] = "ThemeColor";
    BusinessGroupColumns[BusinessGroupColumns["AnnualGoal"] = 256] = "AnnualGoal";
    BusinessGroupColumns[BusinessGroupColumns["UsersLimit"] = 512] = "UsersLimit";
    BusinessGroupColumns[BusinessGroupColumns["CurrentUsage"] = 1024] = "CurrentUsage";
    BusinessGroupColumns[BusinessGroupColumns["IsActive"] = 2048] = "IsActive";
    BusinessGroupColumns[BusinessGroupColumns["ExpiresOn"] = 4096] = "ExpiresOn";
})(BusinessGroupColumns = exports.BusinessGroupColumns || (exports.BusinessGroupColumns = {}));
/** 0 = Default 1 = Id 2 = CreatedOn 4 = Quantity */
var BusinessGroupQuantityColumns;
(function (BusinessGroupQuantityColumns) {
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["Default"] = 0] = "Default";
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["Id"] = 1] = "Id";
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["CreatedOn"] = 2] = "CreatedOn";
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["Quantity"] = 4] = "Quantity";
})(BusinessGroupQuantityColumns = exports.BusinessGroupQuantityColumns || (exports.BusinessGroupQuantityColumns = {}));
/** 0 = Default 1 = Id 2 = StartsOn 4 = ExpiresOn 8 = Notes */
var BusinessGroupSubscriptionColumns;
(function (BusinessGroupSubscriptionColumns) {
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["Default"] = 0] = "Default";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["Id"] = 1] = "Id";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["StartsOn"] = 2] = "StartsOn";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["ExpiresOn"] = 4] = "ExpiresOn";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["Notes"] = 8] = "Notes";
})(BusinessGroupSubscriptionColumns = exports.BusinessGroupSubscriptionColumns || (exports.BusinessGroupSubscriptionColumns = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Email 8 = Text 16 = CreatedDate 32 = State 64 = CustomerSupportTicketUrl 128 = TicketId */
var ContactUsColumns;
(function (ContactUsColumns) {
    ContactUsColumns[ContactUsColumns["Default"] = 0] = "Default";
    ContactUsColumns[ContactUsColumns["Id"] = 1] = "Id";
    ContactUsColumns[ContactUsColumns["UserId"] = 2] = "UserId";
    ContactUsColumns[ContactUsColumns["Email"] = 4] = "Email";
    ContactUsColumns[ContactUsColumns["Text"] = 8] = "Text";
    ContactUsColumns[ContactUsColumns["CreatedDate"] = 16] = "CreatedDate";
    ContactUsColumns[ContactUsColumns["State"] = 32] = "State";
    ContactUsColumns[ContactUsColumns["CustomerSupportTicketUrl"] = 64] = "CustomerSupportTicketUrl";
    ContactUsColumns[ContactUsColumns["TicketId"] = 128] = "TicketId";
})(ContactUsColumns = exports.ContactUsColumns || (exports.ContactUsColumns = {}));
/** 0 = Default 1 = Id 2 = EventKey 4 = EventValue 8 = Published 16 = Platform 32 = AppVersion 64 = EventProviders */
var EventKeyMappingsColumns;
(function (EventKeyMappingsColumns) {
    EventKeyMappingsColumns[EventKeyMappingsColumns["Default"] = 0] = "Default";
    EventKeyMappingsColumns[EventKeyMappingsColumns["Id"] = 1] = "Id";
    EventKeyMappingsColumns[EventKeyMappingsColumns["EventKey"] = 2] = "EventKey";
    EventKeyMappingsColumns[EventKeyMappingsColumns["EventValue"] = 4] = "EventValue";
    EventKeyMappingsColumns[EventKeyMappingsColumns["Published"] = 8] = "Published";
    EventKeyMappingsColumns[EventKeyMappingsColumns["Platform"] = 16] = "Platform";
    EventKeyMappingsColumns[EventKeyMappingsColumns["AppVersion"] = 32] = "AppVersion";
    EventKeyMappingsColumns[EventKeyMappingsColumns["EventProviders"] = 64] = "EventProviders";
})(EventKeyMappingsColumns = exports.EventKeyMappingsColumns || (exports.EventKeyMappingsColumns = {}));
/** 0 = Default 1 = Id 2 = LanguageId 4 = Text 8 = Type 16 = Order 32 = ShowTextEntry 64 = TextEntryRequired 128 = ImageReference */
var FeedbackOptionColumns;
(function (FeedbackOptionColumns) {
    FeedbackOptionColumns[FeedbackOptionColumns["Default"] = 0] = "Default";
    FeedbackOptionColumns[FeedbackOptionColumns["Id"] = 1] = "Id";
    FeedbackOptionColumns[FeedbackOptionColumns["LanguageId"] = 2] = "LanguageId";
    FeedbackOptionColumns[FeedbackOptionColumns["Text"] = 4] = "Text";
    FeedbackOptionColumns[FeedbackOptionColumns["Type"] = 8] = "Type";
    FeedbackOptionColumns[FeedbackOptionColumns["Order"] = 16] = "Order";
    FeedbackOptionColumns[FeedbackOptionColumns["ShowTextEntry"] = 32] = "ShowTextEntry";
    FeedbackOptionColumns[FeedbackOptionColumns["TextEntryRequired"] = 64] = "TextEntryRequired";
    FeedbackOptionColumns[FeedbackOptionColumns["ImageReference"] = 128] = "ImageReference";
})(FeedbackOptionColumns = exports.FeedbackOptionColumns || (exports.FeedbackOptionColumns = {}));
/** 0 = Default 1 = UserId 2 = Text 4 = Notes 8 = CreatedDate */
var FeedbackColumns;
(function (FeedbackColumns) {
    FeedbackColumns[FeedbackColumns["Default"] = 0] = "Default";
    FeedbackColumns[FeedbackColumns["UserId"] = 1] = "UserId";
    FeedbackColumns[FeedbackColumns["Text"] = 2] = "Text";
    FeedbackColumns[FeedbackColumns["Notes"] = 4] = "Notes";
    FeedbackColumns[FeedbackColumns["CreatedDate"] = 8] = "CreatedDate";
})(FeedbackColumns = exports.FeedbackColumns || (exports.FeedbackColumns = {}));
/** 0 = Default 1 = Id 2 = Key 4 = Value */
var SystemConfigColumns;
(function (SystemConfigColumns) {
    SystemConfigColumns[SystemConfigColumns["Default"] = 0] = "Default";
    SystemConfigColumns[SystemConfigColumns["Id"] = 1] = "Id";
    SystemConfigColumns[SystemConfigColumns["Key"] = 2] = "Key";
    SystemConfigColumns[SystemConfigColumns["Value"] = 4] = "Value";
})(SystemConfigColumns = exports.SystemConfigColumns || (exports.SystemConfigColumns = {}));
/** 0 = Welcome 1 = EmailVerification 2 = PasswordReset 3 = StripeConfirmation 4 = TahakomWelcome 5 = SudairWelcome 6 = MedGulfWelcome */
var FixedEmailTemplate;
(function (FixedEmailTemplate) {
    FixedEmailTemplate[FixedEmailTemplate["Welcome"] = 0] = "Welcome";
    FixedEmailTemplate[FixedEmailTemplate["EmailVerification"] = 1] = "EmailVerification";
    FixedEmailTemplate[FixedEmailTemplate["PasswordReset"] = 2] = "PasswordReset";
    FixedEmailTemplate[FixedEmailTemplate["StripeConfirmation"] = 3] = "StripeConfirmation";
    FixedEmailTemplate[FixedEmailTemplate["TahakomWelcome"] = 4] = "TahakomWelcome";
    FixedEmailTemplate[FixedEmailTemplate["SudairWelcome"] = 5] = "SudairWelcome";
    FixedEmailTemplate[FixedEmailTemplate["MedGulfWelcome"] = 6] = "MedGulfWelcome";
})(FixedEmailTemplate = exports.FixedEmailTemplate || (exports.FixedEmailTemplate = {}));
/** 0 = Default 1 = Id 2 = Name 4 = FixedEmailTemplate 8 = PostmarkTemplateId 16 = SendGridTemplateId 32 = Published */
var EmailTemplateColumns;
(function (EmailTemplateColumns) {
    EmailTemplateColumns[EmailTemplateColumns["Default"] = 0] = "Default";
    EmailTemplateColumns[EmailTemplateColumns["Id"] = 1] = "Id";
    EmailTemplateColumns[EmailTemplateColumns["Name"] = 2] = "Name";
    EmailTemplateColumns[EmailTemplateColumns["FixedEmailTemplate"] = 4] = "FixedEmailTemplate";
    EmailTemplateColumns[EmailTemplateColumns["PostmarkTemplateId"] = 8] = "PostmarkTemplateId";
    EmailTemplateColumns[EmailTemplateColumns["SendGridTemplateId"] = 16] = "SendGridTemplateId";
    EmailTemplateColumns[EmailTemplateColumns["Published"] = 32] = "Published";
})(EmailTemplateColumns = exports.EmailTemplateColumns || (exports.EmailTemplateColumns = {}));
/** 0 = Default 1 = Id 2 = ImageReference 4 = Name 8 = OriginalName 16 = About 32 = CreatedAt */
var AuthorColumns;
(function (AuthorColumns) {
    AuthorColumns[AuthorColumns["Default"] = 0] = "Default";
    AuthorColumns[AuthorColumns["Id"] = 1] = "Id";
    AuthorColumns[AuthorColumns["ImageReference"] = 2] = "ImageReference";
    AuthorColumns[AuthorColumns["Name"] = 4] = "Name";
    AuthorColumns[AuthorColumns["OriginalName"] = 8] = "OriginalName";
    AuthorColumns[AuthorColumns["About"] = 16] = "About";
    AuthorColumns[AuthorColumns["CreatedAt"] = 32] = "CreatedAt";
})(AuthorColumns = exports.AuthorColumns || (exports.AuthorColumns = {}));
/** 0 = Reading 1 = Listening */
var BookMarkType;
(function (BookMarkType) {
    BookMarkType[BookMarkType["Reading"] = 0] = "Reading";
    BookMarkType[BookMarkType["Listening"] = 1] = "Listening";
})(BookMarkType = exports.BookMarkType || (exports.BookMarkType = {}));
/** 0 = Item 1 = Collection */
var ContentItemType;
(function (ContentItemType) {
    ContentItemType[ContentItemType["Item"] = 0] = "Item";
    ContentItemType[ContentItemType["Collection"] = 1] = "Collection";
})(ContentItemType = exports.ContentItemType || (exports.ContentItemType = {}));
/** 0 = MostRecent 1 = Oldest 2 = Alphabetically 3 = UserOrder */
var SortBy;
(function (SortBy) {
    SortBy[SortBy["MostRecent"] = 0] = "MostRecent";
    SortBy[SortBy["Oldest"] = 1] = "Oldest";
    SortBy[SortBy["Alphabetically"] = 2] = "Alphabetically";
    SortBy[SortBy["UserOrder"] = 3] = "UserOrder";
})(SortBy = exports.SortBy || (exports.SortBy = {}));
/** 0 = Default 1 = Id 2 = Name 4 = About 8 = CreatedDate 16 = UpdatedDate */
var NarratorColumns;
(function (NarratorColumns) {
    NarratorColumns[NarratorColumns["Default"] = 0] = "Default";
    NarratorColumns[NarratorColumns["Id"] = 1] = "Id";
    NarratorColumns[NarratorColumns["Name"] = 2] = "Name";
    NarratorColumns[NarratorColumns["About"] = 4] = "About";
    NarratorColumns[NarratorColumns["CreatedDate"] = 8] = "CreatedDate";
    NarratorColumns[NarratorColumns["UpdatedDate"] = 16] = "UpdatedDate";
})(NarratorColumns = exports.NarratorColumns || (exports.NarratorColumns = {}));
/** 0 = MiniPlayer 1 = ReadingPage 2 = ListiningPage 3 = Driving 4 = Background 5 = HandsFree 6 = Quiz */
var PlayingMode;
(function (PlayingMode) {
    PlayingMode[PlayingMode["MiniPlayer"] = 0] = "MiniPlayer";
    PlayingMode[PlayingMode["ReadingPage"] = 1] = "ReadingPage";
    PlayingMode[PlayingMode["ListiningPage"] = 2] = "ListiningPage";
    PlayingMode[PlayingMode["Driving"] = 3] = "Driving";
    PlayingMode[PlayingMode["Background"] = 4] = "Background";
    PlayingMode[PlayingMode["HandsFree"] = 5] = "HandsFree";
    PlayingMode[PlayingMode["Quiz"] = 6] = "Quiz";
})(PlayingMode = exports.PlayingMode || (exports.PlayingMode = {}));
/** 0 = Improvement 1 = Favourite */
var RatingOptionType;
(function (RatingOptionType) {
    RatingOptionType[RatingOptionType["Improvement"] = 0] = "Improvement";
    RatingOptionType[RatingOptionType["Favourite"] = 1] = "Favourite";
})(RatingOptionType = exports.RatingOptionType || (exports.RatingOptionType = {}));
/** 1 = StartPlaying 2 = Playing 3 = Seek 4 = NextContent 10 = PausePlaying 11 = StopPlaying */
var EventType;
(function (EventType) {
    EventType[EventType["StartPlaying"] = 1] = "StartPlaying";
    EventType[EventType["Playing"] = 2] = "Playing";
    EventType[EventType["Seek"] = 3] = "Seek";
    EventType[EventType["NextContent"] = 4] = "NextContent";
    EventType[EventType["PausePlaying"] = 10] = "PausePlaying";
    EventType[EventType["StopPlaying"] = 11] = "StopPlaying";
})(EventType = exports.EventType || (exports.EventType = {}));
/** 0 = ContentEntityUpdated 1 = ContentEntityDurationUpdated 2 = ContentEntityDeleted 3 = ContentEntityPublished 4 = ContentEntityUnPublished 5 = ContentEntityRated */
var ContentEntityUpdateReason;
(function (ContentEntityUpdateReason) {
    ContentEntityUpdateReason[ContentEntityUpdateReason["ContentEntityUpdated"] = 0] = "ContentEntityUpdated";
    ContentEntityUpdateReason[ContentEntityUpdateReason["ContentEntityDurationUpdated"] = 1] = "ContentEntityDurationUpdated";
    ContentEntityUpdateReason[ContentEntityUpdateReason["ContentEntityDeleted"] = 2] = "ContentEntityDeleted";
    ContentEntityUpdateReason[ContentEntityUpdateReason["ContentEntityPublished"] = 3] = "ContentEntityPublished";
    ContentEntityUpdateReason[ContentEntityUpdateReason["ContentEntityUnPublished"] = 4] = "ContentEntityUnPublished";
    ContentEntityUpdateReason[ContentEntityUpdateReason["ContentEntityRated"] = 5] = "ContentEntityRated";
})(ContentEntityUpdateReason = exports.ContentEntityUpdateReason || (exports.ContentEntityUpdateReason = {}));
/** 1 = ContentId 2 = Type 3 = Children 4 = Parents 5 = Tag 6 = Followed 7 = ContinueReading 8 = Recommended 9 = YouMayAlsoLike 10 = DailyContent 11 = OneOfTypes 12 = Country 13 = DurationRange 14 = SelectedByAdmin 15 = SameAuthors 16 = Authors 17 = SameTag 18 = Section 19 = OneOfSections 20 = B2BSkills 21 = B2BOtherSkills 22 = B2BRequiredSkills 23 = B2BDepartmentOptionalSkills 24 = B2BOptionalSkills 25 = InUserInterest 26 = NotConsumed 27 = InUserPlaylist 28 = DescendantsOfB2BSkills 29 = Completed 30 = TrendingInUserInterests 31 = RecommondedForUser 32 = New 33 = ForYou 34 = NotCompleted 35 = TopContent 36 = TopContentByCountry 37 = Consumed 38 = ProgressiveDailyContent 39 = ExcludeContentId 40 = CriteriaContainsTypeId 41 = CriteriaNotContainsTypeId 42 = B2BDepartmentRequiredSkills 43 = B2BUserRequiredSkills 44 = NotChildren 45 = NotParents 46 = ContentList 47 = NotInContentList 48 = ComingSoon 49 = CacheInvalidator 50 = DescendentOfLevel 51 = AncestorOfLevel 52 = B2BUserOptionalSkills 53 = OnboardingChosen 54 = Redeemed */
var SelectFactor;
(function (SelectFactor) {
    SelectFactor[SelectFactor["ContentId"] = 1] = "ContentId";
    SelectFactor[SelectFactor["Type"] = 2] = "Type";
    SelectFactor[SelectFactor["Children"] = 3] = "Children";
    SelectFactor[SelectFactor["Parents"] = 4] = "Parents";
    SelectFactor[SelectFactor["Tag"] = 5] = "Tag";
    SelectFactor[SelectFactor["Followed"] = 6] = "Followed";
    SelectFactor[SelectFactor["ContinueReading"] = 7] = "ContinueReading";
    SelectFactor[SelectFactor["Recommended"] = 8] = "Recommended";
    SelectFactor[SelectFactor["YouMayAlsoLike"] = 9] = "YouMayAlsoLike";
    SelectFactor[SelectFactor["DailyContent"] = 10] = "DailyContent";
    SelectFactor[SelectFactor["OneOfTypes"] = 11] = "OneOfTypes";
    SelectFactor[SelectFactor["Country"] = 12] = "Country";
    SelectFactor[SelectFactor["DurationRange"] = 13] = "DurationRange";
    SelectFactor[SelectFactor["SelectedByAdmin"] = 14] = "SelectedByAdmin";
    SelectFactor[SelectFactor["SameAuthors"] = 15] = "SameAuthors";
    SelectFactor[SelectFactor["Authors"] = 16] = "Authors";
    SelectFactor[SelectFactor["SameTag"] = 17] = "SameTag";
    SelectFactor[SelectFactor["Section"] = 18] = "Section";
    SelectFactor[SelectFactor["OneOfSections"] = 19] = "OneOfSections";
    SelectFactor[SelectFactor["B2BSkills"] = 20] = "B2BSkills";
    SelectFactor[SelectFactor["B2BOtherSkills"] = 21] = "B2BOtherSkills";
    SelectFactor[SelectFactor["B2BRequiredSkills"] = 22] = "B2BRequiredSkills";
    SelectFactor[SelectFactor["B2BDepartmentOptionalSkills"] = 23] = "B2BDepartmentOptionalSkills";
    SelectFactor[SelectFactor["B2BOptionalSkills"] = 24] = "B2BOptionalSkills";
    SelectFactor[SelectFactor["InUserInterest"] = 25] = "InUserInterest";
    SelectFactor[SelectFactor["NotConsumed"] = 26] = "NotConsumed";
    SelectFactor[SelectFactor["InUserPlaylist"] = 27] = "InUserPlaylist";
    SelectFactor[SelectFactor["DescendantsOfB2BSkills"] = 28] = "DescendantsOfB2BSkills";
    SelectFactor[SelectFactor["Completed"] = 29] = "Completed";
    SelectFactor[SelectFactor["TrendingInUserInterests"] = 30] = "TrendingInUserInterests";
    SelectFactor[SelectFactor["RecommondedForUser"] = 31] = "RecommondedForUser";
    SelectFactor[SelectFactor["New"] = 32] = "New";
    SelectFactor[SelectFactor["ForYou"] = 33] = "ForYou";
    SelectFactor[SelectFactor["NotCompleted"] = 34] = "NotCompleted";
    SelectFactor[SelectFactor["TopContent"] = 35] = "TopContent";
    SelectFactor[SelectFactor["TopContentByCountry"] = 36] = "TopContentByCountry";
    SelectFactor[SelectFactor["Consumed"] = 37] = "Consumed";
    SelectFactor[SelectFactor["ProgressiveDailyContent"] = 38] = "ProgressiveDailyContent";
    SelectFactor[SelectFactor["ExcludeContentId"] = 39] = "ExcludeContentId";
    SelectFactor[SelectFactor["CriteriaContainsTypeId"] = 40] = "CriteriaContainsTypeId";
    SelectFactor[SelectFactor["CriteriaNotContainsTypeId"] = 41] = "CriteriaNotContainsTypeId";
    SelectFactor[SelectFactor["B2BDepartmentRequiredSkills"] = 42] = "B2BDepartmentRequiredSkills";
    SelectFactor[SelectFactor["B2BUserRequiredSkills"] = 43] = "B2BUserRequiredSkills";
    SelectFactor[SelectFactor["NotChildren"] = 44] = "NotChildren";
    SelectFactor[SelectFactor["NotParents"] = 45] = "NotParents";
    SelectFactor[SelectFactor["ContentList"] = 46] = "ContentList";
    SelectFactor[SelectFactor["NotInContentList"] = 47] = "NotInContentList";
    SelectFactor[SelectFactor["ComingSoon"] = 48] = "ComingSoon";
    SelectFactor[SelectFactor["CacheInvalidator"] = 49] = "CacheInvalidator";
    SelectFactor[SelectFactor["DescendentOfLevel"] = 50] = "DescendentOfLevel";
    SelectFactor[SelectFactor["AncestorOfLevel"] = 51] = "AncestorOfLevel";
    SelectFactor[SelectFactor["B2BUserOptionalSkills"] = 52] = "B2BUserOptionalSkills";
    SelectFactor[SelectFactor["OnboardingChosen"] = 53] = "OnboardingChosen";
    SelectFactor[SelectFactor["Redeemed"] = 54] = "Redeemed";
})(SelectFactor = exports.SelectFactor || (exports.SelectFactor = {}));
/** 1 = Id 2 = Type 3 = ReleaseDate 4 = Rate 5 = Order 6 = Popularity 8 = SelectionOfAdmin 9 = SearchHits 10 = FollowingDate 11 = ReadingDate 12 = DailyShuffle 13 = WeeklyShuffle 14 = Following 15 = Reading 16 = CompletedOn 17 = Title 18 = Progress 19 = ContentListOrder 20 = ExpectedReleaseDate 21 = RedeemedDate 22 = ItemsDailyShuffle */
var SortingFactor;
(function (SortingFactor) {
    SortingFactor[SortingFactor["Id"] = 1] = "Id";
    SortingFactor[SortingFactor["Type"] = 2] = "Type";
    SortingFactor[SortingFactor["ReleaseDate"] = 3] = "ReleaseDate";
    SortingFactor[SortingFactor["Rate"] = 4] = "Rate";
    SortingFactor[SortingFactor["Order"] = 5] = "Order";
    SortingFactor[SortingFactor["Popularity"] = 6] = "Popularity";
    SortingFactor[SortingFactor["SelectionOfAdmin"] = 8] = "SelectionOfAdmin";
    SortingFactor[SortingFactor["SearchHits"] = 9] = "SearchHits";
    SortingFactor[SortingFactor["FollowingDate"] = 10] = "FollowingDate";
    SortingFactor[SortingFactor["ReadingDate"] = 11] = "ReadingDate";
    SortingFactor[SortingFactor["DailyShuffle"] = 12] = "DailyShuffle";
    SortingFactor[SortingFactor["WeeklyShuffle"] = 13] = "WeeklyShuffle";
    SortingFactor[SortingFactor["Following"] = 14] = "Following";
    SortingFactor[SortingFactor["Reading"] = 15] = "Reading";
    SortingFactor[SortingFactor["CompletedOn"] = 16] = "CompletedOn";
    SortingFactor[SortingFactor["Title"] = 17] = "Title";
    SortingFactor[SortingFactor["Progress"] = 18] = "Progress";
    SortingFactor[SortingFactor["ContentListOrder"] = 19] = "ContentListOrder";
    SortingFactor[SortingFactor["ExpectedReleaseDate"] = 20] = "ExpectedReleaseDate";
    SortingFactor[SortingFactor["RedeemedDate"] = 21] = "RedeemedDate";
    SortingFactor[SortingFactor["ItemsDailyShuffle"] = 22] = "ItemsDailyShuffle";
})(SortingFactor = exports.SortingFactor || (exports.SortingFactor = {}));
/** 0 = Asc 1 = Desc */
var SortingDirection;
(function (SortingDirection) {
    SortingDirection[SortingDirection["Asc"] = 0] = "Asc";
    SortingDirection[SortingDirection["Desc"] = 1] = "Desc";
})(SortingDirection = exports.SortingDirection || (exports.SortingDirection = {}));
/** 0 = Search 1 = Content 2 = Playlist 3 = StartedWith 4 = Completed 5 = Favourite 6 = Bookmarks 7 = Highlights */
var NextItemSource;
(function (NextItemSource) {
    NextItemSource[NextItemSource["Search"] = 0] = "Search";
    NextItemSource[NextItemSource["Content"] = 1] = "Content";
    NextItemSource[NextItemSource["Playlist"] = 2] = "Playlist";
    NextItemSource[NextItemSource["StartedWith"] = 3] = "StartedWith";
    NextItemSource[NextItemSource["Completed"] = 4] = "Completed";
    NextItemSource[NextItemSource["Favourite"] = 5] = "Favourite";
    NextItemSource[NextItemSource["Bookmarks"] = 6] = "Bookmarks";
    NextItemSource[NextItemSource["Highlights"] = 7] = "Highlights";
})(NextItemSource = exports.NextItemSource || (exports.NextItemSource = {}));
/** 0 = Default 1 = Id 2 = ContentEntityType 4 = Image 8 = Title 16 = ContentItemType 32 = OriginalTitle 64 = Authors 128 = UpdatedDate 256 = Published 512 = ReferenceName 1024 = ContentEntityTypeId 2048 = TypeDisplayName 4096 = OriginalSubTitle 8192 = Rate 16384 = ChaptersCount 32768 = DurationMS 65536 = ActualDurationMS 131072 = ActualCost 262144 = PublishDate 524288 = CreatedDate */
var ContentEntityLookUpColumns;
(function (ContentEntityLookUpColumns) {
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Default"] = 0] = "Default";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Id"] = 1] = "Id";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ContentEntityType"] = 2] = "ContentEntityType";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Image"] = 4] = "Image";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Title"] = 8] = "Title";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ContentItemType"] = 16] = "ContentItemType";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["OriginalTitle"] = 32] = "OriginalTitle";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Authors"] = 64] = "Authors";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["UpdatedDate"] = 128] = "UpdatedDate";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Published"] = 256] = "Published";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ReferenceName"] = 512] = "ReferenceName";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ContentEntityTypeId"] = 1024] = "ContentEntityTypeId";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["TypeDisplayName"] = 2048] = "TypeDisplayName";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["OriginalSubTitle"] = 4096] = "OriginalSubTitle";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Rate"] = 8192] = "Rate";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ChaptersCount"] = 16384] = "ChaptersCount";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["DurationMS"] = 32768] = "DurationMS";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ActualDurationMS"] = 65536] = "ActualDurationMS";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ActualCost"] = 131072] = "ActualCost";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["PublishDate"] = 262144] = "PublishDate";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["CreatedDate"] = 524288] = "CreatedDate";
})(ContentEntityLookUpColumns = exports.ContentEntityLookUpColumns || (exports.ContentEntityLookUpColumns = {}));
/** 0 = Text 1 = AreaText 2 = TineMCE 3 = DateTime 4 = Date 5 = DragFile 6 = UploadFile 7 = UploadImage 8 = CallbackSelect 9 = Select 10 = Number 11 = RangePicker 12 = ColorPicker 13 = Switch 18 = PreCalculated */
var ContentEntityTypeFieldType;
(function (ContentEntityTypeFieldType) {
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Text"] = 0] = "Text";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["AreaText"] = 1] = "AreaText";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["TineMCE"] = 2] = "TineMCE";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["DateTime"] = 3] = "DateTime";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Date"] = 4] = "Date";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["DragFile"] = 5] = "DragFile";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["UploadFile"] = 6] = "UploadFile";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["UploadImage"] = 7] = "UploadImage";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["CallbackSelect"] = 8] = "CallbackSelect";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Select"] = 9] = "Select";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Number"] = 10] = "Number";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["RangePicker"] = 11] = "RangePicker";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["ColorPicker"] = 12] = "ColorPicker";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Switch"] = 13] = "Switch";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["PreCalculated"] = 18] = "PreCalculated";
})(ContentEntityTypeFieldType = exports.ContentEntityTypeFieldType || (exports.ContentEntityTypeFieldType = {}));
/** 0 = Inherited 1 = Independant 2 = Parent 3 = FirstChapterFree 4 = Free 5 = Credit */
var LockType;
(function (LockType) {
    LockType[LockType["Inherited"] = 0] = "Inherited";
    LockType[LockType["Independant"] = 1] = "Independant";
    LockType[LockType["Parent"] = 2] = "Parent";
    LockType[LockType["FirstChapterFree"] = 3] = "FirstChapterFree";
    LockType[LockType["Free"] = 4] = "Free";
    LockType[LockType["Credit"] = 5] = "Credit";
})(LockType = exports.LockType || (exports.LockType = {}));
/** 0 = VeryHigh 1 = High 2 = Medium 3 = Low 4 = VeryLow */
var ProgressUpdatePriority;
(function (ProgressUpdatePriority) {
    ProgressUpdatePriority[ProgressUpdatePriority["VeryHigh"] = 0] = "VeryHigh";
    ProgressUpdatePriority[ProgressUpdatePriority["High"] = 1] = "High";
    ProgressUpdatePriority[ProgressUpdatePriority["Medium"] = 2] = "Medium";
    ProgressUpdatePriority[ProgressUpdatePriority["Low"] = 3] = "Low";
    ProgressUpdatePriority[ProgressUpdatePriority["VeryLow"] = 4] = "VeryLow";
})(ProgressUpdatePriority = exports.ProgressUpdatePriority || (exports.ProgressUpdatePriority = {}));
/** 0 = ContentRelation */
var HandlingType;
(function (HandlingType) {
    HandlingType[HandlingType["ContentRelation"] = 0] = "ContentRelation";
})(HandlingType = exports.HandlingType || (exports.HandlingType = {}));
/** 0 = Parents 1 = Ancesstors 2 = Children 3 = Descendants */
var HandlingTypeSubType;
(function (HandlingTypeSubType) {
    HandlingTypeSubType[HandlingTypeSubType["Parents"] = 0] = "Parents";
    HandlingTypeSubType[HandlingTypeSubType["Ancesstors"] = 1] = "Ancesstors";
    HandlingTypeSubType[HandlingTypeSubType["Children"] = 2] = "Children";
    HandlingTypeSubType[HandlingTypeSubType["Descendants"] = 3] = "Descendants";
})(HandlingTypeSubType = exports.HandlingTypeSubType || (exports.HandlingTypeSubType = {}));
/** 0 = Title 1 = OriginalTitle */
var ValueToPick;
(function (ValueToPick) {
    ValueToPick[ValueToPick["Title"] = 0] = "Title";
    ValueToPick[ValueToPick["OriginalTitle"] = 1] = "OriginalTitle";
})(ValueToPick = exports.ValueToPick || (exports.ValueToPick = {}));
/** 0 = Other 1 = Full 2 = Misc */
var LinkageType;
(function (LinkageType) {
    LinkageType[LinkageType["Other"] = 0] = "Other";
    LinkageType[LinkageType["Full"] = 1] = "Full";
    LinkageType[LinkageType["Misc"] = 2] = "Misc";
})(LinkageType = exports.LinkageType || (exports.LinkageType = {}));
/** 0 = Primitive 1 = RequiredComponent 2 = MappedField 3 = PredefinedComponent 4 = UserMappedField */
var ComponentFieldType;
(function (ComponentFieldType) {
    ComponentFieldType[ComponentFieldType["Primitive"] = 0] = "Primitive";
    ComponentFieldType[ComponentFieldType["RequiredComponent"] = 1] = "RequiredComponent";
    ComponentFieldType[ComponentFieldType["MappedField"] = 2] = "MappedField";
    ComponentFieldType[ComponentFieldType["PredefinedComponent"] = 3] = "PredefinedComponent";
    ComponentFieldType[ComponentFieldType["UserMappedField"] = 4] = "UserMappedField";
})(ComponentFieldType = exports.ComponentFieldType || (exports.ComponentFieldType = {}));
/** 0 = Component 1 = PageBody */
var ComponentUsageType;
(function (ComponentUsageType) {
    ComponentUsageType[ComponentUsageType["Component"] = 0] = "Component";
    ComponentUsageType[ComponentUsageType["PageBody"] = 1] = "PageBody";
})(ComponentUsageType = exports.ComponentUsageType || (exports.ComponentUsageType = {}));
/** 0 = Default 1 = Id 2 = Type 4 = ReferenceName 8 = TypeId 16 = ContentItemType 32 = SeeAllPageId 64 = SeeAllPageType 128 = ItemTemplateId 256 = ItemTemplateReferenceName */
var ComponentsLookUpColumns;
(function (ComponentsLookUpColumns) {
    ComponentsLookUpColumns[ComponentsLookUpColumns["Default"] = 0] = "Default";
    ComponentsLookUpColumns[ComponentsLookUpColumns["Id"] = 1] = "Id";
    ComponentsLookUpColumns[ComponentsLookUpColumns["Type"] = 2] = "Type";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ReferenceName"] = 4] = "ReferenceName";
    ComponentsLookUpColumns[ComponentsLookUpColumns["TypeId"] = 8] = "TypeId";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ContentItemType"] = 16] = "ContentItemType";
    ComponentsLookUpColumns[ComponentsLookUpColumns["SeeAllPageId"] = 32] = "SeeAllPageId";
    ComponentsLookUpColumns[ComponentsLookUpColumns["SeeAllPageType"] = 64] = "SeeAllPageType";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ItemTemplateId"] = 128] = "ItemTemplateId";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ItemTemplateReferenceName"] = 256] = "ItemTemplateReferenceName";
})(ComponentsLookUpColumns = exports.ComponentsLookUpColumns || (exports.ComponentsLookUpColumns = {}));
/** 0 = Text 1 = AreaText 2 = TineMCE 3 = DateTime 4 = Date 5 = DragFile 6 = UploadFile 7 = UploadImage 8 = CallbackSelect 9 = Select 10 = Number 11 = RangePicker 12 = ColorPicker 13 = Switch 14 = RequiredComponent 15 = MappedField 16 = PredefinedComponent 17 = UserMappedField */
var FieldType;
(function (FieldType) {
    FieldType[FieldType["Text"] = 0] = "Text";
    FieldType[FieldType["AreaText"] = 1] = "AreaText";
    FieldType[FieldType["TineMCE"] = 2] = "TineMCE";
    FieldType[FieldType["DateTime"] = 3] = "DateTime";
    FieldType[FieldType["Date"] = 4] = "Date";
    FieldType[FieldType["DragFile"] = 5] = "DragFile";
    FieldType[FieldType["UploadFile"] = 6] = "UploadFile";
    FieldType[FieldType["UploadImage"] = 7] = "UploadImage";
    FieldType[FieldType["CallbackSelect"] = 8] = "CallbackSelect";
    FieldType[FieldType["Select"] = 9] = "Select";
    FieldType[FieldType["Number"] = 10] = "Number";
    FieldType[FieldType["RangePicker"] = 11] = "RangePicker";
    FieldType[FieldType["ColorPicker"] = 12] = "ColorPicker";
    FieldType[FieldType["Switch"] = 13] = "Switch";
    FieldType[FieldType["RequiredComponent"] = 14] = "RequiredComponent";
    FieldType[FieldType["MappedField"] = 15] = "MappedField";
    FieldType[FieldType["PredefinedComponent"] = 16] = "PredefinedComponent";
    FieldType[FieldType["UserMappedField"] = 17] = "UserMappedField";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
/** 0 = Default 1 = Id 2 = Name 4 = ContentItemType 8 = Title 16 = Description 32 = LanguageId 64 = Permission */
var ComponentTypeColumns;
(function (ComponentTypeColumns) {
    ComponentTypeColumns[ComponentTypeColumns["Default"] = 0] = "Default";
    ComponentTypeColumns[ComponentTypeColumns["Id"] = 1] = "Id";
    ComponentTypeColumns[ComponentTypeColumns["Name"] = 2] = "Name";
    ComponentTypeColumns[ComponentTypeColumns["ContentItemType"] = 4] = "ContentItemType";
    ComponentTypeColumns[ComponentTypeColumns["Title"] = 8] = "Title";
    ComponentTypeColumns[ComponentTypeColumns["Description"] = 16] = "Description";
    ComponentTypeColumns[ComponentTypeColumns["LanguageId"] = 32] = "LanguageId";
    ComponentTypeColumns[ComponentTypeColumns["Permission"] = 64] = "Permission";
})(ComponentTypeColumns = exports.ComponentTypeColumns || (exports.ComponentTypeColumns = {}));
/** 0 = StandAlone 1 = Layout 2 = Body */
var CollectionComponentUsageType;
(function (CollectionComponentUsageType) {
    CollectionComponentUsageType[CollectionComponentUsageType["StandAlone"] = 0] = "StandAlone";
    CollectionComponentUsageType[CollectionComponentUsageType["Layout"] = 1] = "Layout";
    CollectionComponentUsageType[CollectionComponentUsageType["Body"] = 2] = "Body";
})(CollectionComponentUsageType = exports.CollectionComponentUsageType || (exports.CollectionComponentUsageType = {}));
/** 0 = Default 1 = Id 2 = CollectionComponentType 4 = ReferenceName 8 = CollectionComponentTypeId */
var CollectionComponentLookUpColumns;
(function (CollectionComponentLookUpColumns) {
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["Default"] = 0] = "Default";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["Id"] = 1] = "Id";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["CollectionComponentType"] = 2] = "CollectionComponentType";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["ReferenceName"] = 4] = "ReferenceName";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["CollectionComponentTypeId"] = 8] = "CollectionComponentTypeId";
})(CollectionComponentLookUpColumns = exports.CollectionComponentLookUpColumns || (exports.CollectionComponentLookUpColumns = {}));
/** 0 = Default 1 = Id 2 = Name 4 = Title 8 = Description 16 = Permission 32 = AllowedTypes 64 = UsageType */
var CollectionComponentTypesLookUpColumns;
(function (CollectionComponentTypesLookUpColumns) {
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Default"] = 0] = "Default";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Id"] = 1] = "Id";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Name"] = 2] = "Name";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Title"] = 4] = "Title";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Description"] = 8] = "Description";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Permission"] = 16] = "Permission";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["AllowedTypes"] = 32] = "AllowedTypes";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["UsageType"] = 64] = "UsageType";
})(CollectionComponentTypesLookUpColumns = exports.CollectionComponentTypesLookUpColumns || (exports.CollectionComponentTypesLookUpColumns = {}));
/** 0 = MostRecent 1 = Oldest */
var SortBy2;
(function (SortBy2) {
    SortBy2[SortBy2["MostRecent"] = 0] = "MostRecent";
    SortBy2[SortBy2["Oldest"] = 1] = "Oldest";
})(SortBy2 = exports.SortBy2 || (exports.SortBy2 = {}));
/** 0 = Native 1 = Stripe 2 = Mixed 3 = NativeTrial 4 = NativePromo */
var PaymentMethod2;
(function (PaymentMethod2) {
    PaymentMethod2[PaymentMethod2["Native"] = 0] = "Native";
    PaymentMethod2[PaymentMethod2["Stripe"] = 1] = "Stripe";
    PaymentMethod2[PaymentMethod2["Mixed"] = 2] = "Mixed";
    PaymentMethod2[PaymentMethod2["NativeTrial"] = 3] = "NativeTrial";
    PaymentMethod2[PaymentMethod2["NativePromo"] = 4] = "NativePromo";
})(PaymentMethod2 = exports.PaymentMethod2 || (exports.PaymentMethod2 = {}));
/** 0 = NotEligible 1 = NewUser 2 = NewActiveUser 3 = EngagedUser 4 = Regular 5 = VeryNewUser */
var UserGrouping;
(function (UserGrouping) {
    UserGrouping[UserGrouping["NotEligible"] = 0] = "NotEligible";
    UserGrouping[UserGrouping["NewUser"] = 1] = "NewUser";
    UserGrouping[UserGrouping["NewActiveUser"] = 2] = "NewActiveUser";
    UserGrouping[UserGrouping["EngagedUser"] = 3] = "EngagedUser";
    UserGrouping[UserGrouping["Regular"] = 4] = "Regular";
    UserGrouping[UserGrouping["VeryNewUser"] = 5] = "VeryNewUser";
})(UserGrouping = exports.UserGrouping || (exports.UserGrouping = {}));
/** 0 = Home 1 = Explore 2 = Library 3 = Profile 4 = B2BHome 5 = B2BSkills 6 = B2BLibrary 7 = Reels 8 = Ramadan */
var TabResponsibility;
(function (TabResponsibility) {
    TabResponsibility[TabResponsibility["Home"] = 0] = "Home";
    TabResponsibility[TabResponsibility["Explore"] = 1] = "Explore";
    TabResponsibility[TabResponsibility["Library"] = 2] = "Library";
    TabResponsibility[TabResponsibility["Profile"] = 3] = "Profile";
    TabResponsibility[TabResponsibility["B2BHome"] = 4] = "B2BHome";
    TabResponsibility[TabResponsibility["B2BSkills"] = 5] = "B2BSkills";
    TabResponsibility[TabResponsibility["B2BLibrary"] = 6] = "B2BLibrary";
    TabResponsibility[TabResponsibility["Reels"] = 7] = "Reels";
    TabResponsibility[TabResponsibility["Ramadan"] = 8] = "Ramadan";
})(TabResponsibility = exports.TabResponsibility || (exports.TabResponsibility = {}));
/** 0 = B2C 1 = B2B 2 = CarPlay */
var FlowTabType;
(function (FlowTabType) {
    FlowTabType[FlowTabType["B2C"] = 0] = "B2C";
    FlowTabType[FlowTabType["B2B"] = 1] = "B2B";
    FlowTabType[FlowTabType["CarPlay"] = 2] = "CarPlay";
})(FlowTabType = exports.FlowTabType || (exports.FlowTabType = {}));
/** 0 = StartQuiz 1 = ViewResult 2 = Disabled */
var ContentEntityQuizAction;
(function (ContentEntityQuizAction) {
    ContentEntityQuizAction[ContentEntityQuizAction["StartQuiz"] = 0] = "StartQuiz";
    ContentEntityQuizAction[ContentEntityQuizAction["ViewResult"] = 1] = "ViewResult";
    ContentEntityQuizAction[ContentEntityQuizAction["Disabled"] = 2] = "Disabled";
})(ContentEntityQuizAction = exports.ContentEntityQuizAction || (exports.ContentEntityQuizAction = {}));
/** 0 = StartQuiz 1 = ReCompleteContentEntity */
var AfterCompleteQuizAction;
(function (AfterCompleteQuizAction) {
    AfterCompleteQuizAction[AfterCompleteQuizAction["StartQuiz"] = 0] = "StartQuiz";
    AfterCompleteQuizAction[AfterCompleteQuizAction["ReCompleteContentEntity"] = 1] = "ReCompleteContentEntity";
})(AfterCompleteQuizAction = exports.AfterCompleteQuizAction || (exports.AfterCompleteQuizAction = {}));
/** 0 = Year 1 = Quarter 2 = Month */
var Period;
(function (Period) {
    Period[Period["Year"] = 0] = "Year";
    Period[Period["Quarter"] = 1] = "Quarter";
    Period[Period["Month"] = 2] = "Month";
})(Period = exports.Period || (exports.Period = {}));
/** 0 = Optional 1 = Required 2 = Department */
var SoftSkillType;
(function (SoftSkillType) {
    SoftSkillType[SoftSkillType["Optional"] = 0] = "Optional";
    SoftSkillType[SoftSkillType["Required"] = 1] = "Required";
    SoftSkillType[SoftSkillType["Department"] = 2] = "Department";
})(SoftSkillType = exports.SoftSkillType || (exports.SoftSkillType = {}));
/** 0 = OnGoing 1 = Completed */
var SkillStatusEnum;
(function (SkillStatusEnum) {
    SkillStatusEnum[SkillStatusEnum["OnGoing"] = 0] = "OnGoing";
    SkillStatusEnum[SkillStatusEnum["Completed"] = 1] = "Completed";
})(SkillStatusEnum = exports.SkillStatusEnum || (exports.SkillStatusEnum = {}));
/** 0 = Default 1 = Id 2 = QuestionId 4 = Text 8 = CreatedDate 16 = IsCorrect */
var AnswerColumns;
(function (AnswerColumns) {
    AnswerColumns[AnswerColumns["Default"] = 0] = "Default";
    AnswerColumns[AnswerColumns["Id"] = 1] = "Id";
    AnswerColumns[AnswerColumns["QuestionId"] = 2] = "QuestionId";
    AnswerColumns[AnswerColumns["Text"] = 4] = "Text";
    AnswerColumns[AnswerColumns["CreatedDate"] = 8] = "CreatedDate";
    AnswerColumns[AnswerColumns["IsCorrect"] = 16] = "IsCorrect";
})(AnswerColumns = exports.AnswerColumns || (exports.AnswerColumns = {}));
/** 0 = Default 1 = Id 2 = ImageReference 4 = Title 8 = Description 16 = ReferenceName 32 = CreatedAt */
var BadgeColumns;
(function (BadgeColumns) {
    BadgeColumns[BadgeColumns["Default"] = 0] = "Default";
    BadgeColumns[BadgeColumns["Id"] = 1] = "Id";
    BadgeColumns[BadgeColumns["ImageReference"] = 2] = "ImageReference";
    BadgeColumns[BadgeColumns["Title"] = 4] = "Title";
    BadgeColumns[BadgeColumns["Description"] = 8] = "Description";
    BadgeColumns[BadgeColumns["ReferenceName"] = 16] = "ReferenceName";
    BadgeColumns[BadgeColumns["CreatedAt"] = 32] = "CreatedAt";
})(BadgeColumns = exports.BadgeColumns || (exports.BadgeColumns = {}));
/** 0 = Default 1 = Id 2 = ReferenceName 4 = ItemsCount 8 = IntegrationSyncGroupId 16 = DisplayName 32 = PublicImageURL */
var ContentEntityListColumns;
(function (ContentEntityListColumns) {
    ContentEntityListColumns[ContentEntityListColumns["Default"] = 0] = "Default";
    ContentEntityListColumns[ContentEntityListColumns["Id"] = 1] = "Id";
    ContentEntityListColumns[ContentEntityListColumns["ReferenceName"] = 2] = "ReferenceName";
    ContentEntityListColumns[ContentEntityListColumns["ItemsCount"] = 4] = "ItemsCount";
    ContentEntityListColumns[ContentEntityListColumns["IntegrationSyncGroupId"] = 8] = "IntegrationSyncGroupId";
    ContentEntityListColumns[ContentEntityListColumns["DisplayName"] = 16] = "DisplayName";
    ContentEntityListColumns[ContentEntityListColumns["PublicImageURL"] = 32] = "PublicImageURL";
})(ContentEntityListColumns = exports.ContentEntityListColumns || (exports.ContentEntityListColumns = {}));
/** 0 = Default 1 = Id 2 = ContentEntityTypeId 4 = ContentEntityTypeName 8 = NavigationName 16 = SearchComponentId 32 = SearchComponentType 64 = SearchComponentName 128 = SearchPageId 256 = SearchPageType 512 = SearchPageName 1024 = DetailsPageId 2048 = DetailsPageType 4096 = DetailsPageName */
var ContentEntityTypeNavigationColumns;
(function (ContentEntityTypeNavigationColumns) {
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["Default"] = 0] = "Default";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["Id"] = 1] = "Id";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["ContentEntityTypeId"] = 2] = "ContentEntityTypeId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["ContentEntityTypeName"] = 4] = "ContentEntityTypeName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["NavigationName"] = 8] = "NavigationName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchComponentId"] = 16] = "SearchComponentId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchComponentType"] = 32] = "SearchComponentType";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchComponentName"] = 64] = "SearchComponentName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchPageId"] = 128] = "SearchPageId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchPageType"] = 256] = "SearchPageType";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchPageName"] = 512] = "SearchPageName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["DetailsPageId"] = 1024] = "DetailsPageId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["DetailsPageType"] = 2048] = "DetailsPageType";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["DetailsPageName"] = 4096] = "DetailsPageName";
})(ContentEntityTypeNavigationColumns = exports.ContentEntityTypeNavigationColumns || (exports.ContentEntityTypeNavigationColumns = {}));
/** 0 = Default 1 = Id 2 = Name 4 = Title 8 = Description 16 = Permission */
var ContentEntityTypeColumns;
(function (ContentEntityTypeColumns) {
    ContentEntityTypeColumns[ContentEntityTypeColumns["Default"] = 0] = "Default";
    ContentEntityTypeColumns[ContentEntityTypeColumns["Id"] = 1] = "Id";
    ContentEntityTypeColumns[ContentEntityTypeColumns["Name"] = 2] = "Name";
    ContentEntityTypeColumns[ContentEntityTypeColumns["Title"] = 4] = "Title";
    ContentEntityTypeColumns[ContentEntityTypeColumns["Description"] = 8] = "Description";
    ContentEntityTypeColumns[ContentEntityTypeColumns["Permission"] = 16] = "Permission";
})(ContentEntityTypeColumns = exports.ContentEntityTypeColumns || (exports.ContentEntityTypeColumns = {}));
/** 0 = Default 1 = Id 2 = FlowName 4 = PaymentMethod 8 = IsB2B 16 = IsCarPlay */
var FlowColumns;
(function (FlowColumns) {
    FlowColumns[FlowColumns["Default"] = 0] = "Default";
    FlowColumns[FlowColumns["Id"] = 1] = "Id";
    FlowColumns[FlowColumns["FlowName"] = 2] = "FlowName";
    FlowColumns[FlowColumns["PaymentMethod"] = 4] = "PaymentMethod";
    FlowColumns[FlowColumns["IsB2B"] = 8] = "IsB2B";
    FlowColumns[FlowColumns["IsCarPlay"] = 16] = "IsCarPlay";
})(FlowColumns = exports.FlowColumns || (exports.FlowColumns = {}));
/** 0 = Default 1 = Id 2 = Published 4 = FlowName 8 = Notes 16 = Plan 32 = Language 64 = ISOTwoDigitCountryCode 128 = Platform 256 = MajorVersion 512 = MiddleVersion 1024 = MinorVersion 2048 = RewardingDate 4096 = ActiveFrom 8192 = ActiveTo 16384 = ReaderId 32768 = Priority 65536 = BusinessGroupId */
var FlowSelectionColumns;
(function (FlowSelectionColumns) {
    FlowSelectionColumns[FlowSelectionColumns["Default"] = 0] = "Default";
    FlowSelectionColumns[FlowSelectionColumns["Id"] = 1] = "Id";
    FlowSelectionColumns[FlowSelectionColumns["Published"] = 2] = "Published";
    FlowSelectionColumns[FlowSelectionColumns["FlowName"] = 4] = "FlowName";
    FlowSelectionColumns[FlowSelectionColumns["Notes"] = 8] = "Notes";
    FlowSelectionColumns[FlowSelectionColumns["Plan"] = 16] = "Plan";
    FlowSelectionColumns[FlowSelectionColumns["Language"] = 32] = "Language";
    FlowSelectionColumns[FlowSelectionColumns["ISOTwoDigitCountryCode"] = 64] = "ISOTwoDigitCountryCode";
    FlowSelectionColumns[FlowSelectionColumns["Platform"] = 128] = "Platform";
    FlowSelectionColumns[FlowSelectionColumns["MajorVersion"] = 256] = "MajorVersion";
    FlowSelectionColumns[FlowSelectionColumns["MiddleVersion"] = 512] = "MiddleVersion";
    FlowSelectionColumns[FlowSelectionColumns["MinorVersion"] = 1024] = "MinorVersion";
    FlowSelectionColumns[FlowSelectionColumns["RewardingDate"] = 2048] = "RewardingDate";
    FlowSelectionColumns[FlowSelectionColumns["ActiveFrom"] = 4096] = "ActiveFrom";
    FlowSelectionColumns[FlowSelectionColumns["ActiveTo"] = 8192] = "ActiveTo";
    FlowSelectionColumns[FlowSelectionColumns["ReaderId"] = 16384] = "ReaderId";
    FlowSelectionColumns[FlowSelectionColumns["Priority"] = 32768] = "Priority";
    FlowSelectionColumns[FlowSelectionColumns["BusinessGroupId"] = 65536] = "BusinessGroupId";
})(FlowSelectionColumns = exports.FlowSelectionColumns || (exports.FlowSelectionColumns = {}));
/** 0 = Default 1 = Id 2 = Name 4 = CreatedDate */
var PublisherColumns;
(function (PublisherColumns) {
    PublisherColumns[PublisherColumns["Default"] = 0] = "Default";
    PublisherColumns[PublisherColumns["Id"] = 1] = "Id";
    PublisherColumns[PublisherColumns["Name"] = 2] = "Name";
    PublisherColumns[PublisherColumns["CreatedDate"] = 4] = "CreatedDate";
})(PublisherColumns = exports.PublisherColumns || (exports.PublisherColumns = {}));
/** 0 = Default 1 = Id 2 = ContentEntityId 4 = Text 8 = LanguageId 16 = Published 32 = CreatedDate */
var QuestionColumns;
(function (QuestionColumns) {
    QuestionColumns[QuestionColumns["Default"] = 0] = "Default";
    QuestionColumns[QuestionColumns["Id"] = 1] = "Id";
    QuestionColumns[QuestionColumns["ContentEntityId"] = 2] = "ContentEntityId";
    QuestionColumns[QuestionColumns["Text"] = 4] = "Text";
    QuestionColumns[QuestionColumns["LanguageId"] = 8] = "LanguageId";
    QuestionColumns[QuestionColumns["Published"] = 16] = "Published";
    QuestionColumns[QuestionColumns["CreatedDate"] = 32] = "CreatedDate";
})(QuestionColumns = exports.QuestionColumns || (exports.QuestionColumns = {}));
/** 0 = Default 1 = Id 2 = ContentEntityId 4 = Name 16 = QuestionExpiryMS 32 = CreatedDate 64 = PassingGrade */
var QuizColumns;
(function (QuizColumns) {
    QuizColumns[QuizColumns["Default"] = 0] = "Default";
    QuizColumns[QuizColumns["Id"] = 1] = "Id";
    QuizColumns[QuizColumns["ContentEntityId"] = 2] = "ContentEntityId";
    QuizColumns[QuizColumns["Name"] = 4] = "Name";
    QuizColumns[QuizColumns["QuestionExpiryMS"] = 16] = "QuestionExpiryMS";
    QuizColumns[QuizColumns["CreatedDate"] = 32] = "CreatedDate";
    QuizColumns[QuizColumns["PassingGrade"] = 64] = "PassingGrade";
})(QuizColumns = exports.QuizColumns || (exports.QuizColumns = {}));
/** 0 = Pending 1 = Answered */
var ReportProblemState;
(function (ReportProblemState) {
    ReportProblemState[ReportProblemState["Pending"] = 0] = "Pending";
    ReportProblemState[ReportProblemState["Answered"] = 1] = "Answered";
})(ReportProblemState = exports.ReportProblemState || (exports.ReportProblemState = {}));
/** 0 = Default 1 = Id 2 = ContainerContentEntityId 4 = ContainerContentEntityTitle 8 = ContentEntityId 16 = ContentEntityTitle 32 = ContentEntityTextId 64 = ContentEntityText 128 = ReaderId 256 = Email 512 = ProblemText 1024 = Details 2048 = CreatedDate */
var ReportTextProblemColumns;
(function (ReportTextProblemColumns) {
    ReportTextProblemColumns[ReportTextProblemColumns["Default"] = 0] = "Default";
    ReportTextProblemColumns[ReportTextProblemColumns["Id"] = 1] = "Id";
    ReportTextProblemColumns[ReportTextProblemColumns["ContainerContentEntityId"] = 2] = "ContainerContentEntityId";
    ReportTextProblemColumns[ReportTextProblemColumns["ContainerContentEntityTitle"] = 4] = "ContainerContentEntityTitle";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityId"] = 8] = "ContentEntityId";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityTitle"] = 16] = "ContentEntityTitle";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityTextId"] = 32] = "ContentEntityTextId";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityText"] = 64] = "ContentEntityText";
    ReportTextProblemColumns[ReportTextProblemColumns["ReaderId"] = 128] = "ReaderId";
    ReportTextProblemColumns[ReportTextProblemColumns["Email"] = 256] = "Email";
    ReportTextProblemColumns[ReportTextProblemColumns["ProblemText"] = 512] = "ProblemText";
    ReportTextProblemColumns[ReportTextProblemColumns["Details"] = 1024] = "Details";
    ReportTextProblemColumns[ReportTextProblemColumns["CreatedDate"] = 2048] = "CreatedDate";
})(ReportTextProblemColumns = exports.ReportTextProblemColumns || (exports.ReportTextProblemColumns = {}));
/** 0 = BOOK 1 = FICTION 2 = PODCAST 3 = CATEGORY 4 = SUBCATEGORY 5 = PODCASTEPISODE 6 = PODCASTHUB 7 = PROGRAM 8 = THEATER 9 = QURAN 10 = SHORTBOOK 11 = SKILL 12 = MOVIE */
var ContentType;
(function (ContentType) {
    ContentType[ContentType["BOOK"] = 0] = "BOOK";
    ContentType[ContentType["FICTION"] = 1] = "FICTION";
    ContentType[ContentType["PODCAST"] = 2] = "PODCAST";
    ContentType[ContentType["CATEGORY"] = 3] = "CATEGORY";
    ContentType[ContentType["SUBCATEGORY"] = 4] = "SUBCATEGORY";
    ContentType[ContentType["PODCASTEPISODE"] = 5] = "PODCASTEPISODE";
    ContentType[ContentType["PODCASTHUB"] = 6] = "PODCASTHUB";
    ContentType[ContentType["PROGRAM"] = 7] = "PROGRAM";
    ContentType[ContentType["THEATER"] = 8] = "THEATER";
    ContentType[ContentType["QURAN"] = 9] = "QURAN";
    ContentType[ContentType["SHORTBOOK"] = 10] = "SHORTBOOK";
    ContentType[ContentType["SKILL"] = 11] = "SKILL";
    ContentType[ContentType["MOVIE"] = 12] = "MOVIE";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
/** 0 = All 1 = PREMIUM 2 = FREEMIUM */
var PlanType;
(function (PlanType) {
    PlanType[PlanType["All"] = 0] = "All";
    PlanType[PlanType["PREMIUM"] = 1] = "PREMIUM";
    PlanType[PlanType["FREEMIUM"] = 2] = "FREEMIUM";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
/** 0 = Daily 1 = Weekly 2 = Monthly */
var RetentionPeriod;
(function (RetentionPeriod) {
    RetentionPeriod[RetentionPeriod["Daily"] = 0] = "Daily";
    RetentionPeriod[RetentionPeriod["Weekly"] = 1] = "Weekly";
    RetentionPeriod[RetentionPeriod["Monthly"] = 2] = "Monthly";
})(RetentionPeriod = exports.RetentionPeriod || (exports.RetentionPeriod = {}));
/** 0 = P1Y 1 = P1M 2 = P1W 3 = P1D 4 = P2M 5 = P3M 6 = P6M 7 = P2Y 8 = P3Y 9 = P5Y */
var SubscriptionDuration;
(function (SubscriptionDuration) {
    SubscriptionDuration[SubscriptionDuration["P1Y"] = 0] = "P1Y";
    SubscriptionDuration[SubscriptionDuration["P1M"] = 1] = "P1M";
    SubscriptionDuration[SubscriptionDuration["P1W"] = 2] = "P1W";
    SubscriptionDuration[SubscriptionDuration["P1D"] = 3] = "P1D";
    SubscriptionDuration[SubscriptionDuration["P2M"] = 4] = "P2M";
    SubscriptionDuration[SubscriptionDuration["P3M"] = 5] = "P3M";
    SubscriptionDuration[SubscriptionDuration["P6M"] = 6] = "P6M";
    SubscriptionDuration[SubscriptionDuration["P2Y"] = 7] = "P2Y";
    SubscriptionDuration[SubscriptionDuration["P3Y"] = 8] = "P3Y";
    SubscriptionDuration[SubscriptionDuration["P5Y"] = 9] = "P5Y";
})(SubscriptionDuration = exports.SubscriptionDuration || (exports.SubscriptionDuration = {}));
/** 0 = New 1 = Renewal 2 = ALL */
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType[SubscriptionType["New"] = 0] = "New";
    SubscriptionType[SubscriptionType["Renewal"] = 1] = "Renewal";
    SubscriptionType[SubscriptionType["ALL"] = 2] = "ALL";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
/** 0 = Pending 1 = Active 2 = Renewed 3 = Canceled 4 = Updated */
var StripeSubscriptionStatus;
(function (StripeSubscriptionStatus) {
    StripeSubscriptionStatus[StripeSubscriptionStatus["Pending"] = 0] = "Pending";
    StripeSubscriptionStatus[StripeSubscriptionStatus["Active"] = 1] = "Active";
    StripeSubscriptionStatus[StripeSubscriptionStatus["Renewed"] = 2] = "Renewed";
    StripeSubscriptionStatus[StripeSubscriptionStatus["Canceled"] = 3] = "Canceled";
    StripeSubscriptionStatus[StripeSubscriptionStatus["Updated"] = 4] = "Updated";
})(StripeSubscriptionStatus = exports.StripeSubscriptionStatus || (exports.StripeSubscriptionStatus = {}));
var XAppPlatform;
(function (XAppPlatform) {
    XAppPlatform["IOS"] = "IOS";
    XAppPlatform["Android"] = "Android";
    XAppPlatform["Web_STCPay"] = "Web_STCPay";
    XAppPlatform["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform["Stripe"] = "Stripe";
    XAppPlatform["Tamara"] = "Tamara";
    XAppPlatform["Web"] = "Web";
    XAppPlatform["Android_HMS"] = "Android_HMS";
})(XAppPlatform = exports.XAppPlatform || (exports.XAppPlatform = {}));
var XAppPlatform2;
(function (XAppPlatform2) {
    XAppPlatform2["IOS"] = "IOS";
    XAppPlatform2["Android"] = "Android";
    XAppPlatform2["Web_STCPay"] = "Web_STCPay";
    XAppPlatform2["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform2["Stripe"] = "Stripe";
    XAppPlatform2["Tamara"] = "Tamara";
    XAppPlatform2["Web"] = "Web";
    XAppPlatform2["Android_HMS"] = "Android_HMS";
})(XAppPlatform2 = exports.XAppPlatform2 || (exports.XAppPlatform2 = {}));
var XAppPlatform3;
(function (XAppPlatform3) {
    XAppPlatform3["IOS"] = "IOS";
    XAppPlatform3["Android"] = "Android";
    XAppPlatform3["Web_STCPay"] = "Web_STCPay";
    XAppPlatform3["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform3["Stripe"] = "Stripe";
    XAppPlatform3["Tamara"] = "Tamara";
    XAppPlatform3["Web"] = "Web";
    XAppPlatform3["Android_HMS"] = "Android_HMS";
})(XAppPlatform3 = exports.XAppPlatform3 || (exports.XAppPlatform3 = {}));
var XAppPlatform4;
(function (XAppPlatform4) {
    XAppPlatform4["IOS"] = "IOS";
    XAppPlatform4["Android"] = "Android";
    XAppPlatform4["Web_STCPay"] = "Web_STCPay";
    XAppPlatform4["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform4["Stripe"] = "Stripe";
    XAppPlatform4["Tamara"] = "Tamara";
    XAppPlatform4["Web"] = "Web";
    XAppPlatform4["Android_HMS"] = "Android_HMS";
})(XAppPlatform4 = exports.XAppPlatform4 || (exports.XAppPlatform4 = {}));
var XAppPlatform5;
(function (XAppPlatform5) {
    XAppPlatform5["IOS"] = "IOS";
    XAppPlatform5["Android"] = "Android";
    XAppPlatform5["Web_STCPay"] = "Web_STCPay";
    XAppPlatform5["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform5["Stripe"] = "Stripe";
    XAppPlatform5["Tamara"] = "Tamara";
    XAppPlatform5["Web"] = "Web";
    XAppPlatform5["Android_HMS"] = "Android_HMS";
})(XAppPlatform5 = exports.XAppPlatform5 || (exports.XAppPlatform5 = {}));
var XAppPlatform6;
(function (XAppPlatform6) {
    XAppPlatform6["IOS"] = "IOS";
    XAppPlatform6["Android"] = "Android";
    XAppPlatform6["Web_STCPay"] = "Web_STCPay";
    XAppPlatform6["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform6["Stripe"] = "Stripe";
    XAppPlatform6["Tamara"] = "Tamara";
    XAppPlatform6["Web"] = "Web";
    XAppPlatform6["Android_HMS"] = "Android_HMS";
})(XAppPlatform6 = exports.XAppPlatform6 || (exports.XAppPlatform6 = {}));
var XAppPlatform7;
(function (XAppPlatform7) {
    XAppPlatform7["IOS"] = "IOS";
    XAppPlatform7["Android"] = "Android";
    XAppPlatform7["Web_STCPay"] = "Web_STCPay";
    XAppPlatform7["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform7["Stripe"] = "Stripe";
    XAppPlatform7["Tamara"] = "Tamara";
    XAppPlatform7["Web"] = "Web";
    XAppPlatform7["Android_HMS"] = "Android_HMS";
})(XAppPlatform7 = exports.XAppPlatform7 || (exports.XAppPlatform7 = {}));
var XAppPlatform8;
(function (XAppPlatform8) {
    XAppPlatform8["IOS"] = "IOS";
    XAppPlatform8["Android"] = "Android";
    XAppPlatform8["Web_STCPay"] = "Web_STCPay";
    XAppPlatform8["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform8["Stripe"] = "Stripe";
    XAppPlatform8["Tamara"] = "Tamara";
    XAppPlatform8["Web"] = "Web";
    XAppPlatform8["Android_HMS"] = "Android_HMS";
})(XAppPlatform8 = exports.XAppPlatform8 || (exports.XAppPlatform8 = {}));
var XAppPlatform9;
(function (XAppPlatform9) {
    XAppPlatform9["IOS"] = "IOS";
    XAppPlatform9["Android"] = "Android";
    XAppPlatform9["Web_STCPay"] = "Web_STCPay";
    XAppPlatform9["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform9["Stripe"] = "Stripe";
    XAppPlatform9["Tamara"] = "Tamara";
    XAppPlatform9["Web"] = "Web";
    XAppPlatform9["Android_HMS"] = "Android_HMS";
})(XAppPlatform9 = exports.XAppPlatform9 || (exports.XAppPlatform9 = {}));
var XAppPlatform10;
(function (XAppPlatform10) {
    XAppPlatform10["IOS"] = "IOS";
    XAppPlatform10["Android"] = "Android";
    XAppPlatform10["Web_STCPay"] = "Web_STCPay";
    XAppPlatform10["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform10["Stripe"] = "Stripe";
    XAppPlatform10["Tamara"] = "Tamara";
    XAppPlatform10["Web"] = "Web";
    XAppPlatform10["Android_HMS"] = "Android_HMS";
})(XAppPlatform10 = exports.XAppPlatform10 || (exports.XAppPlatform10 = {}));
var XAppPlatform11;
(function (XAppPlatform11) {
    XAppPlatform11["IOS"] = "IOS";
    XAppPlatform11["Android"] = "Android";
    XAppPlatform11["Web_STCPay"] = "Web_STCPay";
    XAppPlatform11["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform11["Stripe"] = "Stripe";
    XAppPlatform11["Tamara"] = "Tamara";
    XAppPlatform11["Web"] = "Web";
    XAppPlatform11["Android_HMS"] = "Android_HMS";
})(XAppPlatform11 = exports.XAppPlatform11 || (exports.XAppPlatform11 = {}));
var XAppPlatform12;
(function (XAppPlatform12) {
    XAppPlatform12["IOS"] = "IOS";
    XAppPlatform12["Android"] = "Android";
    XAppPlatform12["Web_STCPay"] = "Web_STCPay";
    XAppPlatform12["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform12["Stripe"] = "Stripe";
    XAppPlatform12["Tamara"] = "Tamara";
    XAppPlatform12["Web"] = "Web";
    XAppPlatform12["Android_HMS"] = "Android_HMS";
})(XAppPlatform12 = exports.XAppPlatform12 || (exports.XAppPlatform12 = {}));
var XAppPlatform13;
(function (XAppPlatform13) {
    XAppPlatform13["IOS"] = "IOS";
    XAppPlatform13["Android"] = "Android";
    XAppPlatform13["Web_STCPay"] = "Web_STCPay";
    XAppPlatform13["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform13["Stripe"] = "Stripe";
    XAppPlatform13["Tamara"] = "Tamara";
    XAppPlatform13["Web"] = "Web";
    XAppPlatform13["Android_HMS"] = "Android_HMS";
})(XAppPlatform13 = exports.XAppPlatform13 || (exports.XAppPlatform13 = {}));
var XAppPlatform14;
(function (XAppPlatform14) {
    XAppPlatform14["IOS"] = "IOS";
    XAppPlatform14["Android"] = "Android";
    XAppPlatform14["Web_STCPay"] = "Web_STCPay";
    XAppPlatform14["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform14["Stripe"] = "Stripe";
    XAppPlatform14["Tamara"] = "Tamara";
    XAppPlatform14["Web"] = "Web";
    XAppPlatform14["Android_HMS"] = "Android_HMS";
})(XAppPlatform14 = exports.XAppPlatform14 || (exports.XAppPlatform14 = {}));
var XAppPlatform15;
(function (XAppPlatform15) {
    XAppPlatform15["IOS"] = "IOS";
    XAppPlatform15["Android"] = "Android";
    XAppPlatform15["Web_STCPay"] = "Web_STCPay";
    XAppPlatform15["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform15["Stripe"] = "Stripe";
    XAppPlatform15["Tamara"] = "Tamara";
    XAppPlatform15["Web"] = "Web";
    XAppPlatform15["Android_HMS"] = "Android_HMS";
})(XAppPlatform15 = exports.XAppPlatform15 || (exports.XAppPlatform15 = {}));
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            var ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            var id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map(function (v, i) { return recurse(v, i, obj); });
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (var i = 0; i < refs.length; i++) {
        var ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    var mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    var result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
